import React, { useContext, useState, useEffect, forwardRef, useRef, Fragment, useCallback } from 'react';
import { createBrowserHistory } from 'history';
import localforage from 'localforage';
import decodeJwtToken from 'jwt-decode';
import gql from 'graphql-tag';
import { ApolloClient, InMemoryCache, HttpLink, useMutation, useQuery, ApolloProvider } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';
import { createUploadLink } from 'apollo-upload-client';
import 'dot-prop-immutable';
import { motion, AnimatePresence } from 'framer-motion';
import { Trans, useLingui, I18nProvider } from '@lingui/react';
import clsx from 'clsx';
import { Route, Link, useHistory, useLocation, useRouteMatch, useParams, Router, Switch } from 'react-router-dom';
import { PERMISSION_READ_PRODUCTS, PERMISSION_WRITE_PRODUCTS, PERMISSION_READ_ORDERS, PERMISSION_READ_USERS, PERMISSION_WRITE_USERS, PERMISSION_WRITE_ROLES, PERMISSION_READ_CUSTOMERS, PERMISSION_READ_SETTINGS, PERMISSION_WRITE_SETTINGS, PERMISSION_UPLOAD_FILES, ADMIN_USER_STATUS_ACTIVE, ADMIN_USER_STATUS_CREATED, ADMIN_USER_STATUS_INVITED, LANGUAGE_DE, LANGUAGE_FR, LANGUAGE_EN, LANGUAGE_NL, CURRENCY_UNIT_USD, CURRENCY_UNIT_EUR, ORDER_STATUS_PAID, FILE_TYPE_PRODUCT_IMAGE } from '@toway/constants';
import { isValidEmail, isRequired, formatDate, priceHelper, isGreaterOrEqualThan, ORDER_STATUS_CREATED, ORDER_STATUS_PAID as ORDER_STATUS_PAID$1, whereValue, VAT_REGEX_STRINGS, slugify, whereId, whereIsNotId, formatTime } from '@toway/utils';
import useFormState, { createFormValidation } from 'use-form-state';
import { i18n } from '@lingui/core';
import { parse, stringify } from 'query-string';
import { createPortal } from 'react-dom';
import { usePopper } from 'react-popper';
import Dialog from '@reach/dialog';
import { useInView } from 'react-intersection-observer';
import { useDropzone } from 'react-dropzone';
import RcTree from 'rc-tree';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var ACCESS_TOKEN_KEY = 'accessToken';
var REFRESH_TOKEN_KEY = 'refreshToken';

// In memory cache
var accessToken = null;
var refreshToken = null;
var getAccessToken = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(accessToken === null)) {
            _context2.next = 4;
            break;
          }
          _context2.next = 3;
          return localforage.getItem(ACCESS_TOKEN_KEY);
        case 3:
          accessToken = _context2.sent;
        case 4:
          return _context2.abrupt("return", accessToken);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getAccessToken() {
    return _ref2.apply(this, arguments);
  };
}();
var setAccessToken = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(newAccessToken) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return localforage.setItem(ACCESS_TOKEN_KEY, newAccessToken);
        case 2:
          accessToken = newAccessToken;
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function setAccessToken(_x) {
    return _ref3.apply(this, arguments);
  };
}();
var removeAccessToken = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return localforage.removeItem(ACCESS_TOKEN_KEY);
        case 2:
          accessToken = null;
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function removeAccessToken() {
    return _ref4.apply(this, arguments);
  };
}();
var getRefreshToken = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          if (!(refreshToken === null)) {
            _context5.next = 4;
            break;
          }
          _context5.next = 3;
          return localforage.getItem(REFRESH_TOKEN_KEY);
        case 3:
          refreshToken = _context5.sent;
        case 4:
          return _context5.abrupt("return", refreshToken);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function getRefreshToken() {
    return _ref5.apply(this, arguments);
  };
}();
var setRefreshToken = function setRefreshToken(newRefreshToken) {
  refreshToken = newRefreshToken;
  return localforage.setItem(REFRESH_TOKEN_KEY, newRefreshToken);
};
var removeRefreshToken = function removeRefreshToken() {
  refreshToken = null;
  return localforage.removeItem(REFRESH_TOKEN_KEY);
};

var connectionToCollection = function connectionToCollection() {
  var connection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    edges: []
  };
  return connection.edges.map(function (edge) {
    return edge.node;
  });
};
var mergeQueryResults = function mergeQueryResults(previousResult, fetchMoreResult, path) {
  var _fetchMoreResult$path = fetchMoreResult[path],
    newEdges = _fetchMoreResult$path.edges,
    totalCount = _fetchMoreResult$path.totalCount,
    pageInfo = _fetchMoreResult$path.pageInfo;
  return newEdges.length ? _defineProperty({}, path, {
    // eslint-disable-next-line no-underscore-dangle
    __typename: previousResult[path].__typename,
    edges: [].concat(_toConsumableArray(previousResult[path].edges), _toConsumableArray(newEdges)),
    pageInfo: pageInfo,
    totalCount: totalCount
  }) : previousResult;
};
var isUnauthenticatedError = function isUnauthenticatedError(error) {
  return error.extensions.code === 'UNAUTHENTICATED';
};
var getTranslatedValues = function getTranslatedValues(_ref2, language) {
  var translations = _ref2.translations;
  return Object.keys(translations).reduce(function (result, key) {
    return _objectSpread2(_objectSpread2({}, result), {}, _defineProperty({}, key, translations[key] && translations[key][language]));
  }, {});
};
var setTranslatedValues = function setTranslatedValues(values, language) {
  return Object.keys(values).reduce(function (result, key) {
    return _objectSpread2(_objectSpread2({}, result), {}, _defineProperty({}, key, _defineProperty({}, language, values[key])));
  }, {});
};
var mapCategoriesToTreeData = function mapCategoriesToTreeData() {
  var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return categories.map(function (_ref3) {
    var id = _ref3.id,
      name = _ref3.name;
    return {
      title: name,
      key: id
    };
  });
};

var createUnauthorizedApolloClient = function createUnauthorizedApolloClient() {
  return new ApolloClient({
    cache: new InMemoryCache(),
    link: new HttpLink({
      uri: process.env.REACT_APP_GRAPHQL_URI
    })
  });
};
function createApolloClient() {
  var REACT_APP_GRAPHQL_URI = process.env.REACT_APP_GRAPHQL_URI;
  var setAuthContext = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(request, _ref) {
      var headers, adminHeaders, accessToken;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            headers = _ref.headers;
            adminHeaders = _objectSpread2({}, headers);
            _context.next = 4;
            return getAccessToken();
          case 4:
            accessToken = _context.sent;
            if (!(accessToken === null)) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return", {
              headers: adminHeaders
            });
          case 7:
            return _context.abrupt("return", {
              headers: _objectSpread2(_objectSpread2({}, adminHeaders), {}, {
                authorization: "Bearer ".concat(accessToken)
              })
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function setAuthContext(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var removeJwtTokenFromCacheLink = onError(function (error) {
    var graphQLErrors = error.graphQLErrors;
    if (typeof graphQLErrors !== 'undefined' && graphQLErrors.length > 0) {
      graphQLErrors.map(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(graphQLError) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (isUnauthenticatedError(graphQLError)) {
                  removeAccessToken();
                  removeRefreshToken();
                }
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
    // eslint-disable-next-line no-console
    console.log({
      error: error
    });
  });
  var uploadLink = createUploadLink({
    uri: REACT_APP_GRAPHQL_URI
  });
  var setAuthorizationHeadersLink = setContext(setAuthContext);
  var linkFlow = setAuthorizationHeadersLink.concat(removeJwtTokenFromCacheLink.concat(uploadLink));
  return new ApolloClient({
    link: linkFlow,
    cache: new InMemoryCache()
  });
}

var _templateObject$G;
var REFRESH_ACCESS_TOKEN_MUTATION = gql(_templateObject$G || (_templateObject$G = _taggedTemplateLiteral(["\n    mutation refreshAccessToken($refreshToken: String!) {\n        refreshAccessToken(refreshToken: $refreshToken)\n    }\n"])));
function refreshAccessToken(_x) {
  return _refreshAccessToken.apply(this, arguments);
}
function _refreshAccessToken() {
  _refreshAccessToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(refreshToken) {
    var apolloClient, mutation, variables, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apolloClient = createUnauthorizedApolloClient();
          mutation = REFRESH_ACCESS_TOKEN_MUTATION;
          variables = {
            refreshToken: refreshToken
          };
          _context.prev = 3;
          _context.next = 6;
          return apolloClient.mutate({
            mutation: mutation,
            variables: variables
          });
        case 6:
          response = _context.sent;
          return _context.abrupt("return", response.data.refreshAccessToken);
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](3);
          // eslint-disable-next-line no-console
          console.error('Failed to refresh access token.');
          return _context.abrupt("return", null);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 10]]);
  }));
  return _refreshAccessToken.apply(this, arguments);
}

var isTokenExpired = function isTokenExpired(token) {
  var decodedToken = decodeJwtToken(token);
  var tokenExpiresAt = decodedToken.exp;
  return tokenExpiresAt < new Date().getTime();
};
var loadAndValidateTokens = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var accessToken, refreshToken, tokensAreSet;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return getAccessToken();
        case 2:
          accessToken = _context.sent;
          _context.next = 5;
          return getRefreshToken();
        case 5:
          refreshToken = _context.sent;
          tokensAreSet = accessToken !== null && refreshToken !== null;
          if (!tokensAreSet) {
            _context.next = 24;
            break;
          }
          if (!isTokenExpired(refreshToken)) {
            _context.next = 17;
            break;
          }
          _context.next = 11;
          return removeAccessToken();
        case 11:
          _context.next = 13;
          return removeRefreshToken();
        case 13:
          accessToken = null;
          refreshToken = null;
          _context.next = 24;
          break;
        case 17:
          if (!isTokenExpired(accessToken)) {
            _context.next = 24;
            break;
          }
          _context.next = 20;
          return refreshAccessToken(refreshToken);
        case 20:
          accessToken = _context.sent;
          if (!(accessToken !== null)) {
            _context.next = 24;
            break;
          }
          _context.next = 24;
          return setAccessToken(accessToken);
        case 24:
          return _context.abrupt("return", {
            refreshToken: refreshToken,
            accessToken: accessToken
          });
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function loadAndValidateTokens() {
    return _ref.apply(this, arguments);
  };
}();

var _excluded$u = ["dispatcher"];
var NotificationsContext = /*#__PURE__*/React.createContext();
var NotificationsProvider = function NotificationsProvider(_ref) {
  var dispatcher = _ref.dispatcher,
    props = _objectWithoutProperties(_ref, _excluded$u);
  return /*#__PURE__*/React.createElement(NotificationsContext.Provider, _extends({
    value: dispatcher
  }, props));
};

var NOTIFICATION_TYPE_ERROR = 'ERROR';
var NOTIFICATION_TYPE_SUCCESS = 'SUCCESS';
var NOTIFICATION_TYPE_WARNING = 'WARNING';
var SETTINGS_TAB_GENERAL = 'general';
var SETTINGS_TAB_SHIPPING = 'shipping';
var SETTINGS_TAB_THEME = 'theme';
var USERS_TAB_ACTIVE = 'active';
var USERS_TAB_PENDING_INVITATIONS = 'pending-invitations';
var PRODUCTS_TAB_ALL = 'all-products';

var ERROR$1 = NOTIFICATION_TYPE_ERROR,
  SUCCESS$1 = NOTIFICATION_TYPE_SUCCESS,
  WARNING$1 = NOTIFICATION_TYPE_WARNING;
var useNotifications = function useNotifications() {
  var notificationDispatcher = useContext(NotificationsContext);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    notifications = _useState2[0],
    setNotifications = _useState2[1];
  useEffect(function () {
    return notificationDispatcher.subscribe(function (newNotifications) {
      setNotifications(newNotifications);
    });
  }, [notificationDispatcher]);
  var dispatchSuccess = function dispatchSuccess(data) {
    return notificationDispatcher.dispatch(_objectSpread2({
      type: SUCCESS$1,
      title: /*#__PURE__*/React.createElement(Trans, {
        id: "Success"
      }),
      message: /*#__PURE__*/React.createElement(Trans, {
        id: "Your request was handled successfully."
      })
    }, data));
  };
  var dispatchError = function dispatchError() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return notificationDispatcher.dispatch(_objectSpread2({
      type: ERROR$1,
      title: /*#__PURE__*/React.createElement(Trans, {
        id: "Error"
      }),
      message: /*#__PURE__*/React.createElement(Trans, {
        id: "Oops, looks like something went wrong, please try again later."
      })
    }, data));
  };
  var dispatchGraphqlError = function dispatchGraphqlError(error, data) {
    var message = /*#__PURE__*/React.createElement(Trans, {
      id: "Oops, looks like something went wrong, please try again later."
    });
    if (error.networkError) {
      message = error.networkError.result.errors[0].message;
    }
    if (error.graphQLErrors.length > 0) {
      message = error.graphQLErrors[0].message;
    }
    return notificationDispatcher.dispatch(_objectSpread2({
      type: ERROR$1,
      title: /*#__PURE__*/React.createElement(Trans, {
        id: "Error"
      }),
      message: message
    }, data));
  };
  var dispatchWarning = function dispatchWarning(data) {
    return notificationDispatcher.dispatch(_objectSpread2({
      type: WARNING$1,
      title: /*#__PURE__*/React.createElement(Trans, {
        id: "Warning"
      }),
      message: /*#__PURE__*/React.createElement(Trans, {
        id: "Careful a warning was triggered."
      })
    }, data));
  };
  var removeNotification = function removeNotification(notification) {
    notificationDispatcher.removeNotification(notification);
  };
  return {
    notifications: notifications,
    dispatchError: dispatchError,
    dispatchWarning: dispatchWarning,
    dispatchSuccess: dispatchSuccess,
    dispatchGraphqlError: dispatchGraphqlError,
    dispatch: function dispatch(data) {
      return notificationDispatcher.dispatch(data);
    },
    removeNotification: removeNotification
  };
};

var _excluded$t = ["name", "color", "size", "stroke", "className"];
var Dashboard = function Dashboard() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M16 21l-1-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 21l1-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.925 17H5.075A2.075 2.075 0 0 1 3 14.925v-9.85C3 3.929 3.929 3 5.075 3h13.849C20.071 3 21 3.929 21 5.075v9.849A2.075 2.075 0 0 1 18.925 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13v-2.727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13V7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13V9.675"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13V7.546"
  }));
};
var User = function User() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M5.77778 20.7777C5.77778 18.2777 7.77778 16.3777 10.1778 16.3777H15.2778C17.7778 16.3777 19.6778 18.3777 19.6778 20.7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7778 5.97777C17.4778 7.67777 17.4778 10.3778 15.7778 11.9778C14.0778 13.5778 11.3778 13.6778 9.77778 11.9778C8.17778 10.2778 8.07778 7.57777 9.77778 5.97777C11.4778 4.37777 14.0778 4.37777 15.7778 5.97777"
  }));
};
var Users = function Users() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M20.793 9.52399C20.9864 9.7106 21.1406 9.93386 21.2467 10.1807C21.3527 10.4276 21.4086 10.6931 21.4109 10.9618C21.4133 11.2305 21.3621 11.497 21.2603 11.7456C21.1586 11.9943 21.0083 12.2202 20.8182 12.4102C20.6282 12.6002 20.4022 12.7504 20.1535 12.852C19.9048 12.9537 19.6383 13.0048 19.3696 13.0024C19.101 13 18.8354 12.944 18.5886 12.8378C18.3418 12.7317 18.1186 12.5774 17.932 12.384C17.5688 12.0015 17.3693 11.4922 17.3761 10.9648C17.383 10.4374 17.5955 9.93344 17.9685 9.56045C18.3415 9.18746 18.8454 8.97491 19.3729 8.96809C19.9003 8.96128 20.4095 9.16075 20.792 9.52399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.203 5.91199C14.7873 6.49627 15.1155 7.28871 15.1155 8.11499C15.1155 8.94128 14.7873 9.73372 14.203 10.318C13.6188 10.9023 12.8263 11.2305 12 11.2305C11.1737 11.2305 10.3813 10.9023 9.79703 10.318C9.21276 9.73372 8.88452 8.94128 8.88452 8.11499C8.88452 7.70586 8.96511 7.30073 9.12168 6.92274C9.27825 6.54475 9.50773 6.2013 9.79703 5.91199C10.0863 5.62269 10.4298 5.3932 10.8078 5.23664C11.1858 5.08007 11.5909 4.99948 12 4.99948C12.8263 4.99948 13.6188 5.32772 14.203 5.91199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.06804 9.52399C6.26387 9.70995 6.42048 9.93325 6.52864 10.1807C6.6368 10.4282 6.69432 10.6948 6.69781 10.9648C6.7013 11.2348 6.65068 11.5028 6.54895 11.753C6.44721 12.0032 6.29642 12.2304 6.10545 12.4214C5.91449 12.6124 5.68723 12.7632 5.43706 12.8649C5.1869 12.9666 4.91889 13.0172 4.64886 13.0138C4.37882 13.0103 4.11221 12.9528 3.86476 12.8446C3.6173 12.7364 3.39401 12.5798 3.20804 12.384C2.84481 12.0015 2.64534 11.4922 2.65215 10.9648C2.65896 10.4374 2.87151 9.93344 3.2445 9.56045C3.61749 9.18746 4.12141 8.97491 4.64886 8.96809C5.1763 8.96128 5.68554 9.16075 6.06804 9.52399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 19V17.904C23 17.2409 22.7366 16.6051 22.2677 16.1362C21.7989 15.6674 21.163 15.404 20.5 15.404H19.699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 19V17.904C1 17.2409 1.26339 16.6051 1.73223 16.1362C2.20107 15.6674 2.83696 15.404 3.5 15.404H4.301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.339 19V17.399C17.339 16.9394 17.2485 16.4842 17.0726 16.0596C16.8967 15.635 16.6389 15.2491 16.3139 14.9241C15.9889 14.5991 15.6031 14.3413 15.1784 14.1654C14.7538 13.9895 14.2987 13.899 13.839 13.899H10.16C9.23178 13.899 8.34154 14.2677 7.68516 14.9241C7.02878 15.5805 6.66003 16.4707 6.66003 17.399V19"
  }));
};
var Order = function Order() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M18 22a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 21H5a2 2 0 0 1-2-2V8.5A1.5 1.5 0 0 1 4.5 7h13A1.5 1.5 0 0 1 19 8.5V11"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "10.55",
    r: ".25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "10.55",
    r: ".25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6.75A3.75 3.75 0 0 1 10.75 3h.5A3.75 3.75 0 0 1 15 6.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6.75V7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.556 17.222l-1.945 1.945L16.444 18"
  }));
};
var Product = function Product() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M20.926 15.999V8.001c0-.715-.381-1.375-1-1.732L13 2.27a2.001 2.001 0 0 0-2 0L4.074 6.269a2 2 0 0 0-1 1.732v7.997c0 .715.381 1.375 1 1.732l6.926 4a2.001 2.001 0 0 0 2 0l6.926-3.999a2 2 0 0 0 1-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17 12.63l3 1.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.342 7.001L12 12l8.658-4.999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22V12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67 9.5l8.93-5.15"
  }));
};
var Settings = function Settings() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M3.9 15.647l1.398.214a2 2 0 0 1 1.693 2.123l-.103 1.411c-.03.411.194.798.565.977l1.034.498c.371.179.814.112 1.117-.167l1.039-.96a2 2 0 0 1 2.715 0l1.039.96c.303.28.745.346 1.117.167l1.036-.499a1 1 0 0 0 .563-.974l-.103-1.413a2 2 0 0 1 1.693-2.123l1.398-.214c.407-.062.735-.367.827-.769l.255-1.118a1.001 1.001 0 0 0-.411-1.051l-1.167-.799a2 2 0 0 1-.604-2.647l.705-1.226a1.004 1.004 0 0 0-.086-1.126l-.715-.897a1.004 1.004 0 0 0-1.079-.334l-1.352.414a2.001 2.001 0 0 1-2.448-1.178l-.518-1.313a1.004 1.004 0 0 0-.936-.635l-1.146.003a1.004 1.004 0 0 0-.933.64l-.505 1.298a2 2 0 0 1-2.452 1.186l-1.408-.432a1.004 1.004 0 0 0-1.082.336l-.71.898a1.003 1.003 0 0 0-.079 1.13l.721 1.229a2 2 0 0 1-.595 2.662l-1.153.79c-.34.233-.503.65-.411 1.051l.255 1.118c.091.403.419.708.826.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.916 10.084a2.71 2.71 0 1 1-3.833 3.832 2.71 2.71 0 0 1 3.833-3.832"
  }));
};
var WarningCircle = function WarningCircle() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12 12V7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999 15.5a.25.25 0 1 0 .251.25.25.25 0 0 0-.251-.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14.381V9.619A4.5 4.5 0 0 1 5.236 5.73l4.5-2.619a4.501 4.501 0 0 1 4.527 0l4.5 2.619A4.5 4.5 0 0 1 21 9.619v4.762a4.5 4.5 0 0 1-2.236 3.889l-4.5 2.619a4.501 4.501 0 0 1-4.527 0l-4.5-2.619A4.5 4.5 0 0 1 3 14.381z"
  }));
};
var CheckCircle = function CheckCircle() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12 21C9.61305 21 7.32387 20.0518 5.63604 18.364C3.94821 16.6761 3 14.3869 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21V21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10L11 15L8 12"
  }));
};
var Cross = function Cross() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M6 6L18 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6L6 18"
  }));
};
var MenuDots = function MenuDots() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M11.625 12.001C11.6254 12.0751 11.6477 12.1474 11.6892 12.2088C11.7306 12.2702 11.7893 12.3179 11.8579 12.346C11.9264 12.3741 12.0018 12.3812 12.0744 12.3665C12.147 12.3519 12.2136 12.316 12.2659 12.2635C12.3181 12.2109 12.3536 12.1441 12.3679 12.0714C12.3822 11.9987 12.3747 11.9234 12.3463 11.855C12.3178 11.7866 12.2698 11.7282 12.2081 11.6871C12.1465 11.6459 12.0741 11.624 12 11.624C11.9004 11.6245 11.805 11.6645 11.7347 11.7351C11.6644 11.8058 11.625 11.9014 11.625 12.001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.625 6.001C11.6254 6.07508 11.6477 6.14739 11.6892 6.20879C11.7306 6.2702 11.7893 6.31795 11.8579 6.34603C11.9264 6.3741 12.0018 6.38124 12.0744 6.36655C12.147 6.35185 12.2136 6.31598 12.2659 6.26346C12.3181 6.21094 12.3536 6.14411 12.3679 6.07143C12.3822 5.99874 12.3747 5.92344 12.3463 5.85504C12.3178 5.78663 12.2698 5.72818 12.2081 5.68706C12.1465 5.64594 12.0741 5.624 12 5.624C11.9004 5.62453 11.805 5.66448 11.7347 5.73513C11.6644 5.80577 11.625 5.90136 11.625 6.001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.625 18.001C11.6254 18.0751 11.6477 18.1474 11.6892 18.2088C11.7306 18.2702 11.7893 18.3179 11.8579 18.346C11.9264 18.3741 12.0018 18.3812 12.0744 18.3665C12.147 18.3519 12.2136 18.316 12.2659 18.2635C12.3181 18.2109 12.3536 18.1441 12.3679 18.0714C12.3822 17.9987 12.3747 17.9234 12.3463 17.855C12.3178 17.7866 12.2698 17.7282 12.2081 17.6871C12.1465 17.6459 12.0741 17.624 12 17.624C11.9004 17.6245 11.805 17.6645 11.7347 17.7351C11.6644 17.8058 11.625 17.9014 11.625 18.001"
  }));
};
var Edit = function Edit() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M17.54 10.12L13.88 6.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.251 21H3V17.749C3 17.484 3.105 17.229 3.293 17.042L16.627 3.707C16.7198 3.61405 16.83 3.54032 16.9513 3.49001C17.0726 3.4397 17.2027 3.4138 17.334 3.4138C17.4653 3.4138 17.5954 3.4397 17.7167 3.49001C17.838 3.54032 17.9482 3.61405 18.041 3.707L20.292 5.958C20.3849 6.05079 20.4587 6.16099 20.509 6.28231C20.5593 6.40362 20.5852 6.53367 20.5852 6.665C20.5852 6.79633 20.5593 6.92638 20.509 7.04769C20.4587 7.16901 20.3849 7.27921 20.292 7.372L6.958 20.707C6.86526 20.8 6.75506 20.8738 6.63373 20.924C6.5124 20.9743 6.38234 21.0001 6.251 21V21Z"
  }));
};
var Email = function Email() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M19 18.981H5C4.46957 18.981 3.96086 18.7703 3.58579 18.3952C3.21071 18.0201 3 17.5114 3 16.981V7.019C3 6.48857 3.21071 5.97986 3.58579 5.60479C3.96086 5.22971 4.46957 5.019 5 5.019H19C19.5304 5.019 20.0391 5.22971 20.4142 5.60479C20.7893 5.97986 21 6.48857 21 7.019V16.982C20.9997 17.5123 20.7889 18.0207 20.4139 18.3956C20.0388 18.7704 19.5303 18.981 19 18.981V18.981Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9L12 12L7 9"
  }));
};
var SendEmail = function SendEmail() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M3 7H2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4H2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.438 16H6.85003C6.47583 16.0001 6.1068 15.9126 5.77242 15.7446C5.43803 15.5767 5.14756 15.3328 4.92419 15.0326C4.70082 14.7324 4.55075 14.3841 4.48596 14.0155C4.42116 13.647 4.44345 13.2684 4.55103 12.91L6.71103 5.71C6.85942 5.21566 7.16322 4.78232 7.57736 4.47429C7.99149 4.16625 8.4939 3.99993 9.01003 4H19.599C19.9732 3.99995 20.3423 4.0874 20.6767 4.25537C21.011 4.42334 21.3015 4.66717 21.5249 4.96739C21.7482 5.26761 21.8983 5.6159 21.9631 5.98445C22.0279 6.353 22.0056 6.7316 21.898 7.09L19.738 14.29C19.5893 14.7843 19.2853 15.2176 18.871 15.5256C18.4567 15.8336 17.9543 16 17.438 16V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.74304 14.721L11.697 10.085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.21 10.053L19.282 15.125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20H3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.198 4.836L12.001 10.44C12.1576 10.6228 12.3749 10.7429 12.613 10.7783C12.851 10.8138 13.0939 10.7622 13.297 10.633L21.709 5.285"
  }));
};
var Paperclip = function Paperclip() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z"
  }));
};
var Spinner$1 = function Spinner() {
  return /*#__PURE__*/React.createElement("path", {
    d: "M12 6V3M16.5 4.206l-1.502 2.602M17.192 9.002L19.794 7.5M21 12h-3M6 12H3M4.206 7.5l2.602 1.502M7.5 4.206l1.502 2.602M12 21v-3M9.002 17.192L7.5 19.794M6.808 14.998L4.206 16.5M17.192 14.998l2.602 1.502M14.998 17.192l1.502 2.602"
  });
};
var Bin = function Bin() {
  return /*#__PURE__*/React.createElement("path", {
    d: "M16.138 21h-8.28a2 2 0 01-1.995-1.853L4.966 7H19l-.867 12.142A2 2 0 0116.138 21v0zM12 11v6M4 7h16M17 7l-1.013-2.702A2 2 0 0014.114 3H9.886a2 2 0 00-1.873 1.298L7 7M15.429 11L15 17M8.571 11L9 17"
  });
};
var DeliveryTruck = function DeliveryTruck() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M18.704 18.296a1.583 1.583 0 1 1-2.24 2.24 1.583 1.583 0 1 1 2.24-2.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.704 18.296a1.583 1.583 0 1 1-2.238 2.24 1.583 1.583 0 0 1 2.238-2.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4h4a1 1 0 0 1 1 1v10H2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19.416H3a1 1 0 0 1-1-1V13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7h4.323c.409 0 .777.249.928.629l1.606 4.014c.094.236.143.488.143.742v5.948a1 1 0 0 1-1 1h-1.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19.42H8.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 14h-4v-4h3.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 7h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10H2"
  }));
};
var Trash = function Trash() {
  return /*#__PURE__*/React.createElement("path", {
    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
  });
};
var PlusCircle = function PlusCircle() {
  return /*#__PURE__*/React.createElement("path", {
    d: "M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
  });
};
var Image = function Image() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M18.353 19.615H5.693a2 2 0 01-2-2v-11a2 2 0 012-2h12.66a2 2 0 012 2v11a2 2 0 01-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69 11.282a1.667 1.667 0 100-3.334 1.667 1.667 0 000 3.334zM20.353 15.446L16.97 12.74a1 1 0 00-1.406.156l-2.572 3.215a1 1 0 01-1.406.156l-1.299-1.039a1 1 0 00-1.393.141l-3.513 4.216"
  }));
};
var Logout = function Logout() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M3 12h11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9l3 3-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9.137V7.4a2 2 0 0 1 1.608-1.96l11-2.406A2.146 2.146 0 0 1 21 5.2V19a2 2 0 0 1-2.339 1.972l-11-1.892A2 2 0 0 1 6 17.108v-2.137"
  }));
};
var ChevronUpDown = function ChevronUpDown() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M16 9L12 5L8 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15L12 19L16 15"
  }));
};
var ChevronDown = function ChevronDown() {
  return /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.5L11.5 14.5L16.5 9.5"
  });
};
var Power = function Power() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M18.36 6.64a9 9 0 1 1-12.73 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "12",
    y1: "2",
    x2: "12",
    y2: "12"
  }));
};
var Globe = function Globe() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.1C16.667 8.027 16.667 15.973 12 20.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20.9C7.33301 15.973 7.33301 8.027 12 3.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3C16.982 3 21 7.018 21 12C21 16.982 16.982 21 12 21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21C7.018 21 3 16.982 3 12C3 7.018 7.018 3 12 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51001 9H20.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51001 15H20.49"
  }));
};
var View = function View() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }));
};
var Plus = function Plus() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M18 11.5H7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17V6"
  }));
};
var Drag = function Drag() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M7 16.1429H16.5",
    stroke: "#9CA3AF",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12.0714H16.5",
    stroke: "#9CA3AF",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8H16.5",
    stroke: "#9CA3AF",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var getStrokeWidth = function getStrokeWidth(stroke, size) {
  if (stroke !== 'default') {
    return '';
  }
  if (size === 'small') {
    return 2;
  }
  return 1.75;
};
var Icon = function Icon(_ref) {
  var name = _ref.name,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'default' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    _ref$stroke = _ref.stroke,
    stroke = _ref$stroke === void 0 ? 'default' : _ref$stroke,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$t);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: getStrokeWidth(stroke, size),
    viewBox: "0 0 24 24",
    className: clsx(size === 'largest' && 'h-12 w-12',
    // 48px
    size === 'larger' && 'h-10 w-10',
    // 40px
    size === 'large' && 'h-8 w-8',
    // 32px
    size === 'default' && 'h-6 w-6',
    // 24px
    size === 'small' && 'h-5 w-5',
    // 20px
    color === 'default' && 'text-gray-400', className)
  }, props), function () {
    switch (name) {
      case 'dashboard':
        return /*#__PURE__*/React.createElement(Dashboard, null);
      case 'user':
        return /*#__PURE__*/React.createElement(User, null);
      case 'users':
        return /*#__PURE__*/React.createElement(Users, null);
      case 'order':
        return /*#__PURE__*/React.createElement(Order, null);
      case 'product':
        return /*#__PURE__*/React.createElement(Product, null);
      case 'warning-circle':
        return /*#__PURE__*/React.createElement(WarningCircle, null);
      case 'check-circle':
        return /*#__PURE__*/React.createElement(CheckCircle, null);
      case 'settings':
        return /*#__PURE__*/React.createElement(Settings, null);
      case 'cross':
        return /*#__PURE__*/React.createElement(Cross, null);
      case 'menu-dots':
        return /*#__PURE__*/React.createElement(MenuDots, null);
      case 'edit':
        return /*#__PURE__*/React.createElement(Edit, null);
      case 'email':
        return /*#__PURE__*/React.createElement(Email, null);
      case 'send-email':
        return /*#__PURE__*/React.createElement(SendEmail, null);
      case 'paperclip':
        return /*#__PURE__*/React.createElement(Paperclip, null);
      case 'spinner':
        return /*#__PURE__*/React.createElement(Spinner$1, null);
      case 'bin':
        return /*#__PURE__*/React.createElement(Bin, null);
      case 'delivery-truck':
        return /*#__PURE__*/React.createElement(DeliveryTruck, null);
      case 'trash':
        return /*#__PURE__*/React.createElement(Trash, null);
      case 'plus-circle':
        return /*#__PURE__*/React.createElement(PlusCircle, null);
      case 'image':
        return /*#__PURE__*/React.createElement(Image, null);
      case 'logout':
        return /*#__PURE__*/React.createElement(Logout, null);
      case 'chevron-up-down':
        return /*#__PURE__*/React.createElement(ChevronUpDown, null);
      case 'chevron-down':
        return /*#__PURE__*/React.createElement(ChevronDown, null);
      case 'power':
        return /*#__PURE__*/React.createElement(Power, null);
      case 'globe':
        return /*#__PURE__*/React.createElement(Globe, null);
      case 'view':
        return /*#__PURE__*/React.createElement(View, null);
      case 'plus':
        return /*#__PURE__*/React.createElement(Plus, null);
      case 'drag':
        return /*#__PURE__*/React.createElement(Drag, null);
      default:
        return null;
    }
  }());
};

var getIconName$1 = function getIconName(type) {
  if (type === NOTIFICATION_TYPE_ERROR) {
    return 'warning-circle';
  }
  if (type === NOTIFICATION_TYPE_WARNING) {
    return 'warning-circle';
  }
  return 'check-circle';
};
var Notification = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? NOTIFICATION_TYPE_SUCCESS : _ref$type,
    title = _ref.title,
    message = _ref.message,
    onDismiss = _ref.onDismiss;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: "max-w-sm w-full mb-4 bg-white shadow-lg rounded-lg pointer-events-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-lg ring-1 ring-black ring-opacity-5 overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: getIconName$1(type),
    className: clsx(type === NOTIFICATION_TYPE_SUCCESS && 'text-green-400', type === NOTIFICATION_TYPE_ERROR && 'text-red-600', type === NOTIFICATION_TYPE_WARNING && 'text-yellow-300')
  })), /*#__PURE__*/React.createElement("div", {
    className: "ml-3 w-0 flex-1 pt-0.5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-sm leading-5 font-medium text-gray-900"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "mt-1 text-sm leading-5 text-gray-500"
  }, message)), /*#__PURE__*/React.createElement("div", {
    className: "ml-4 flex-shrink-0 flex"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onDismiss,
    className: "inline-flex text-gray-400 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "h-5 w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }))))))));
});

var ToastMessages = function ToastMessages() {
  var _useNotifications = useNotifications(),
    notifications = _useNotifications.notifications,
    removeNotification = _useNotifications.removeNotification;
  return /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 flex flex-col items-end px-4 py-6 z-10 pointer-events-none sm:p-6"
  }, /*#__PURE__*/React.createElement(AnimatePresence, null, notifications.map(function (notification) {
    return /*#__PURE__*/React.createElement(AnimatedNotification, {
      key: notification.createdAt,
      type: notification.data.type,
      title: notification.data.title,
      message: notification.data.message,
      onDismiss: function onDismiss() {
        return removeNotification(notification);
      },
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1
      },
      exit: {
        opacity: 0
      },
      drag: "x",
      onDragEnd: function onDragEnd() {
        return removeNotification(notification);
      }
    });
  })));
};
var AnimatedNotification = motion(Notification);

var AppStateContext = /*#__PURE__*/React.createContext();
var AppStateProvider = AppStateContext.Provider;

var _templateObject$F;
var CURRENT_USER_FRAGMENT = gql(_templateObject$F || (_templateObject$F = _taggedTemplateLiteral(["\n    fragment CurrentUser on Me {\n        id\n        firstName\n        lastName\n        fullName\n        email\n        phone\n        permissions\n        preferredLanguageCode\n    }\n"])));

var _templateObject$E;
var STORE_FRAGMENT = gql(_templateObject$E || (_templateObject$E = _taggedTemplateLiteral(["\n    fragment StoreFragment on Store {\n        id\n        name\n        legalName\n        slug\n        customerSupportEmail\n        customerSupportPhone\n        vatNumber\n        address\n        countryCode\n        defaultLanguage\n        url\n        availableLanguages\n        currencyUnit\n        weightUnit\n        timeZone\n        dateFormat\n        orderNumberFormat\n        shippingSettings {\n            freeShippingFromAmount\n            countryRules {\n                countryCode,\n                cost\n            }\n        }\n    }\n"])));

var _templateObject$D;
var INITIAL_DATA_QUERY = gql(_templateObject$D || (_templateObject$D = _taggedTemplateLiteral(["\n    query initialDataQuery {\n        me {\n            ...CurrentUser\n        }\n        store {\n            ...StoreFragment\n        }\n    }\n    ", "\n    ", "\n"])), CURRENT_USER_FRAGMENT, STORE_FRAGMENT);
var fetchInitialData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(apollo, options) {
    var query, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          query = INITIAL_DATA_QUERY;
          _context.next = 3;
          return apollo.query(_objectSpread2({
            query: query
          }, options));
        case 3:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchInitialData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

// Remove this polyfill when the issue below is resolved
// https://github.com/jsdom/jsdom/issues/2156
var EventTargetPolyfill = /*#__PURE__*/function () {
  function EventTargetPolyfill() {
    _classCallCheck(this, EventTargetPolyfill);
    this.events = {};
  }
  return _createClass(EventTargetPolyfill, [{
    key: "addEventListener",
    value: function addEventListener(type, listener) {
      if (typeof this.events[type] === 'undefined') {
        this.events[type] = [];
      }
      this.events[type].push(listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener) {
      if (typeof this.events[type] !== 'undefined') {
        var index = this.events[type].indexOf(listener);
        if (index > -1) {
          this.events[type].splice(index, 1);
        }
      }
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      var type = event.type;
      if (typeof this.events[type] !== 'undefined') {
        this.events[type].forEach(function (listener) {
          listener(event);
        });
      }
    }
  }]);
}();

var DEFAULT_DURATION = 5000;
var NotificationDispatcher = /*#__PURE__*/function (_EventTarget) {
  function NotificationDispatcher() {
    var _this;
    var defaultDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_DURATION;
    _classCallCheck(this, NotificationDispatcher);
    _this = _callSuper(this, NotificationDispatcher);
    _this.defaultDuration = defaultDuration;
    _this.notifications = [];
    return _this;
  }
  _inherits(NotificationDispatcher, _EventTarget);
  return _createClass(NotificationDispatcher, [{
    key: "createNotification",
    value: function createNotification(data) {
      var createdAt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.defaultDuration;
      return {
        data: data,
        createdAt: createdAt,
        duration: duration
      };
    }
  }, {
    key: "removeNotification",
    value: function removeNotification(notification) {
      var index = this.notifications.indexOf(notification);
      if (index !== -1) {
        this.notifications.splice(index, 1);
      }
      this.dispatchEvent(new CustomEvent('changed'));
      this.dispatchEvent(new CustomEvent('removed', {
        detail: notification
      }));
    }
  }, {
    key: "dispatchNotification",
    value: function dispatchNotification(notification) {
      var _this2 = this;
      this.notifications.push(notification);
      setTimeout(function () {
        _this2.removeNotification(notification);
      }, notification.duration);
      this.dispatchEvent(new CustomEvent('changed'));
      this.dispatchEvent(new CustomEvent('added', {
        detail: notification
      }));
    }
  }, {
    key: "dispatch",
    value: function dispatch(data, createdAt, duration) {
      var notification = this.createNotification(data, createdAt, duration);
      this.dispatchNotification(notification);
    }
  }, {
    key: "subscribe",
    value: function subscribe(listener) {
      var _this3 = this;
      this.addEventListener('changed', function () {
        return listener(_toConsumableArray(_this3.notifications));
      });
      return function () {
        _this3.removeEventListener('changed', function () {
          return listener(_toConsumableArray(_this3.notifications));
        });
      };
    }
  }]);
}(EventTargetPolyfill);
var notificationDispatcher = null;
var getNotificationDispatcher = function getNotificationDispatcher() {
  if (notificationDispatcher === null) {
    notificationDispatcher = new NotificationDispatcher();
    return notificationDispatcher;
  }
  return notificationDispatcher;
};

var useAppState = function useAppState() {
  return useContext(AppStateContext);
};

var HasPermission = function HasPermission(_ref) {
  var type = _ref.type,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? null : _ref$placeholder,
    children = _ref.children;
  var _useAppState = useAppState(),
    currentUser = _useAppState.currentUser;
  if (currentUser === null) {
    return placeholder;
  }
  if (!currentUser.permissions.includes(type)) {
    return placeholder;
  }
  return children;
};

var AppNotFound = function AppNotFound() {
  return /*#__PURE__*/React.createElement("div", {
    className: "min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sm:mx-auto sm:w-full sm:max-w-md"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900"
  }, "Not Found")));
};

var _excluded$s = ["type", "children"];
var HasPermissionRoute = function HasPermissionRoute(_ref) {
  var type = _ref.type,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$s);
  return /*#__PURE__*/React.createElement(Route, props, /*#__PURE__*/React.createElement(HasPermission, {
    type: type,
    placeholder: /*#__PURE__*/React.createElement(AppNotFound, null)
  }, children));
};

var _excluded$r = ["type", "title", "className", "showDismiss", "onDismiss", "children"];
var ERROR = 'error';
var WARNING = 'warning';
var SUCCESS = 'success';
var getIconName = function getIconName(type) {
  if (type === ERROR) {
    return 'warning-circle';
  }
  if (type === WARNING) {
    return 'warning-circle';
  }
  return 'check-circle';
};
var getTextColor = function getTextColor(type) {
  if (type === ERROR) {
    return 'text-red-600';
  }
  if (type === WARNING) {
    return 'text-yellow-300';
  }
  return 'text-green-400';
};
var Alert = function Alert(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? ERROR : _ref$type,
    title = _ref.title,
    className = _ref.className,
    showDismiss = _ref.showDismiss,
    onDismiss = _ref.onDismiss,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$r);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx('rounded-md p-4', type === SUCCESS && 'bg-green-50', type === ERROR && 'bg-red-50', type === WARNING && 'bg-yellow-50', className),
    "data-testid": "Alert"
  }, props), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: clsx(getTextColor(type)),
    name: getIconName(type)
  })), /*#__PURE__*/React.createElement("div", {
    className: "ml-3 flex flex-col flex-start justify-center "
  }, /*#__PURE__*/React.createElement("h3", {
    className: clsx('text-sm leading-5 font-medium', getTextColor(type))
  }, title), /*#__PURE__*/React.createElement("p", {
    className: clsx('mt-2 text-sm leading-5', getTextColor(type))
  }, children)), showDismiss && /*#__PURE__*/React.createElement("div", {
    className: "ml-auto pl-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "-mx-1.5 -my-1.5"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onDismiss,
    className: clsx('inline-flex rounded-md p-1.5 focus:outline-none transition ease-in-out duration-150', type === SUCCESS && 'hover:bg-green-100 focus:bg-green-100', type === ERROR && 'hover:bg-red-100 focus:bg-red-100', type === WARNING && 'hover:bg-yellow-100 focus:bg-yellow-100'),
    "aria-label": "Dismiss"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: clsx(getTextColor(type)),
    name: "cross"
  }))))));
};

var _excluded$q = ["className", "children", "loading", "disabled", "onClick"];
var Button = function Button(_ref) {
  var className = _ref.className,
    children = _ref.children,
    loading = _ref.loading,
    disabled = _ref.disabled,
    _onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded$q);
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    disabled: disabled,
    className: clsx('btn', className, loading && 'opacity-75', disabled && 'cursor-not-allowed opacity-75'),
    onClick: function onClick() {
      return !disabled && typeof _onClick === 'function' && _onClick();
    }
  }, props), /*#__PURE__*/React.createElement("div", {
    className: "flex-1"
  }, loading && /*#__PURE__*/React.createElement(Icon, {
    name: "spinner",
    className: "animate-spin ml-auto mr-2",
    color: "white"
  })), children, /*#__PURE__*/React.createElement("div", {
    className: "flex-1"
  }));
};

var FormGroup = function FormGroup(_ref) {
  var label = _ref.label,
    htmlFor = _ref.htmlFor,
    _ref$isHorizontal = _ref.isHorizontal,
    isHorizontal = _ref$isHorizontal === void 0 ? false : _ref$isHorizontal,
    className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('mb-5', isHorizontal && 'sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5', !isHorizontal && 'mb-1', className)
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: htmlFor,
    className: clsx('block text-sm font-medium leading-5 text-gray-700 mb-1', isHorizontal && 'sm:mt-px sm:pt-2')
  }, label), /*#__PURE__*/React.createElement("div", {
    className: clsx('mt-1 sm:mt-0 sm:col-span-2 -mb-5', !isHorizontal && 'sm:mt-1')
  }, children));
};

var FormInputErrors = function FormInputErrors(_ref) {
  var _ref$errors = _ref.errors,
    errors = _ref$errors === void 0 ? [] : _ref$errors;
  if (errors.length === 0) {
    return null;
  }
  return errors.map(function (error, index) {
    return /*#__PURE__*/React.createElement("p", {
      key: error,
      "data-testid": "FormInputError",
      className: clsx('text-sm text-red-600', index === 0 && 'mt-1 ml-1')
    }, error);
  });
};

var _excluded$p = ["id", "type", "errors", "hasError", "iconNameBefore", "iconNameAfter", "className", "inputClassName", "disabled", "value", "onChange", "prepend", "as"];
var FormInput = function FormInput(_ref) {
  var id = _ref.id,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    errors = _ref.errors,
    hasError = _ref.hasError,
    iconNameBefore = _ref.iconNameBefore,
    iconNameAfter = _ref.iconNameAfter,
    className = _ref.className,
    inputClassName = _ref.inputClassName,
    disabled = _ref.disabled,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    onChange = _ref.onChange,
    _ref$prepend = _ref.prepend,
    prepend = _ref$prepend === void 0 ? '' : _ref$prepend,
    as = _ref.as,
    props = _objectWithoutProperties(_ref, _excluded$p);
  var hasPrependValue = prepend.length > 0;
  var inputProps = _objectSpread2({
    id: id,
    type: type,
    disabled: disabled,
    className: clsx('appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm', hasError && 'border-red-300 text-red-600 placeholder-red-300 focus:border-red-300 focus:ring-red', !disabled && 'shadow-sm', disabled && 'bg-gray-100', iconNameBefore && 'pl-9', (iconNameAfter || hasError) && 'pr-9', inputClassName, hasPrependValue && 'rounded-tl-none rounded-bl-none'),
    value: value,
    onChange: onChange
  }, props);
  var input = /*#__PURE__*/React.createElement("input", inputProps);
  if (as === 'textarea') {
    input = /*#__PURE__*/React.createElement("textarea", _extends({}, inputProps, {
      className: clsx([inputProps.className, 'resize-none min-h-36'])
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx(['flex w-full', className])
  }, hasPrependValue && /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-50 flex items-center text-sm px-3 rounded-tl-md rounded-bl-md border border-gray-300 border-r-0 text-gray-500"
  }, prepend), /*#__PURE__*/React.createElement("div", {
    className: "relative rounded-md flex-1"
  }, iconNameBefore && /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "small",
    name: iconNameAfter
  })), input, (iconNameAfter || hasError) && /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "small",
    name: hasError ? 'warning-circle' : iconNameAfter,
    className: clsx(hasError && 'text-red-500')
  })))), /*#__PURE__*/React.createElement(FormInputErrors, {
    errors: errors
  }));
};

var _excluded$o = ["className", "hasError", "onChange", "value", "name"];
var Checkbox = function Checkbox(_ref) {
  var className = _ref.className;
    _ref.hasError;
    var onChange = _ref.onChange,
    value = _ref.value,
    name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$o);
  return /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    className: clsx('h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded cursor-pointer', className),
    name: name,
    onChange: onChange,
    checked: value
  }, props));
};

var _excluded$n = ["label", "description", "htmlFor", "className", "labelClassName", "descriptionClassName"];
var FormCheckbox = function FormCheckbox(_ref) {
  var label = _ref.label,
    description = _ref.description;
    _ref.htmlFor;
    var className = _ref.className,
    labelClassName = _ref.labelClassName,
    descriptionClassName = _ref.descriptionClassName,
    props = _objectWithoutProperties(_ref, _excluded$n);
  var name = props.name;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('relative flex items-start', className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center h-5"
  }, /*#__PURE__*/React.createElement(Checkbox, _extends({
    id: name
  }, props))), /*#__PURE__*/React.createElement("div", {
    className: "ml-3 text-sm leading-5"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: name,
    className: clsx('ml-2 block text-sm text-gray-700 cursor-pointer', labelClassName)
  }, label), description && /*#__PURE__*/React.createElement("p", {
    className: clsx('text-gray-500', descriptionClassName)
  }, description)));
};

var _excluded$m = ["children"];
var LoginPageContainer = function LoginPageContainer(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$m);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "min-h-screen bg-white flex"
  }, props), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mx-auto w-full max-w-sm lg:w-96"
  }, children)), /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block relative w-0 flex-1"
  }, /*#__PURE__*/React.createElement("img", {
    className: "absolute inset-0 h-full w-full object-cover",
    src: "https://images.unsplash.com/photo-1483985988355-763728e1935b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1908&q=80",
    alt: ""
  })));
};

var _excluded$l = ["children"];
var LoginPageTitle = function LoginPageTitle(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$l);
  return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement("img", {
    className: "h-12 w-auto",
    src: "/img/logo.svg",
    alt: "Pure Interior"
  }), /*#__PURE__*/React.createElement("h2", {
    className: "mt-6 text-3xl leading-9 font-extrabold text-gray-900"
  }, children));
};

var _excluded$k = ["children"];
var LoginPageCard = function LoginPageCard(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$k);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "mt-8"
  }, props), children);
};

var LoginPage = function LoginPage(_ref) {
  var errorMessage = _ref.errorMessage,
    isLoading = _ref.isLoading,
    formState = _ref.formState,
    _onSubmit = _ref.onSubmit;
  var getErrorMessages = formState.getErrorMessages,
    getNativeInputProps = formState.getNativeInputProps;
  return /*#__PURE__*/React.createElement(LoginPageContainer, {
    "data-testid": "LoginPage"
  }, /*#__PURE__*/React.createElement(LoginPageTitle, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Sign in"
  })), /*#__PURE__*/React.createElement(LoginPageCard, null, errorMessage && /*#__PURE__*/React.createElement(Alert, {
    className: "mb-6",
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Failed to login"
    })
  }, errorMessage), /*#__PURE__*/React.createElement("form", {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      _onSubmit();
    },
    className: "space-y-6"
  }, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Email address"
    }),
    htmlFor: "email"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    id: "email",
    className: "max-w-lg",
    errors: getErrorMessages('email')
  }, getNativeInputProps('email')))), /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Password"
    }),
    htmlFor: "password"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    id: "password",
    type: "password",
    className: "max-w-lg",
    errors: getErrorMessages('password')
  }, getNativeInputProps('password')))), /*#__PURE__*/React.createElement("div", {
    className: "mt-6 flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(FormCheckbox, _extends({
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Remember me"
    })
  }, getNativeInputProps('rememberMe')))), /*#__PURE__*/React.createElement("div", {
    className: "text-sm leading-5"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/reset-password"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "font-medium text-primary-500 hover:text-primary-600 focus:outline-none focus:underline transition ease-in-out duration-150"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Forgot your password?"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "mt-6"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    "data-testid": "SignInButton",
    loading: isLoading,
    disabled: isLoading,
    className: "btn-primary w-full"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Sign in"
  }))))));
};

var _templateObject$C;
var LOGIN_MUTATION = gql(_templateObject$C || (_templateObject$C = _taggedTemplateLiteral(["\n    mutation loginWithPassword($input: LoginWithPasswordInput!) {\n        loginWithPassword(input: $input) {\n            accessToken\n            refreshToken\n            me {\n                ...CurrentUser\n            }\n        }\n    }\n    ", "\n"])), CURRENT_USER_FRAGMENT);
var useLoginMutation = function useLoginMutation() {
  return useMutation(LOGIN_MUTATION);
};

var validation$9 = createFormValidation([{
  path: 'email',
  validate: isValidEmail,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The email field is required"
  })
}, {
  path: 'password',
  validate: function validate(password) {
    return password !== '';
  },
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The password field is required"
  })
}]);
var useLoginFormState = function useLoginFormState() {
  return useFormState({
    email: '',
    password: '',
    rememberMe: false
  }, {
    validation: validation$9
  });
};

var LoginPageWithState = function LoginPageWithState() {
  var appState = useAppState();
  var _useLoginMutation = useLoginMutation(),
    _useLoginMutation2 = _slicedToArray(_useLoginMutation, 2),
    login = _useLoginMutation2[0],
    loading = _useLoginMutation2[1].loading;
  var formState = useLoginFormState();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  return /*#__PURE__*/React.createElement(LoginPage, {
    errorMessage: errorMessage,
    formState: formState,
    isLoading: loading,
    onSubmit: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _formState$values, email, password, input, _yield$login, data, _data$loginWithPasswo, accessToken, refreshToken, currentUser, message;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!formState.validate()) {
              _context.next = 16;
              break;
            }
            _context.prev = 1;
            _formState$values = formState.values, email = _formState$values.email, password = _formState$values.password;
            input = {
              email: email,
              password: password
            };
            _context.next = 6;
            return login({
              variables: {
                input: input
              }
            });
          case 6:
            _yield$login = _context.sent;
            data = _yield$login.data;
            _data$loginWithPasswo = data.loginWithPassword, accessToken = _data$loginWithPasswo.accessToken, refreshToken = _data$loginWithPasswo.refreshToken, currentUser = _data$loginWithPasswo.me;
            appState.login(accessToken, refreshToken, currentUser);
            _context.next = 16;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            message = _context.t0.graphQLErrors[0].message;
            setErrorMessage(message);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 12]]);
    }))
  });
};

var ResetPasswordPage = function ResetPasswordPage(_ref) {
  var formState = _ref.formState,
    errorMessage = _ref.errorMessage,
    isLoading = _ref.isLoading,
    isPasswordReset = _ref.isPasswordReset,
    _onSubmit = _ref.onSubmit;
  var values = formState.values,
    getNativeInputProps = formState.getNativeInputProps,
    getErrorMessages = formState.getErrorMessages;
  return /*#__PURE__*/React.createElement(LoginPageContainer, {
    "data-testid": "ResetPasswordPage"
  }, /*#__PURE__*/React.createElement(LoginPageTitle, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Forgot password"
  })), /*#__PURE__*/React.createElement(LoginPageCard, null, errorMessage && /*#__PURE__*/React.createElement(Alert, {
    className: "mb-6",
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Failed to login"
    })
  }, errorMessage), isPasswordReset ? /*#__PURE__*/React.createElement(Alert, {
    type: "success",
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Success"
    })
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "A reset password link has been sent to<0>{0}</0>. Please check your inbox.",
    values: {
      "0": values.email
    },
    components: {
      "0": /*#__PURE__*/React.createElement("strong", null)
    }
  })) : /*#__PURE__*/React.createElement("form", {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      _onSubmit();
    }
  }, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Email address"
    }),
    htmlFor: "email"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    id: "email",
    className: "max-w-lg",
    errors: getErrorMessages('email')
  }, getNativeInputProps('email')))), /*#__PURE__*/React.createElement("div", {
    className: "mt-6 flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-sm leading-5"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/login"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "font-medium text-primary-500 hover:text-primary-600 focus:outline-none focus:underline transition ease-in-out duration-150"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Back to login"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "mt-6"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    "data-testid": "ResetPasswordButton",
    disabled: isLoading,
    loading: isLoading,
    className: "btn-primary w-full"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Reset password"
  }))))));
};

var _templateObject$B;
var RESET_PASSWORD_MUTATION = gql(_templateObject$B || (_templateObject$B = _taggedTemplateLiteral(["\n    mutation requestPasswordReset($input: RequestPasswordResetInput!) {\n        requestPasswordReset(input: $input)\n    }\n"])));
function useResetPasswordMutation() {
  return useMutation(RESET_PASSWORD_MUTATION);
}

var validation$8 = createFormValidation([{
  path: 'email',
  validate: isValidEmail,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The email field is required"
  })
}]);
var useResetPasswordFormState = function useResetPasswordFormState() {
  return useFormState({
    email: ''
  }, {
    validation: validation$8
  });
};

var ResetPasswordPageWithState = function ResetPasswordPageWithState() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPasswordReset = _useState2[0],
    setIsPasswordReset = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var formState = useResetPasswordFormState();
  var _useResetPasswordMuta = useResetPasswordMutation(),
    _useResetPasswordMuta2 = _slicedToArray(_useResetPasswordMuta, 2),
    resetPassword = _useResetPasswordMuta2[0],
    loading = _useResetPasswordMuta2[1].loading;
  return /*#__PURE__*/React.createElement(ResetPasswordPage, {
    formState: formState,
    errorMessage: errorMessage,
    isLoading: loading,
    isPasswordReset: isPasswordReset,
    onSubmit: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var input, message;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!formState.validate()) {
              _context.next = 12;
              break;
            }
            _context.prev = 1;
            input = formState.values;
            _context.next = 5;
            return resetPassword({
              variables: {
                input: input
              }
            });
          case 5:
            setIsPasswordReset(true);
            _context.next = 12;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            message = _context.t0.graphQLErrors[0].message;
            setErrorMessage(message);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }))
  });
};

var parseQueryString = function parseQueryString(search) {
  return parse(search);
};
var stringifyQueryParams = function stringifyQueryParams(params) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return stringify(params, options);
};
var combineRefs = function combineRefs() {
  var refs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (el) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(el);
      } else {
        // eslint-disable-next-line no-param-reassign
        ref.current = el;
      }
    });
  };
};

var useQueryParams = function useQueryParams() {
  var history = useHistory();
  var _useLocation = useLocation(),
    search = _useLocation.search,
    pathname = _useLocation.pathname;
  var params = parseQueryString(search);
  var onChangeParam = function onChangeParam(param, paramValue) {
    params[param] = paramValue;
    var qs = stringifyQueryParams(params, {
      skipEmptyString: true
    });
    history.push("".concat(pathname, "?").concat(qs));
  };
  return {
    params: params,
    onChangeParam: onChangeParam
  };
};

var ChoosePasswordPage = function ChoosePasswordPage(_ref) {
  var email = _ref.email,
    formState = _ref.formState,
    onSave = _ref.onSave;
  var getNativeInputProps = formState.getNativeInputProps,
    getErrorMessages = formState.getErrorMessages;
  return /*#__PURE__*/React.createElement(LoginPageContainer, null, /*#__PURE__*/React.createElement(LoginPageTitle, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Choose password"
  })), /*#__PURE__*/React.createElement(LoginPageCard, null, /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Email address"
    }),
    htmlFor: "email"
  }, /*#__PURE__*/React.createElement(FormInput, {
    id: "email",
    name: "email",
    type: "email",
    className: "max-w-lg",
    disabled: true,
    value: email
  })), /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Password"
    }),
    htmlFor: "password"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    id: "password",
    type: "password",
    className: "max-w-lg",
    errors: getErrorMessages('password')
  }, getNativeInputProps('password')))), /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Repeat password"
    }),
    htmlFor: "password"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    id: "repeatPassword",
    type: "password",
    className: "max-w-lg",
    errors: getErrorMessages('repeatPassword')
  }, getNativeInputProps('repeatPassword')))), /*#__PURE__*/React.createElement("div", {
    className: "mt-6"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onSave,
    className: "btn-primary w-full"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Done"
  }))))));
};

var _templateObject$A;
var CHOOSE_PASSWORD_MUTATION = gql(_templateObject$A || (_templateObject$A = _taggedTemplateLiteral(["\n    mutation choosePassword($input: ChoosePasswordInput!) {\n        choosePassword(input: $input) {\n            accessToken,\n            refreshToken,\n            me {\n                ...CurrentUser\n            }\n        }\n    }\n    ", "\n"])), CURRENT_USER_FRAGMENT);
function useChoosePasswordMutation() {
  return useMutation(CHOOSE_PASSWORD_MUTATION);
}

var validation$7 = createFormValidation([{
  path: 'password',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "Please choose a password"
  })
}, {
  path: 'repeatPassword',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "Please repeat your password"
  })
}]);
var useChoosePasswordFormState = function useChoosePasswordFormState() {
  return useFormState({
    password: '',
    repeatPassword: ''
  }, {
    validation: validation$7
  });
};

var ChoosePasswordPageWithState = function ChoosePasswordPageWithState() {
  var _useLingui = useLingui(),
    i18n = _useLingui.i18n;
  var appState = useAppState();
  var _useQueryParams = useQueryParams(),
    _useQueryParams$param = _useQueryParams.params,
    email = _useQueryParams$param.email,
    token = _useQueryParams$param.token;
  var _useNotifications = useNotifications(),
    dispatchSuccess = _useNotifications.dispatchSuccess;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var formState = useChoosePasswordFormState();
  var _useChoosePasswordMut = useChoosePasswordMutation(),
    _useChoosePasswordMut2 = _slicedToArray(_useChoosePasswordMut, 2),
    choosePassword = _useChoosePasswordMut2[0],
    loading = _useChoosePasswordMut2[1].loading;
  return /*#__PURE__*/React.createElement(ChoosePasswordPage, {
    email: email,
    formState: formState,
    isLoading: loading,
    errorMessage: errorMessage,
    onSave: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var values, input, _yield$choosePassword, data, _data$choosePassword, accessToken, refreshToken, currentUser, message;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!formState.validate()) {
              _context.next = 18;
              break;
            }
            _context.prev = 1;
            values = formState.values;
            input = {
              token: token,
              email: email,
              password: values.password
            };
            _context.next = 6;
            return choosePassword({
              variables: {
                input: input
              }
            });
          case 6:
            _yield$choosePassword = _context.sent;
            data = _yield$choosePassword.data;
            _data$choosePassword = data.choosePassword, accessToken = _data$choosePassword.accessToken, refreshToken = _data$choosePassword.refreshToken, currentUser = _data$choosePassword.me;
            _context.next = 11;
            return appState.login(accessToken, refreshToken, currentUser);
          case 11:
            dispatchSuccess({
              message: i18n._(/*i18n*/i18n._("Your password was saved successfully."))
            });
            _context.next = 18;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](1);
            message = _context.t0.graphQLErrors[0].message;
            setErrorMessage(message);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 14]]);
    }))
  });
};

var _excluded$j = ["className", "children", "variant"];
var Table = function Table(_ref) {
  var className = _ref.className,
    children = _ref.children,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded$j);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx('overflow-hidden', variant !== 'borderLess' && 'shadow border-b border-gray-200 sm:rounded-lg', className)
  }, props), /*#__PURE__*/React.createElement("table", {
    className: "min-w-full divide-y divide-gray-200"
  }, children));
};

var TableCell = function TableCell(_ref) {
  var className = _ref.className,
    _ref$hasText = _ref.hasText,
    hasText = _ref$hasText === void 0 ? true : _ref$hasText,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("td", {
    className: clsx('px-6 py-4', hasText && 'text-sm leading-5', className)
  }, children);
};

var _excluded$i = ["className", "iconName", "imageUrl"];
var Avatar = function Avatar(_ref) {
  var className = _ref.className,
    _ref$iconName = _ref.iconName,
    iconName = _ref$iconName === void 0 ? 'user' : _ref$iconName,
    _ref$imageUrl = _ref.imageUrl,
    imageUrl = _ref$imageUrl === void 0 ? null : _ref$imageUrl,
    props = _objectWithoutProperties(_ref, _excluded$i);
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: clsx('inline-block h-10 w-10 rounded-full overflow-hidden bg-gray-100 p-2 bg-cover', className),
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    }
  }), imageUrl === null && /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    className: "h-full w-full"
  }));
};

var usePermissions = function usePermissions() {
  var _useAppState = useAppState(),
    permissions = _useAppState.currentUser.permissions;
  var canReadProducts = permissions.includes(PERMISSION_READ_PRODUCTS);
  var canWriteProducts = permissions.includes(PERMISSION_WRITE_PRODUCTS);
  var canReadOrders = permissions.includes(PERMISSION_READ_ORDERS);
  var canWriteOrders = permissions.includes(PERMISSION_READ_ORDERS);
  var canReadUsers = permissions.includes(PERMISSION_READ_USERS);
  var canWriteUsers = permissions.includes(PERMISSION_WRITE_USERS);
  var canWriteRoles = permissions.includes(PERMISSION_WRITE_ROLES);
  var canReadCustomers = permissions.includes(PERMISSION_READ_CUSTOMERS);
  var canReadSettings = permissions.includes(PERMISSION_READ_SETTINGS);
  var canWriteSettings = permissions.includes(PERMISSION_WRITE_SETTINGS);
  var canUploadFiles = permissions.includes(PERMISSION_UPLOAD_FILES);
  return {
    canReadProducts: canReadProducts,
    canWriteProducts: canWriteProducts,
    canReadOrders: canReadOrders,
    canWriteOrders: canWriteOrders,
    canReadUsers: canReadUsers,
    canWriteUsers: canWriteUsers,
    canWriteRoles: canWriteRoles,
    canReadCustomers: canReadCustomers,
    canReadSettings: canReadSettings,
    canWriteSettings: canWriteSettings,
    canUploadFiles: canUploadFiles
  };
};

function useLatest(value) {
  var ref = useRef(value);
  useEffect(function () {
    ref.current = value;
  });
  return ref;
}

var MOUSEDOWN = 'mousedown';
var TOUCHSTART = 'touchstart';
var EVENTS = [MOUSEDOWN, TOUCHSTART];
function useOnClickOutside(ref, handler) {
  var handlerRef = useLatest(handler);
  useEffect(function () {
    if (!handler) {
      throw new Error('No handler defined');
    }
    var listener = function listener(event) {
      if (!ref.current || !handlerRef.current || ref.current.contains(event.target)) {
        return;
      }
      handlerRef.current(event);
    };
    EVENTS.forEach(function (event) {
      document.addEventListener(event, listener);
    });
    return function () {
      EVENTS.forEach(function (event) {
        document.removeEventListener(event, listener);
      });
    };
  }, [handler, handlerRef, ref]);
}

var _excluded$h = ["onOutsideClick"];
var POSITION_AUTO = 'auto';
var POSITION_AUTO_START = 'auto-start';
var POSITION_AUTO_END = 'auto-end';
var POSITION_TOP = 'top';
var POSITION_TOP_START = 'top-start';
var POSITION_TOP_END = 'top-end';
var POSITION_BOTTOM = 'bottom';
var POSITION_BOTTOM_START = 'bottom-start';
var POSITION_BOTTOM_END = 'bottom-end';
var POSITION_RIGHT = 'right';
var POSITION_RIGHT_START = 'right-start';
var POSITION_RIGHT_END = 'right-end';
var POSITION_LEFT = 'left';
var POSITION_LEFT_START = 'left-start';
var POSITION_LEFT_END = 'left-end';
var PopoverContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onOutsideClick = _ref.onOutsideClick,
    props = _objectWithoutProperties(_ref, _excluded$h);
  var containerRef = useRef();
  useOnClickOutside(containerRef, function () {
    if (typeof onOutsideClick === 'function') {
      onOutsideClick();
    }
  });
  var refs = ref !== null ? [ref, containerRef] : [containerRef];
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: combineRefs(refs)
  }, props));
});
var Popover = function Popover(_ref2) {
  var _ref2$position = _ref2.position,
    position = _ref2$position === void 0 ? POSITION_BOTTOM_START : _ref2$position,
    content = _ref2.content,
    children = _ref2.children,
    className = _ref2.className;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    popperElement = _useState4[0],
    setPopperElement = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    referenceElement = _useState6[0],
    setReferenceElement = _useState6[1];
  var _usePopper = usePopper(referenceElement, popperElement, {
      strategy: 'fixed',
      placement: position
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: clsx(['focus:outline-none inline-block', className]),
    ref: setReferenceElement,
    onClick: function onClick() {
      return setIsOpen(true);
    }
  }, children), isOpen && /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(PopoverContainer, {
    onOutsideClick: function onOutsideClick() {
      return setIsOpen(false);
    }
  }, /*#__PURE__*/React.createElement("div", _extends({
    ref: setPopperElement,
    style: styles.popper
  }, attributes.popper), function () {
    if (typeof content === 'function') {
      return content({
        open: function open() {
          return setIsOpen(true);
        },
        close: function close() {
          return setIsOpen(false);
        }
      });
    }
    return content;
  }())), document.querySelector('#popover')));
};
Popover.POSITION_TOP = POSITION_TOP;
Popover.POSITION_AUTO = POSITION_AUTO;
Popover.POSITION_AUTO_START = POSITION_AUTO_START;
Popover.POSITION_AUTO_END = POSITION_AUTO_END;
Popover.POSITION_TOP = POSITION_TOP;
Popover.POSITION_TOP_START = POSITION_TOP_START;
Popover.POSITION_TOP_END = POSITION_TOP_END;
Popover.POSITION_BOTTOM = POSITION_BOTTOM;
Popover.POSITION_BOTTOM_START = POSITION_BOTTOM_START;
Popover.POSITION_BOTTOM_END = POSITION_BOTTOM_END;
Popover.POSITION_RIGHT = POSITION_RIGHT;
Popover.POSITION_RIGHT_START = POSITION_RIGHT_START;
Popover.POSITION_RIGHT_END = POSITION_RIGHT_END;
Popover.POSITION_LEFT = POSITION_LEFT;
Popover.POSITION_LEFT_START = POSITION_LEFT_START;
Popover.POSITION_LEFT_END = POSITION_LEFT_END;

var _excluded$g = ["content"];
var DropdownMenu = function DropdownMenu(_ref) {
  var _content = _ref.content,
    props = _objectWithoutProperties(_ref, _excluded$g);
  return /*#__PURE__*/React.createElement(Popover, _extends({
    content: function content(options) {
      return /*#__PURE__*/React.createElement("div", {
        className: "w-56 mt-2 rounded-md shadow-lg"
      }, /*#__PURE__*/React.createElement("div", {
        className: "rounded-md bg-white ring-1 ring-black ring-opacity-5 py-2",
        role: "menu",
        "aria-orientation": "vertical",
        "aria-labelledby": "options-menu"
      }, function () {
        if (typeof _content === 'function') {
          return _content(options);
        }
        return _content;
      }()));
    }
  }, props));
};

var _excluded$f = ["iconName", "children", "className", "disabled"];
var DropdownMenuItem = function DropdownMenuItem(_ref) {
  var iconName = _ref.iconName,
    children = _ref.children,
    className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    props = _objectWithoutProperties(_ref, _excluded$f);
  return /*#__PURE__*/React.createElement("button", _extends({
    disabled: disabled,
    type: "button",
    role: "menuitem",
    className: clsx('group flex items-center w-full px-4 py-2 text-sm leading-5 focus:outline-none', !disabled && 'text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900', disabled && 'cursor-not-allowed text-gray-400 hover:bg-transparent hover:text-gray-400 focus:bg-gray-transparent focus:text-gray-400', className)
  }, props), iconName && /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    size: "small",
    color: "none",
    className: clsx('mr-3 ', !disabled && 'text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500', disabled && 'text-gray-300 group-hover:text-gray-300 group-focus:text-gray-300')
  }), children);
};

var ACTIVE$1 = ADMIN_USER_STATUS_ACTIVE;
var UsersPageTableRow$1 = function UsersPageTableRow(_ref) {
  var adminUser = _ref.adminUser,
    isLoading = _ref.isLoading,
    canDeleteUser = _ref.canDeleteUser,
    onResendInvitation = _ref.onResendInvitation,
    onDeleteUser = _ref.onDeleteUser;
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    position: "bottom-start",
    content: function content(_ref2) {
      var close = _ref2.close;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownMenuItem, {
        disabled: isLoading || adminUser.status === ACTIVE$1,
        onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return onResendInvitation();
              case 2:
                close();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        })),
        iconName: "email"
      }, "Resend Invitation"), /*#__PURE__*/React.createElement(Link, {
        to: "/settings/users/update/".concat(adminUser.id)
      }, /*#__PURE__*/React.createElement(DropdownMenuItem, {
        iconName: "edit"
      }, "Edit")), /*#__PURE__*/React.createElement(DropdownMenuItem, {
        disabled: isLoading || !canDeleteUser,
        onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return onDeleteUser();
              case 2:
                close();
              case 3:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        })),
        iconName: "bin"
      }, "Delete user"));
    }
  }, /*#__PURE__*/React.createElement("button", {
    disabled: isLoading,
    type: "button",
    className: "inline-flex rounded-md p-1.5 focus:outline-none transition ease-in-out duration-150 hover:bg-gray-100 focus:bg-gray-100",
    "aria-label": "Dismiss"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "group-hover:text-gray-500 group-focus:text-gray-500",
    name: "menu-dots"
  })));
};

var _templateObject$z;
var SEND_ADMIN_USER_INVITE_MUTATION = gql(_templateObject$z || (_templateObject$z = _taggedTemplateLiteral(["\n    mutation sendAdminUserInvite($id: ID!) {\n        sendAdminUserInvite(id: $id)\n    }\n"])));
var useSendAdminUserInviteMutation = function useSendAdminUserInviteMutation() {
  return useMutation(SEND_ADMIN_USER_INVITE_MUTATION);
};

var SMALL = 'small';
var MEDIUM = 'medium';
var LARGE = 'large';
var Modal = function Modal(_ref) {
  var isOpen = _ref.isOpen,
    onDismiss = _ref.onDismiss,
    children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? SMALL : _ref$size;
  return /*#__PURE__*/React.createElement(Dialog, {
    role: "dialog",
    "aria-label": "Modal",
    isOpen: isOpen,
    onDismiss: onDismiss,
    className: clsx(['w-full p-4 bg-transparent', size === SMALL && 'max-w-md', size === MEDIUM && 'max-w-2xl', size === LARGE && 'max-w-4xl'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative px-8 pt-6 pb-4 bg-white rounded-lg"
  }, children));
};

var ModalTitle = function ModalTitle(_ref) {
  var title = _ref.title,
    description = _ref.description,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "hidden sm:block absolute top-0 right-0 pt-4 pr-4"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onClose,
    className: "text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "h-6 w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M6 18L18 6M6 6l12 12"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 mb-6 text-center sm:mt-0 sm:text-left"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-lg leading-6 font-medium text-gray-900",
    id: "modal-headline"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "mt-1 text-sm leading-5 text-gray-500"
  }, description)));
};

var RemoveUserModal = function RemoveUserModal(_ref) {
  var isOpen = _ref.isOpen,
    onDismiss = _ref.onDismiss,
    userName = _ref.userName,
    onConfirm = _ref.onConfirm,
    isRemovingAdminUser = _ref.isRemovingAdminUser;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onDismiss: onDismiss,
    style: {
      padding: 0
    },
    className: "bg-white rounded-lg"
  }, /*#__PURE__*/React.createElement(ModalTitle, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Delete user"
    }),
    description: /*#__PURE__*/React.createElement(Trans, {
      id: "Are you sure you want to delete {userName}?",
      values: {
        userName: userName
      }
    }),
    onClose: onDismiss
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-10 sm:mt-10 sm:flex sm:flex-row-reverse"
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn-danger",
    onClick: onConfirm,
    loading: isRemovingAdminUser,
    disabled: isRemovingAdminUser
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Delete user"
  }))), /*#__PURE__*/React.createElement("span", {
    className: "mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn-white",
    onClick: onDismiss,
    loading: isRemovingAdminUser,
    disabled: isRemovingAdminUser
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Cancel"
  })))));
};

var _templateObject$y;
var REMOVE_ADMIN_USER_MUTATION = gql(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral(["\n    mutation removeAdminUser($userId: ID!) {\n        removeAdminUser(userId: $userId) {\n            adminUser {\n                id\n            }\n        }\n    }\n"])));
var useRemoveAdminUserMutation = function useRemoveAdminUserMutation(adminUserFragment) {
  return useMutation(REMOVE_ADMIN_USER_MUTATION, {
    update: function update(cache, _ref) {
      var removedAdminUser = _ref.data.removeAdminUser.adminUser;
      cache.modify({
        fields: {
          adminUsers: function adminUsers() {
            var existingAdminUsers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var removedAdminUserRef = cache.writeFragment({
              data: removedAdminUser,
              fragment: adminUserFragment
            });
            return {
              edges: existingAdminUsers.edges.filter(function (_ref2) {
                var __ref = _ref2.node.__ref;
                return __ref !== removedAdminUserRef.__ref;
              }),
              pageInfo: existingAdminUsers.pageInfo
            };
          }
        }
      });
    }
  });
};

var RemoveUserModalWithState = function RemoveUserModalWithState(_ref) {
  var isOpen = _ref.isOpen,
    onDismiss = _ref.onDismiss,
    adminUser = _ref.adminUser,
    adminUserFragment = _ref.adminUserFragment;
  var _useNotifications = useNotifications(),
    dispatchSuccess = _useNotifications.dispatchSuccess,
    dispatchError = _useNotifications.dispatchError;
  var _useRemoveAdminUserMu = useRemoveAdminUserMutation(adminUserFragment),
    _useRemoveAdminUserMu2 = _slicedToArray(_useRemoveAdminUserMu, 2),
    removeAdminUser = _useRemoveAdminUserMu2[0],
    isRemovingAdminUser = _useRemoveAdminUserMu2[1].loading;
  return /*#__PURE__*/React.createElement(RemoveUserModal, {
    isOpen: isOpen,
    onDismiss: onDismiss,
    userName: adminUser.fullName,
    isRemovingAdminUser: isRemovingAdminUser,
    onConfirm: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _ref3, message;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return removeAdminUser({
              variables: {
                userId: adminUser.id
              }
            });
          case 3:
            dispatchSuccess({
              message: /*#__PURE__*/React.createElement(Trans, {
                id: "{0} successfully deleted.",
                values: {
                  "0": adminUser.fullName
                }
              })
            });
            _context.next = 10;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            _ref3 = _context.t0.graphQLErrors[0] || {}, message = _ref3.message;
            dispatchError({
              message: message
            });
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    }))
  });
};

var UsersPageTableRowActionButtonWithState = function UsersPageTableRowActionButtonWithState(_ref) {
  var adminUser = _ref.adminUser,
    adminUserFragment = _ref.adminUserFragment,
    onResendInvitationComplete = _ref.onResendInvitationComplete;
  var _usePermissions = usePermissions(),
    canWriteUsers = _usePermissions.canWriteUsers;
  var _useNotifications = useNotifications(),
    dispatchSuccess = _useNotifications.dispatchSuccess,
    dispatchError = _useNotifications.dispatchError;
  var _useSendAdminUserInvi = useSendAdminUserInviteMutation(),
    _useSendAdminUserInvi2 = _slicedToArray(_useSendAdminUserInvi, 2),
    resendInvitation = _useSendAdminUserInvi2[0],
    isResendingInvitation = _useSendAdminUserInvi2[1].loading;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isRemoveUsereModalOpen = _useState2[0],
    setIsRemoveUsereModalOpen = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UsersPageTableRow$1, {
    isLoading: isResendingInvitation,
    adminUser: adminUser,
    canDeleteUser: canWriteUsers,
    onResendInvitation: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var variables, _ref3, message;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            variables = {
              id: adminUser.id
            };
            _context.next = 4;
            return resendInvitation({
              variables: variables
            });
          case 4:
            dispatchSuccess({
              message: /*#__PURE__*/React.createElement(Trans, {
                id: "Invite send to <0>{0}</0>.",
                values: {
                  "0": adminUser.email
                },
                components: {
                  "0": /*#__PURE__*/React.createElement("strong", null)
                }
              })
            });
            onResendInvitationComplete();
            _context.next = 12;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            _ref3 = _context.t0.graphQLErrors[0] || {}, message = _ref3.message;
            dispatchError({
              message: message
            });
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    })),
    onDeleteUser: function onDeleteUser() {
      return setIsRemoveUsereModalOpen(true);
    }
  }), /*#__PURE__*/React.createElement(RemoveUserModalWithState, {
    isOpen: isRemoveUsereModalOpen,
    onDismiss: function onDismiss() {
      return setIsRemoveUsereModalOpen(false);
    },
    adminUser: adminUser,
    adminUserFragment: adminUserFragment
  }));
};

var _templateObject$x;
var CREATED = ADMIN_USER_STATUS_CREATED,
  INVITED = ADMIN_USER_STATUS_INVITED,
  ACTIVE = ADMIN_USER_STATUS_ACTIVE;
var USER_PAGE_TABLE_ROW = gql(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral(["\n    fragment UserPageTableRowUser on AdminUser {\n        id\n        fullName\n        email\n        status\n        role {\n            id\n            name\n        }\n    }\n"])));
var UsersPageTableRow = function UsersPageTableRow(_ref) {
  var adminUser = _ref.adminUser,
    onResendInvitationComplete = _ref.onResendInvitationComplete;
  var fullName = adminUser.fullName,
    email = adminUser.email,
    role = adminUser.role,
    status = adminUser.status;
  var _useAppState = useAppState(),
    currentUser = _useAppState.currentUser;
  var isYou = adminUser.id === currentUser.id;
  return /*#__PURE__*/React.createElement("tr", {
    "data-testid": "UsersPageTableRow"
  }, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(Avatar, {
    className: "flex-shrink-0"
  }), /*#__PURE__*/React.createElement("div", {
    className: "ml-4 text-sm leading-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-medium text-gray-900"
  }, fullName), /*#__PURE__*/React.createElement("div", {
    className: "text-gray-500"
  }, email)))), /*#__PURE__*/React.createElement(TableCell, null, role.name), /*#__PURE__*/React.createElement(TableCell, null, isYou ? /*#__PURE__*/React.createElement("span", {
    className: "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800"
  }, "YOU") : /*#__PURE__*/React.createElement("span", {
    className: clsx('px-2 inline-flex text-xs leading-5 font-semibold rounded-full', status === CREATED && 'bg-blue-100 text-blue-800', status === INVITED && 'bg-yellow-100 text-yellow-800', status === ACTIVE && 'bg-green-100 text-green-800')
  }, status)), /*#__PURE__*/React.createElement(TableCell, {
    hasText: false,
    className: "text-right"
  }, !isYou && /*#__PURE__*/React.createElement(UsersPageTableRowActionButtonWithState, {
    adminUser: adminUser,
    adminUserFragment: USER_PAGE_TABLE_ROW,
    onResendInvitationComplete: onResendInvitationComplete
  })));
};

var TableHeaderCell = function TableHeaderCell(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("th", {
    className: "px-6 py-3 bg-gray-50  text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
  }, children);
};

var UsersPageTableHeaderRow = function UsersPageTableHeaderRow() {
  return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Name"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Role"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Status"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null));
};

var DEFAULT_HEIGHT = 10;
var ScrollSentinel = function ScrollSentinel(_ref) {
  var onIntersect = _ref.onIntersect,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? DEFAULT_HEIGHT : _ref$height;
  var _useInView = useInView(),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  useEffect(function () {
    if (inView) {
      onIntersect();
    }
  }, [inView, onIntersect]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: "absolute bottom-0 left-0 right-0",
    style: {
      height: height
    }
  });
};

var InfiniteScroll = function InfiniteScroll(_ref) {
  var isFetchingMore = _ref.isFetchingMore,
    onFetchMore = _ref.onFetchMore,
    hasMoreRecords = _ref.hasMoreRecords,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, children, isFetchingMore && /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center items-center h-10"
  }, /*#__PURE__*/React.createElement("div", null, "Loading...")), !isFetchingMore && hasMoreRecords && /*#__PURE__*/React.createElement(ScrollSentinel, {
    onIntersect: onFetchMore
  }));
};

var UsersPageTable = function UsersPageTable(_ref) {
  var _ref$adminUsers = _ref.adminUsers,
    adminUsers = _ref$adminUsers === void 0 ? [] : _ref$adminUsers,
    onResendInvitationComplete = _ref.onResendInvitationComplete,
    isFetchingMore = _ref.isFetchingMore,
    onFetchMore = _ref.onFetchMore,
    hasMoreRecords = _ref.hasMoreRecords;
  return /*#__PURE__*/React.createElement(InfiniteScroll, {
    isFetchingMore: isFetchingMore,
    onFetchMore: onFetchMore,
    hasMoreRecords: hasMoreRecords
  }, /*#__PURE__*/React.createElement(Table, {
    "data-testid": "UsersPageTable"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement(UsersPageTableHeaderRow, null)), /*#__PURE__*/React.createElement("tbody", {
    className: "bg-white divide-y divide-gray-200"
  }, adminUsers.map(function (adminUser) {
    return /*#__PURE__*/React.createElement(UsersPageTableRow, {
      key: adminUser.id,
      adminUser: adminUser,
      onResendInvitationComplete: onResendInvitationComplete
    });
  }))));
};

var PageContainer = function PageContainer(props) {
  return /*#__PURE__*/React.createElement(AnimatePresence, null, /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "PageContainer",
    className: "h-screen flex overflow-hidden bg-gray-100"
  }, props)));
};

var BreadcrumbItem = function BreadcrumbItem(_ref) {
  var to = _ref.to,
    text = _ref.text;
  if (typeof to === 'undefined') {
    return /*#__PURE__*/React.createElement("span", {
      className: "text-gray-400"
    }, text);
  }
  return /*#__PURE__*/React.createElement(Link, {
    to: to
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "text-gray-500 hover:text-gray-700 focus:outline-none"
  }, text));
};
var BreadcrumbDivider = function BreadcrumbDivider() {
  return /*#__PURE__*/React.createElement("svg", {
    className: "flex-shrink-0 mx-2 h-5 w-5 text-gray-400",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
    clipRule: "evenodd"
  }));
};
var BackButton = function BackButton() {
  var history = useHistory();
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return history.goBack();
    },
    className: "flex items-center text-sm leading-5 font-medium text-gray-500 hover:text-gray-700 focus:outline-none focus:text-gray-700"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "flex-shrink-0 -ml-1 mr-1 h-5 w-5 text-gray-400",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
    clipRule: "evenodd"
  })), "Back");
};
var Breadcrumbs = function Breadcrumbs(_ref2) {
  var items = _ref2.items;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("nav", {
    className: "sm:hidden"
  }, /*#__PURE__*/React.createElement(BackButton, null)), /*#__PURE__*/React.createElement("nav", {
    className: "hidden sm:flex items-center text-sm leading-5 font-medium"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "text-gray-400 hover:text-gray-700 focus:outline-none focus:text-gray-700"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "flex-shrink-0 mr-1 pt-1 h-5 w-5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
  })))), /*#__PURE__*/React.createElement(BreadcrumbDivider, null), items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: item.to || item.text
    }, /*#__PURE__*/React.createElement(BreadcrumbItem, {
      to: item.to,
      text: item.text
    }), index !== items.length - 1 && /*#__PURE__*/React.createElement(BreadcrumbDivider, null));
  })));
};

var PageHeader = function PageHeader(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    breadcrumbsItems = _ref.breadcrumbsItems,
    rightChildren = _ref.rightChildren,
    leftChildren = _ref.leftChildren;
  return /*#__PURE__*/React.createElement("div", null, breadcrumbsItems && /*#__PURE__*/React.createElement(Breadcrumbs, {
    items: breadcrumbsItems
  }), /*#__PURE__*/React.createElement("div", {
    className: "my-6 md:flex md:items-center md:justify-between"
  }, leftChildren && /*#__PURE__*/React.createElement("div", {
    className: "mr-4"
  }, leftChildren), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 min-w-0"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-2xl font-medium leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate"
  }, title), subtitle && subtitle), /*#__PURE__*/React.createElement("div", {
    className: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4"
  }, rightChildren)));
};

function Fade(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(motion.div, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  }, children);
}

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
var PageContent = function PageContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-0 flex-1 overflow-hidden"
  }, /*#__PURE__*/React.createElement("main", {
    className: "flex-1 relative z-0 overflow-y-auto focus:outline-none",
    tabIndex: "0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "max-w-7xl mx-auto px-4 pt-2 pb-6 sm:px-6 md:px-8 md:py-6"
  }, /*#__PURE__*/React.createElement(Fade, null, children))));
};

var PageSideBarMenuItem = function PageSideBarMenuItem(_ref) {
  var to = _ref.to,
    _ref$exact = _ref.exact,
    exact = _ref$exact === void 0 ? false : _ref$exact,
    iconName = _ref.iconName,
    children = _ref.children,
    className = _ref.className;
  var isActive = useRouteMatch({
    path: to,
    exact: exact
  }) !== null;
  return /*#__PURE__*/React.createElement(Link, {
    to: to
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: clsx('group w-full flex items-center px-10 py-4 text-sm leading-5 font-medium text-gray-600 border-l-4 ', 'hover:text-gray-900 hover:bg-gray-50', 'focus:outline-none focus:text-gray-900 focus:bg-gray-50', 'transition-all ease-in-out duration-300', !isActive && 'text-gray-500 border-transparent', isActive && 'bg-gray-50 text-gray-900 border-primary-600', className)
  }, /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    className: clsx('mr-2 group-focus:text-gray-500 group-hover:text-primary-600', isActive && 'text-primary-600 group-focus:text-primary-600')
  }), children));
};

var PageSideBarUserDropdown = function PageSideBarUserDropdown(_ref) {
  var currentUser = _ref.currentUser,
    onLogout = _ref.onLogout;
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    isInline: false,
    position: "bottom",
    content: function content() {
      return /*#__PURE__*/React.createElement(DropdownMenuItem, {
        iconName: "logout",
        onClick: onLogout
      }, /*#__PURE__*/React.createElement(Trans, {
        id: "Logout"
      }));
    },
    className: "w-full"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: clsx(['group w-full rounded-md px-3.5 py-2 text-sm border border-gray-100 leading-5 font-medium text-gray-700', 'hover:bg-gray-50 hover:text-gray-500', 'focus:outline-none focus:bg-gray-200 focus:border-blue-300', 'active:bg-gray-50 active:text-gray-800', 'transition ease-in-out duration-150']),
    "aria-haspopup": "true",
    "aria-expanded": "true"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full justify-between items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex min-w-0 items-center justify-between space-x-3"
  }, /*#__PURE__*/React.createElement(Avatar, null), /*#__PURE__*/React.createElement("h2", {
    className: "text-gray-900 text-sm text-left leading-5 font-medium truncate"
  }, currentUser.fullName)), /*#__PURE__*/React.createElement(Icon, {
    className: "ml-2",
    name: "chevron-up-down"
  }))));
};

var Logo = function Logo() {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex text-black"
  }, /*#__PURE__*/React.createElement("svg", {
    height: "100%",
    viewBox: "0 0 242 242",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.53 0C91.17 2.67 69.69 12.52 53 26.4C30.34 45.18 13.31 71.9 11 108.73C6.99999 172.67 56.16 225.35 115.07 229.88C157.81 233.18 186.61 217.02 208.25 194.93C228.1 174.7 236.94 150.93 240.87 120.37C241.04 119.04 241.31 118.75 241.65 119.6C240.01 159.11 227.51 184.6 206.65 205.8C184.04 228.564 153.314 241.416 121.23 241.53C53.88 241.68 3.35999 190.89 0.159989 126.58C-1.66001 90.28 12.27 61.33 31.22 39.58C50.71 17.27 80 0.88 120.53 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.26 222.65C156.67 218.95 178.64 208.43 195.32 191.75C213.5 173.58 226.4 144.16 224.69 113.41C221.69 59.01 177.87 12.41 114.69 16.24C61.69 19.44 27.76 56.84 19.78 107.38C23.1 50.43 66.88 5.00001 130.52 5.68001C186.93 6.29001 235 54.23 235.25 113.41C235.313 127.854 232.478 142.164 226.913 155.493C221.348 168.822 213.165 180.899 202.85 191.01C184.38 209.31 159.58 222.11 125.26 222.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.71 162.93H65.19V147.49H66.71V162.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.18 161.08L84 147.49H85.5V162.93H83.68L75.21 149.32L75.38 162.93H73.88V147.49H75.71L84.18 161.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.05 162.93H94.53V149H91.44V147.48H99.13V149H96.05V162.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.58 154.41H113.06V155.94H106.58V161.44H113.06V162.93H105.06V147.49H113.06V149H106.58V154.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.57 149V162.92H120.08V147.49H124.22C124.959 147.473 125.698 147.543 126.42 147.7C126.962 147.829 127.474 148.06 127.93 148.38C128.556 148.823 129.059 149.418 129.39 150.11C129.743 150.822 129.924 151.606 129.92 152.4C129.947 153.523 129.571 154.619 128.86 155.49C128.539 155.9 128.135 156.237 127.675 156.48C127.215 156.723 126.709 156.866 126.19 156.9L129.92 162.9H128.13L123.54 155.46H125C125.875 155.492 126.728 155.184 127.38 154.6C127.68 154.317 127.916 153.974 128.073 153.593C128.23 153.212 128.304 152.802 128.29 152.39C128.299 151.883 128.203 151.379 128.01 150.91C127.821 150.464 127.538 150.065 127.18 149.74C126.865 149.459 126.488 149.257 126.08 149.15C125.329 149.01 124.564 148.953 123.8 148.98L121.57 149Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.21 162.93H136.69V147.49H138.21V162.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.64 155.11C144.633 154.055 144.844 153.01 145.26 152.04C146.083 150.114 147.616 148.578 149.54 147.75C150.494 147.369 151.513 147.178 152.54 147.19C153.567 147.182 154.585 147.373 155.54 147.75C157.472 148.568 159.013 150.102 159.84 152.03C160.238 153.008 160.438 154.054 160.43 155.11C160.44 156.132 160.267 157.148 159.92 158.11C159.574 159.031 159.058 159.879 158.4 160.61C157.659 161.456 156.75 162.137 155.73 162.61C154.716 163.057 153.618 163.282 152.51 163.27C151.466 163.292 150.43 163.095 149.467 162.692C148.504 162.289 147.637 161.689 146.92 160.93C146.169 160.163 145.58 159.252 145.188 158.252C144.796 157.252 144.61 156.183 144.64 155.11ZM146.22 155.11C146.197 155.981 146.348 156.848 146.664 157.66C146.98 158.472 147.455 159.213 148.06 159.84C148.636 160.462 149.338 160.955 150.119 161.286C150.9 161.617 151.742 161.778 152.59 161.76C153.425 161.772 154.252 161.606 155.018 161.273C155.783 160.94 156.469 160.448 157.03 159.83C158.238 158.545 158.889 156.833 158.84 155.07C158.85 154.229 158.691 153.394 158.371 152.616C158.052 151.837 157.579 151.131 156.98 150.54C156.402 149.929 155.704 149.445 154.929 149.118C154.155 148.791 153.321 148.628 152.48 148.64C151.777 148.637 151.078 148.762 150.42 149.01C149.752 149.256 149.132 149.619 148.59 150.08C147.854 150.707 147.26 151.484 146.85 152.36C146.441 153.227 146.226 154.172 146.22 155.13V155.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.14 149V162.92H166.64V147.49H170.78C171.522 147.472 172.264 147.543 172.99 147.7C173.639 147.851 174.245 148.146 174.765 148.563C175.284 148.98 175.703 149.509 175.99 150.11C176.346 150.821 176.531 151.605 176.53 152.4C176.553 153.525 176.173 154.62 175.46 155.49C175.14 155.898 174.738 156.235 174.28 156.478C173.822 156.721 173.317 156.865 172.8 156.9L176.53 162.9H174.73L170.15 155.46H171.61C172.483 155.498 173.335 155.189 173.98 154.6C174.285 154.32 174.525 153.978 174.686 153.596C174.846 153.215 174.923 152.804 174.91 152.39C174.914 151.883 174.819 151.38 174.63 150.91C174.441 150.462 174.154 150.062 173.79 149.74C173.477 149.457 173.099 149.254 172.69 149.15C171.939 149.01 171.174 148.953 170.41 148.98L168.14 149Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.6057 57.0261C94.0433 57.1024 92.3811 57.3458 89.7057 57.8901C88.0152 58.234 86.9928 58.4881 85.4057 58.9586C84.7457 59.1542 84.0248 59.3622 83.8037 59.4207C83.5826 59.4793 82.8064 59.7418 82.0787 60.004C81.3511 60.2663 80.6432 60.5113 80.5057 60.5485C80.2281 60.6236 79.481 60.9121 78.219 61.4316C77.7587 61.621 77.3545 61.776 77.3207 61.776C77.2868 61.776 76.6846 62.0326 75.9824 62.3461C75.2802 62.6596 74.582 62.9618 74.4307 63.0175C74.2795 63.0731 73.6701 63.3567 73.0766 63.6476C72.483 63.9384 71.9709 64.1765 71.9386 64.1765C71.9063 64.1765 71.4019 64.4261 70.8178 64.7312C70.2336 65.0363 69.6679 65.3184 69.5605 65.358C69.453 65.3975 68.8972 65.688 68.3253 66.0034C67.7533 66.3188 67.2653 66.5769 67.2409 66.5769C67.2164 66.5769 66.9059 66.7443 66.551 66.9489C66.1961 67.1536 65.6245 67.4731 65.2807 67.6589C64.937 67.8447 64.2912 68.2174 63.8456 68.487C63.4001 68.7567 63.0165 68.9773 62.9932 68.9773C62.97 68.9773 62.5615 69.2239 62.0855 69.5252C61.6094 69.8266 61.2028 70.0732 61.1817 70.0732C61.1607 70.0732 60.7637 70.3229 60.2996 70.6281C59.8355 70.9334 59.3882 71.2178 59.3057 71.2603C59.2232 71.3028 58.7569 71.6107 58.2694 71.9447L57.383 72.5518L57.3826 73.2041C57.3824 73.5629 57.4021 73.8891 57.4264 73.9291C57.4604 73.9852 57.5871 73.8959 57.9813 73.5377C58.9799 72.6306 59.107 72.5193 59.2143 72.4577C59.274 72.4234 59.5103 72.2417 59.7393 72.0539C60.2164 71.6628 60.444 71.4978 61.5666 70.7289C62.0125 70.4235 62.4513 70.1412 62.5416 70.1016C62.6319 70.062 62.9195 69.894 63.1807 69.7282C63.6936 69.4028 66.8534 67.7249 66.9534 67.7249C66.9868 67.7249 67.4622 67.5174 68.0099 67.2637C68.5576 67.0101 69.1632 66.7417 69.3557 66.6674C69.5482 66.5932 70.2457 66.3216 70.9057 66.064C71.5657 65.8064 72.2857 65.5367 72.5057 65.4648C72.7257 65.3928 73.412 65.1677 74.0307 64.9647C75.3472 64.5326 76.702 64.1243 76.8192 64.1243C76.8644 64.1243 77.3421 64.0074 77.8806 63.8647C80.5294 63.1624 82.6267 62.8488 85.583 62.7129C86.7032 62.6614 88.4337 62.711 89.3307 62.8203C89.5645 62.8487 90.0098 62.8957 90.3203 62.9245C91.3085 63.0165 92.7862 63.3826 94.0101 63.8389C94.3652 63.9713 94.7677 64.1156 94.9045 64.1596C95.1714 64.2455 96.3133 64.8283 96.6508 65.0508C96.7635 65.1251 96.9854 65.2532 97.144 65.3353C97.3025 65.4175 97.7043 65.7011 98.0369 65.9656C98.3694 66.23 98.7122 66.496 98.7986 66.5566C99.0838 66.7567 100.209 67.9499 100.644 68.5143C102.437 70.8372 103.647 73.8653 104.007 76.9341C104.099 77.716 104.112 79.3807 104.032 80.1706C103.873 81.7439 103.442 83.4064 102.815 84.8705C102.577 85.425 101.957 86.6623 101.791 86.9114C101.738 86.9924 101.566 87.2701 101.41 87.5284C101.036 88.1481 100.422 89.0082 99.807 89.776C99.2045 90.5278 97.4849 92.3194 96.8371 92.8701C95.5258 93.9849 94.2404 94.9885 93.8379 95.2119C93.7118 95.2819 93.5473 95.3847 93.4724 95.4403C93.257 95.6004 91.9189 96.4256 91.8747 96.4256C91.8528 96.4256 91.4181 96.6844 90.9087 97.0006C90.3993 97.3168 89.9315 97.5958 89.8692 97.6206C89.8068 97.6454 89.3732 97.9063 88.9057 98.2005C88.4382 98.4946 87.9657 98.7762 87.8557 98.8261C87.7457 98.8759 87.2776 99.1547 86.8154 99.4455C86.3532 99.7362 85.9591 99.9741 85.9396 99.9741C85.9201 99.9741 85.7526 100.067 85.5674 100.179L85.2307 100.385V98.3008C85.2307 97.1547 85.2139 96.2169 85.1932 96.2169C85.1094 96.2169 84.4317 96.4694 83.0807 97.0039C82.297 97.3141 81.5882 97.5842 81.5057 97.6041C81.4232 97.624 80.7587 97.8807 80.029 98.1744C79.2993 98.4682 78.5118 98.7707 78.279 98.8467C78.0462 98.9228 77.5295 99.1201 77.1307 99.2852L76.4057 99.5854V102.632V105.679L75.9942 105.901C75.7679 106.024 75.2279 106.345 74.7942 106.614C74.3606 106.883 73.8651 107.178 73.6932 107.269L73.3807 107.435L73.3809 105.91C73.3814 101.745 73.1707 73.7991 73.1385 73.7655C73.1181 73.7441 72.4989 73.9966 71.7625 74.3264C71.026 74.6563 70.3964 74.9262 70.3633 74.9262C70.3302 74.9262 69.7002 75.1962 68.9633 75.5263C68.2264 75.8563 67.5954 76.1264 67.5611 76.1264C67.5268 76.1264 67.1965 76.2628 66.8272 76.4296L66.1557 76.7328L66.1432 94.2792L66.1306 111.826L65.9017 111.931C65.7758 111.989 65.2977 112.273 64.8392 112.562C64.3808 112.85 63.9351 113.118 63.8488 113.156C63.7625 113.194 63.3125 113.464 62.8488 113.756C62.3851 114.048 61.9376 114.317 61.8543 114.354C61.771 114.39 61.2908 114.681 60.7873 114.999C60.2837 115.317 59.8516 115.577 59.827 115.577C59.8024 115.577 59.3783 115.835 58.8845 116.151C58.3906 116.467 57.9459 116.74 57.8962 116.758C57.7677 116.805 55.9775 117.991 56.0002 118.015C56.0549 118.072 56.7513 117.751 57.9807 117.101C60.5322 115.753 62.0555 114.94 62.1057 114.9C62.1332 114.879 62.3582 114.756 62.6057 114.629C62.8532 114.502 63.607 114.113 64.2807 113.766C65.4502 113.162 66.0549 112.863 66.1068 112.863C66.12 112.863 66.1307 118.183 66.1307 124.684V136.505L66.7932 136.159C67.1576 135.969 67.5907 135.744 67.7557 135.66C68.1546 135.456 69.5416 134.728 70.6557 134.137C71.1507 133.874 71.6542 133.612 71.7745 133.554C72.2578 133.323 73.4592 132.678 73.5115 132.622C73.5526 132.578 73.5501 130.151 73.5021 123.43C73.4662 118.408 73.4354 113.158 73.4338 111.765L73.4307 109.232L74.3182 108.78C74.8063 108.532 75.262 108.313 75.3307 108.293C75.3995 108.273 75.6775 108.142 75.9485 108C76.2195 107.859 76.4481 107.75 76.4566 107.759C76.465 107.768 76.5192 111.31 76.5769 115.629L76.6817 123.483L76.8278 124.142C77.2026 125.835 77.8698 127.612 78.6592 129.021C78.9597 129.558 79.8144 130.848 79.9752 131.009C80.0263 131.06 80.2189 131.289 80.4033 131.519C80.7329 131.929 81.9857 133.193 82.2307 133.363C82.2995 133.411 82.6404 133.673 82.9883 133.945C83.764 134.553 85.6213 135.672 86.1498 135.85C86.2631 135.888 86.6032 136.029 86.9057 136.163C87.7226 136.524 88.8336 136.911 89.4557 137.051C89.7582 137.119 90.2532 137.234 90.5557 137.308C91.3214 137.494 92.7677 137.708 93.3057 137.714C93.8594 137.72 94.9781 137.513 95.9307 137.228C96.302 137.116 96.6348 137.025 96.6704 137.025C96.8112 137.023 97.745 136.629 98.4557 136.27C98.8682 136.062 99.2957 135.848 99.4057 135.794C99.5157 135.74 99.9523 135.455 100.376 135.16C100.799 134.865 101.157 134.624 101.171 134.624C101.184 134.624 101.299 134.537 101.426 134.43C102.957 133.145 104.262 131.778 105.318 130.353C105.832 129.661 106.592 128.514 106.881 127.996C107.001 127.781 107.125 127.57 107.158 127.527C107.287 127.357 107.982 125.948 108.278 125.257C108.451 124.855 108.699 124.28 108.83 123.978C110.676 119.744 111.756 115.504 112.158 110.906C112.267 109.653 112.307 106.963 112.236 105.688C112.062 102.608 111.614 99.8482 110.847 97.1301C110.442 95.6944 109.748 93.7643 109.638 93.7643C109.562 93.7643 108.803 94.2149 108.077 94.6912C107.677 94.9541 107.306 95.186 107.252 95.2066C107.199 95.2273 106.748 95.5099 106.249 95.8349C105.75 96.1598 105.325 96.4256 105.303 96.4256C105.227 96.4256 103.481 97.5854 103.481 97.6363C103.481 97.6648 103.581 98.1848 103.703 98.7919C104.403 102.268 104.716 105.005 104.832 108.654C105.013 114.4 104.269 120.17 102.697 125.205C101.657 128.535 100.328 130.664 98.4958 131.938C98.2704 132.095 98.0733 132.223 98.0579 132.223C98.0424 132.223 97.7908 132.33 97.4986 132.46C96.4232 132.939 95.5956 133.085 94.1722 133.044C92.8895 133.008 92.0309 132.846 90.0807 132.274C89.3624 132.063 88.1333 131.291 87.5738 130.699C86.5475 129.614 85.8885 128.28 85.5535 126.61C85.4223 125.956 85.4169 125.861 85.3795 123.561C85.3582 122.255 85.327 117.441 85.3101 112.863C85.2932 108.286 85.2672 104.282 85.2524 103.966L85.2255 103.392L86.1722 102.883C86.693 102.603 87.1449 102.375 87.1765 102.375C87.2082 102.375 87.7256 102.104 88.3265 101.774C88.9273 101.444 89.4426 101.174 89.4716 101.174C89.5006 101.174 89.9477 100.936 90.4651 100.645C90.9824 100.354 91.5469 100.05 91.7194 99.9684C91.8918 99.8873 92.3866 99.6167 92.8189 99.3672C93.2512 99.1177 93.7175 98.8614 93.8553 98.7977C93.993 98.734 94.5034 98.4453 94.9895 98.1562C95.4755 97.8671 95.9538 97.5954 96.0523 97.5524C96.1509 97.5094 96.5857 97.2574 97.0186 96.9922C97.4515 96.7271 97.907 96.4587 98.0307 96.3958C98.1545 96.3329 98.6382 96.041 99.1057 95.7472C99.5732 95.4535 100.007 95.1927 100.07 95.1679C100.132 95.143 100.526 94.8952 100.944 94.6172C101.363 94.3392 101.798 94.063 101.911 94.0033C102.164 93.8696 103.46 93.0107 104.346 92.3887C104.709 92.1344 105.103 91.8644 105.223 91.7886C105.342 91.7129 105.792 91.3906 106.223 91.0726C106.653 90.7546 107.062 90.4636 107.131 90.426C107.199 90.3884 107.545 90.1247 107.899 89.8399C108.253 89.555 108.59 89.2942 108.648 89.2602C108.707 89.2261 108.991 88.9995 109.28 88.7566C109.569 88.5137 109.952 88.2009 110.131 88.0615C111.69 86.8451 114.598 83.9402 115.713 82.4836C115.874 82.2734 116.023 82.0935 116.043 82.084C116.1 82.0577 116.92 80.8771 117.219 80.3901C117.364 80.1546 117.542 79.8679 117.614 79.7531C117.686 79.6383 117.899 79.2448 118.088 78.8786C119.685 75.7757 120.042 72.7199 119.149 69.8044C118.961 69.1908 118.454 67.9482 118.265 67.6364C118.199 67.5272 118.039 67.25 117.909 67.0204C117.608 66.4872 117.023 65.6378 116.483 64.9501C115.96 64.2845 114.636 62.8988 113.923 62.2711C113.251 61.6793 112.069 60.7763 111.637 60.5237C111.455 60.4174 111.092 60.1971 110.831 60.0341C110.225 59.6559 109.856 59.4661 108.806 58.992C107.905 58.5854 107.017 58.2464 106.481 58.1042C106.302 58.0568 105.728 57.9031 105.206 57.7626C104.141 57.4765 103.169 57.2826 102.027 57.1284C101.375 57.0406 100.883 57.0213 98.8557 57.0045C97.5357 56.9936 96.0732 57.0033 95.6057 57.0261ZM169.903 85.569C169.067 85.7921 168.509 86.116 167.889 86.7387C167.392 87.2373 166.962 88.0172 166.774 88.7636C166.619 89.3774 166.619 90.3759 166.774 90.9897C166.977 91.7956 167.407 92.5472 167.984 93.1045C168.484 93.5879 168.967 93.8884 169.54 94.0722C170.3 94.3166 170.564 94.3546 171.293 94.3253C171.877 94.3018 172.024 94.276 172.531 94.1074C173.216 93.8795 173.648 93.6236 174.148 93.1497C174.722 92.6052 175.174 91.8347 175.41 90.9986C175.487 90.7259 175.505 90.5009 175.503 89.8506C175.5 89.108 175.489 89.0054 175.36 88.5982C175.094 87.7597 174.716 87.1446 174.12 86.5814C173.549 86.0414 173.05 85.7678 172.284 85.5743C171.419 85.356 170.707 85.3545 169.903 85.569ZM172.008 86.3549C172.224 86.4126 172.627 86.5762 172.903 86.7185C173.471 87.0105 173.817 87.3355 174.199 87.9358C174.487 88.3879 174.623 88.7607 174.721 89.3738C174.891 90.4358 174.565 91.4817 173.792 92.3573C173.449 92.7458 172.957 93.0595 172.281 93.3216C171.783 93.5143 170.844 93.5634 170.258 93.4274C169.686 93.2944 168.828 92.8301 168.476 92.4628C167.778 91.735 167.431 90.8748 167.431 89.8767C167.431 88.8171 167.884 87.7903 168.647 87.1199C168.944 86.8591 169.765 86.4453 170.206 86.3342C170.665 86.2186 171.535 86.2286 172.008 86.3549ZM169.131 89.925V92.3554H169.531H169.931V91.3045V90.2536L170.311 90.2896C170.835 90.3392 171.045 90.438 171.249 90.7301C171.456 91.0276 171.93 91.8328 172.076 92.1336L172.183 92.3554H172.681H173.18L172.987 92.0292C172.448 91.1153 172.078 90.5875 171.83 90.3816C171.638 90.2225 171.594 90.1637 171.666 90.1637C171.847 90.1637 172.374 89.8485 172.522 89.6517C172.761 89.3338 172.831 89.1467 172.83 88.8226C172.828 88.4313 172.706 88.154 172.417 87.8886C172.055 87.5561 171.966 87.5391 170.468 87.5157L169.131 87.4948V89.925ZM171.64 88.29C171.863 88.4088 171.981 88.6198 171.981 88.9016C171.981 89.3702 171.678 89.523 170.655 89.5715L169.931 89.6059V88.8599V88.114L170.691 88.1517C171.292 88.1815 171.491 88.2105 171.64 88.29ZM130.939 93.1644C130.044 93.3416 129.258 93.5379 128.406 93.7969C127.993 93.9223 127.619 94.0249 127.574 94.025C127.448 94.0253 126.13 94.5503 125.365 94.9051C124.985 95.0813 124.651 95.2254 124.623 95.2254C124.556 95.2254 123.854 95.6196 123.181 96.0347C122.892 96.2127 122.582 96.3953 122.493 96.4405C122.403 96.4856 122.069 96.718 121.75 96.9568C121.432 97.1957 121.04 97.485 120.879 97.5998C120.188 98.0932 118.414 99.8356 117.744 100.679C117.538 100.937 117.342 101.172 117.307 101.201C117.212 101.281 116.514 102.283 116.146 102.87C115.965 103.157 115.757 103.486 115.683 103.601C115.078 104.533 114.155 106.624 113.759 107.958L113.627 108.402L113.775 119.438C113.856 125.509 113.911 130.486 113.898 130.5C113.885 130.514 113.465 130.542 112.965 130.562C112.465 130.582 111.909 130.613 111.731 130.632C111.012 130.706 109.845 130.873 109.656 130.927C109.456 130.986 109.456 130.986 109.594 131.026C109.67 131.049 110.674 131.096 111.824 131.133L113.915 131.199L113.948 132.685C113.966 133.502 113.981 134.715 113.981 135.381C113.981 136.046 113.995 136.839 114.013 137.144L114.046 137.697L114.392 137.374C114.582 137.196 115.785 136.007 117.064 134.732C118.343 133.457 119.449 132.367 119.523 132.31C119.596 132.253 119.883 131.974 120.161 131.689L120.666 131.171L122.036 131.123C122.789 131.097 124.171 131.053 125.106 131.025C128.054 130.936 132.077 130.618 135.681 130.188C138.135 129.895 138.709 129.828 139.12 129.785L139.533 129.742L139.687 130.265C140.173 131.925 140.555 132.992 141.022 133.997C141.33 134.66 141.85 135.607 142.085 135.932C142.156 136.03 142.334 136.287 142.481 136.502C142.76 136.91 143.754 138.101 143.922 138.229C143.975 138.27 144.267 138.535 144.571 138.819C144.875 139.102 145.202 139.384 145.298 139.445C145.393 139.505 145.76 139.757 146.114 140.005C146.847 140.519 146.813 140.499 147.781 140.982C148.606 141.394 149.339 141.706 149.705 141.8C149.843 141.836 150.31 141.973 150.743 142.105C154.218 143.164 158.731 143.318 163.731 142.55C164.671 142.406 165.306 142.289 167.256 141.903C168.382 141.68 169.656 141.371 170.898 141.018C171.535 140.837 172.179 140.662 172.331 140.63C172.482 140.597 172.707 140.537 172.831 140.498C176.104 139.442 176.965 139.147 178.261 138.642C178.758 138.447 179.242 138.271 179.335 138.249C179.428 138.228 180 138 180.605 137.742C181.21 137.485 181.897 137.204 182.131 137.117C182.364 137.031 182.983 136.761 183.506 136.517C184.028 136.272 184.636 135.997 184.856 135.904C185.076 135.812 185.351 135.685 185.468 135.622L185.681 135.509L185.68 135.131C185.679 134.924 185.663 134.727 185.642 134.695C185.589 134.609 185.339 134.663 183.856 135.08C182.544 135.448 181.163 135.795 180.381 135.953C180.147 136 179.258 136.187 178.406 136.37C176.065 136.87 174.036 137.175 171.281 137.441C167.785 137.779 164.059 137.69 161.431 137.207C161.197 137.164 160.814 137.104 160.581 137.074C159.947 136.993 158.676 136.647 157.606 136.264C157.083 136.077 156.573 135.902 156.472 135.875C156.227 135.809 155.111 135.273 154.584 134.968C154.352 134.834 154.064 134.679 153.944 134.624C153.825 134.569 153.441 134.319 153.091 134.069C152.742 133.819 152.354 133.544 152.231 133.457C151.435 132.902 149.881 131.302 149.14 130.275C148.59 129.513 147.87 128.368 147.894 128.292C147.908 128.25 150.177 127.671 150.931 127.517C151.839 127.332 154.824 126.452 156.581 125.851C158.721 125.12 159.284 124.904 161.356 124.028C161.576 123.935 161.868 123.813 162.006 123.756C162.654 123.49 164.676 122.456 165.519 121.96C165.829 121.778 166.246 121.539 166.447 121.43C166.647 121.32 167.112 121.025 167.481 120.773C167.85 120.521 168.198 120.296 168.254 120.273C168.31 120.251 168.637 120.014 168.981 119.747C169.324 119.48 169.714 119.187 169.846 119.095C170.216 118.838 171.181 117.968 171.896 117.247C173.833 115.291 174.985 113.269 175.389 111.117C175.552 110.246 175.542 109.002 175.363 108.104C174.926 105.909 173.826 103.925 171.922 101.9C171.244 101.179 170.299 100.289 169.906 100.002C169.786 99.9151 169.422 99.6299 169.097 99.3686C168.772 99.1074 168.43 98.8529 168.337 98.8031C168.245 98.7533 168.065 98.6349 167.937 98.54C167.559 98.2585 166.747 97.7359 166.363 97.5279C166.167 97.4212 165.643 97.1296 165.201 96.8798C164.758 96.63 164.368 96.4256 164.333 96.4256C164.299 96.4256 163.947 96.2722 163.55 96.0846C162.601 95.6358 161.902 95.3523 161.381 95.2041C161.147 95.1377 160.676 94.9971 160.333 94.8917C159.026 94.4892 157.714 94.2975 156.915 94.3923C156.451 94.4473 155.983 94.5829 154.931 94.9679C153.82 95.374 153.736 95.4107 152.506 96.0228C151.281 96.6322 150.05 97.3604 149.031 98.0785C148.687 98.3206 148.299 98.5937 148.168 98.6854C148.037 98.7771 147.69 99.0518 147.398 99.2957C147.105 99.5397 146.777 99.8097 146.669 99.8958C145.917 100.492 144.319 102.14 143.406 103.26C142.327 104.583 141.113 106.516 140.407 108.036C139.114 110.821 138.408 113.478 138.099 116.725C137.993 117.836 137.979 120.544 138.073 121.682C138.239 123.683 138.598 125.985 139.013 127.702C139.081 127.985 139.13 128.223 139.121 128.231C139.091 128.26 136.499 128.625 135.931 128.68C135.614 128.71 134.681 128.815 133.856 128.912C128.91 129.495 126.704 129.707 122.893 129.965L121.531 130.058L121.532 115.629C121.533 106.805 121.552 101.052 121.581 100.818C121.608 100.607 121.676 100.347 121.734 100.24C121.857 100.012 122.261 99.7623 122.681 99.6558C123.059 99.5598 124.329 99.5736 124.913 99.6801C125.399 99.7688 126.145 100.003 126.432 100.157C127.022 100.474 127.919 101.246 128.333 101.794C128.499 102.013 128.697 102.274 128.774 102.375C128.998 102.666 129.465 103.502 129.736 104.097C129.874 104.398 130.009 104.689 130.038 104.743C130.156 104.967 130.649 106.47 130.83 107.161C131.021 107.886 131.281 109.11 131.281 109.283C131.281 109.354 132.217 110.354 132.325 110.398C132.343 110.405 132.572 110.227 132.835 110.001C133.097 109.775 133.355 109.566 133.408 109.536C133.462 109.506 133.798 109.231 134.156 108.925C134.513 108.619 134.839 108.354 134.879 108.336C134.92 108.318 135.263 108.044 135.641 107.726C136.854 106.709 137.519 106.163 137.804 105.949C138.07 105.749 138.422 105.461 139.979 104.166C140.364 103.846 140.708 103.574 140.742 103.562C140.847 103.525 140.803 102.779 140.659 102.14C140.177 100.014 139.116 97.7358 137.821 96.0499C137.197 95.2375 136.222 94.3094 135.675 94.0068C134.847 93.5493 134.628 93.4415 134.284 93.3218C133.607 93.0867 133.262 93.0353 132.381 93.0389C131.735 93.0415 131.422 93.0688 130.939 93.1644ZM153.431 98.2707C153.747 98.3426 154.231 98.4746 154.506 98.5639C154.781 98.6532 155.118 98.7568 155.256 98.7939C155.833 98.9502 158.036 100.022 159.104 100.666C159.49 100.899 159.885 101.13 159.981 101.179C160.078 101.229 160.393 101.46 160.681 101.693C160.97 101.926 161.329 102.214 161.481 102.334C162.209 102.907 163.832 104.554 164.531 105.428C164.737 105.686 164.923 105.905 164.943 105.914C165.009 105.945 165.843 107.164 166.193 107.741C167.366 109.673 167.945 111.402 168.015 113.172C168.084 114.946 167.547 116.681 166.463 118.186C166.077 118.721 165.028 119.873 164.656 120.169C164.53 120.269 164.306 120.451 164.158 120.572C163.751 120.907 162.915 121.526 162.87 121.526C162.848 121.526 162.576 121.684 162.267 121.878C161.558 122.321 161.077 122.572 160.001 123.062C158.964 123.534 158.193 123.857 157.942 123.924C157.84 123.951 157.126 124.197 156.356 124.47C155.586 124.743 154.787 125.006 154.581 125.055C154.374 125.103 153.891 125.234 153.506 125.346C152.473 125.644 150.089 126.259 149.803 126.3C149.667 126.32 149.035 126.451 148.398 126.592C147.762 126.733 147.227 126.848 147.209 126.848C147.124 126.848 146.56 125.354 146.262 124.344C145.806 122.795 145.512 121.199 145.296 119.099C145.173 117.902 145.174 114.139 145.297 112.733C145.637 108.874 146.367 105.191 147.43 101.975C147.922 100.487 148.357 99.6654 148.96 99.0863C149.306 98.7544 150.152 98.3243 150.709 98.1977C151.351 98.0515 152.616 98.0854 153.431 98.2707Z"
  })));
};

var PageSideBarMenuGroup = function PageSideBarMenuGroup(_ref) {
  var to = _ref.to,
    matchPath = _ref.matchPath,
    _ref$exact = _ref.exact,
    exact = _ref$exact === void 0 ? false : _ref$exact,
    iconName = _ref.iconName,
    children = _ref.children,
    className = _ref.className,
    title = _ref.title;
  var isActive = useRouteMatch({
    path: matchPath || to,
    exact: exact
  }) !== null;
  var _useState = useState(isActive),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(['hover:text-black hover:bg-gray-50 m-0 group border-l-4', 'focus:outline-none focus:text-black focus:bg-gray-50', !isActive && 'text-gray-500 border-transparent', isActive && 'bg-gray-50 text-black  border-primary-600'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement(Link, {
    to: to
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: clsx('flex items-center w-full px-10 py-4 text-sm leading-5 font-medium', 'focus:outline-none', 'transition-all ease-in-out duration-300', className)
  }, /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    className: clsx('mr-2 group-focus:text-gray-500 group-hover:text-primary-600', isActive && 'text-primary-600 group-focus:text-primary-600')
  }), title)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    },
    className: clsx(['transform transition-transform absolute top-1/2 right-2 -translate-y-1/2', 'focus:outline-none', isActive ? 'text-black' : 'text-gray-500', isOpen && 'rotate-180'])
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-down",
    color: ""
  }))), isOpen && children);
};

var PageSideBarMenuGroupItem = function PageSideBarMenuGroupItem(_ref) {
  var to = _ref.to,
    _ref$exact = _ref.exact,
    exact = _ref$exact === void 0 ? false : _ref$exact,
    children = _ref.children,
    className = _ref.className;
  var isActive = useRouteMatch({
    path: to,
    exact: exact
  }) !== null;
  return /*#__PURE__*/React.createElement(Link, {
    to: to
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: clsx('group w-full flex items-center px-10 py-4 text-sm leading-5 font-medium', 'hover:text-black', 'focus:outline-none focus:text-black', 'transition-all ease-in-out duration-300', isActive ? 'text-black' : 'text-gray-500', className)
  }, /*#__PURE__*/React.createElement("span", {
    className: "pl-8"
  }, children)));
};

var READ_PRODUCTS$2 = PERMISSION_READ_PRODUCTS,
  READ_ORDERS$2 = PERMISSION_READ_ORDERS,
  READ_USERS$2 = PERMISSION_READ_USERS,
  READ_CUSTOMERS$1 = PERMISSION_READ_CUSTOMERS,
  READ_SETTINGS$1 = PERMISSION_READ_SETTINGS;
var PageSideBar = function PageSideBar(_ref) {
  var currentUser = _ref.currentUser,
    onLogout = _ref.onLogout;
  return /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex md:flex-shrink-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-64"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-0 flex-1 border-r border-gray-200 bg-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-1 flex flex-col pt-5 pb-4 overflow-y-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-20 mx-auto mb-12"
  }, /*#__PURE__*/React.createElement(Logo, null)), /*#__PURE__*/React.createElement("nav", {
    className: "flex-1 bg-white"
  }, /*#__PURE__*/React.createElement(HasPermission, {
    type: READ_ORDERS$2
  }, /*#__PURE__*/React.createElement(PageSideBarMenuItem, {
    to: "/",
    iconName: "order",
    exact: true
  }, "Orders")), /*#__PURE__*/React.createElement(HasPermission, {
    type: READ_CUSTOMERS$1
  }, /*#__PURE__*/React.createElement(PageSideBarMenuItem, {
    to: "/customers",
    iconName: "users"
  }, "Customers")), /*#__PURE__*/React.createElement(HasPermission, {
    type: READ_PRODUCTS$2
  }, /*#__PURE__*/React.createElement(PageSideBarMenuGroup, {
    title: "Products",
    iconName: "product",
    to: "/products",
    matchPath: ['/products', '/categories']
  }, /*#__PURE__*/React.createElement(PageSideBarMenuGroupItem, {
    to: "/products",
    exact: "true"
  }, "All products"), /*#__PURE__*/React.createElement(PageSideBarMenuGroupItem, {
    to: "/categories"
  }, "Categories"))), /*#__PURE__*/React.createElement(HasPermission, {
    type: READ_SETTINGS$1
  }, /*#__PURE__*/React.createElement(PageSideBarMenuGroup, {
    title: "Settings",
    iconName: "settings",
    to: "/settings"
  }, /*#__PURE__*/React.createElement(PageSideBarMenuGroupItem, {
    to: "/settings",
    exact: "true"
  }, "General"), /*#__PURE__*/React.createElement(HasPermission, {
    type: READ_USERS$2
  }, /*#__PURE__*/React.createElement(PageSideBarMenuGroupItem, {
    to: "/settings/users"
  }, "Users")))))), /*#__PURE__*/React.createElement("div", {
    className: "p-3"
  }, /*#__PURE__*/React.createElement(PageSideBarUserDropdown, {
    currentUser: currentUser,
    onLogout: onLogout
  })))));
};

var PageSideBarWithState = function PageSideBarWithState() {
  var _useAppState = useAppState(),
    _useAppState$currentU = _useAppState.currentUser,
    currentUser = _useAppState$currentU === void 0 ? {} : _useAppState$currentU,
    logout = _useAppState.logout;
  return /*#__PURE__*/React.createElement(PageSideBar, {
    currentUser: currentUser,
    onLogout: logout
  });
};

var _excluded$e = ["language", "size"];
var NL = function NL() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M24 20C24 20.5525 23.5525 21 23 21H1C0.4475 21 0 20.5525 0 20V15H24V20Z",
    fill: "#21468C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 9H0V15H24V9Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 9H0V4C0 3.4475 0.4475 3 1 3H23C23.5525 3 24 3.4475 24 4V9Z",
    fill: "#AE1C27"
  }));
};
var UK = function UK() {
  return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23 3H1C0.734784 3 0.48043 3.10536 0.292893 3.29289C0.105357 3.48043 0 3.73478 0 4L0 20C0 20.2652 0.105357 20.5196 0.292893 20.7071C0.48043 20.8946 0.734784 21 1 21H23C23.2652 21 23.5196 20.8946 23.7071 20.7071C23.8946 20.5196 24 20.2652 24 20V4C24 3.73478 23.8946 3.48043 23.7071 3.29289C23.5196 3.10536 23.2652 3 23 3Z",
    fill: "#002781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 4C24 3.73478 23.8946 3.48043 23.7071 3.29289C23.5196 3.10536 23.2652 3 23 3H20.4195L14 7.938V3H10V7.938L3.5805 3H1C0.734784 3 0.48043 3.10536 0.292893 3.29289C0.105357 3.48043 0 3.73478 0 4L0 5.293L6.1195 10H0V14H6.1195L0 18.7075V20C0 20.2652 0.105357 20.5196 0.292893 20.7071C0.48043 20.8946 0.734784 21 1 21H3.5805L10 16.062V21H14V16.062L20.4195 21H23C23.2652 21 23.5196 20.8946 23.7071 20.7071C23.8946 20.5196 24 20.2652 24 20V18.7075L17.8805 14H24V10H17.8805L24 5.293V4Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 11H13V3H11V11H0V13H11V21H13V13H24V11Z",
    fill: "#D10D24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.8615L0.791 20.9775C0.859712 20.9922 0.929747 20.9997 1 21H2.193L10 14.9675V13.8615Z",
    fill: "#D10D24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.1385L23.209 3.0225C23.1403 3.00789 23.0703 3.00035 23 3H21.807L14 9.033V10.1385Z",
    fill: "#D10D24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.003 10L0.3075 3.28101C0.210319 3.37385 0.132966 3.48544 0.0801145 3.60901C0.027263 3.73259 9.42173e-06 3.8656 0 4.00001L0 4.15001L7.572 10H9.003Z",
    fill: "#D10D24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.997 14L23.6925 20.719C23.7897 20.6262 23.867 20.5146 23.9199 20.391C23.9727 20.2674 24 20.1344 24 20V19.85L16.428 14H14.997Z",
    fill: "#D10D24"
  }));
};
var FR = function FR() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M8 21H1C0.4475 21 0 20.5525 0 20V4C0 3.4475 0.4475 3 1 3H8V21Z",
    fill: "#01209F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 20C24 20.5525 23.5525 21 23 21H16V3H23C23.5525 3 24 3.4475 24 4V20Z",
    fill: "#EF4234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3H8V21H16V3Z",
    fill: "#E6E6E6"
  }));
};
var DE = function DE() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M24 9H0V4C0 3.4475 0.4475 3 1 3H23C23.5525 3 24 3.4475 24 4V9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 9H0V15H24V9Z",
    fill: "#EE0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 20C24 20.5525 23.5525 21 23 21H1C0.4475 21 0 20.5525 0 20V15H24V20Z",
    fill: "#FDCF00"
  }));
};
function Flag(_ref) {
  var language = _ref.language,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded$e);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), function () {
    switch (language) {
      case LANGUAGE_NL:
        return /*#__PURE__*/React.createElement(NL, null);
      case LANGUAGE_EN:
        return /*#__PURE__*/React.createElement(UK, null);
      case LANGUAGE_FR:
        return /*#__PURE__*/React.createElement(FR, null);
      case LANGUAGE_DE:
        return /*#__PURE__*/React.createElement(DE, null);
      default:
        return null;
    }
  }());
}

var _excluded$d = ["id", "errors", "hasError", "flagBefore", "iconNameBefore", "iconNameAfter", "className", "selectClassName"];
var FormSelect = function FormSelect(_ref) {
  var id = _ref.id,
    errors = _ref.errors,
    hasError = _ref.hasError,
    flagBefore = _ref.flagBefore,
    iconNameBefore = _ref.iconNameBefore,
    iconNameAfter = _ref.iconNameAfter,
    className = _ref.className,
    selectClassName = _ref.selectClassName,
    props = _objectWithoutProperties(_ref, _excluded$d);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx('rounded-md shadow-sm relative', className)
  }, flagBefore && /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
  }, /*#__PURE__*/React.createElement(Flag, {
    size: 20,
    language: flagBefore
  })), iconNameBefore && /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "small",
    name: iconNameBefore
  })), /*#__PURE__*/React.createElement("select", _extends({
    id: id,
    className: clsx('mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 pl-3 pr-9 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm', hasError && 'border-red-300 text-red-600 placeholder-red-300 focus:border-red-300 focus:ring-red', (iconNameBefore || flagBefore) && 'pl-9', (iconNameAfter || hasError) && 'pr-15', selectClassName)
  }, props)), (iconNameAfter || hasError) && /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "small",
    name: iconNameAfter || 'warning-circle',
    className: clsx(hasError && 'text-red-500')
  }))), /*#__PURE__*/React.createElement(FormInputErrors, {
    errors: errors
  }));
};

var Tabs$1 = function Tabs(_ref) {
  var currentTab = _ref.currentTab,
    tabs = _ref.tabs,
    onChangeTab = _ref.onChangeTab,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('mb-6', className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden sm:block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "border-b border-gray-200"
  }, /*#__PURE__*/React.createElement("nav", {
    className: "-mb-px flex space-x-8",
    "aria-label": "Tabs"
  }, tabs.map(function (_ref2) {
    var label = _ref2.label,
      value = _ref2.value,
      disabled = _ref2.disabled;
    var isActive = currentTab === value;
    return /*#__PURE__*/React.createElement("button", {
      key: value,
      type: "button",
      onClick: function onClick() {
        return !disabled && onChangeTab(value);
      },
      className: clsx([isActive && 'border-primary-500 text-primary-600 whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none', !isActive && 'border-transparent hover:border-gray-300 whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500', !isActive && !disabled && 'text-gray-500 hover:text-gray-700', disabled && 'text-gray-300 cursor-not-allowed']),
      disabled: disabled
    }, label);
  })))));
};

var UsersPage = function UsersPage(_ref) {
  var adminUsers = _ref.adminUsers,
    onResendInvitationComplete = _ref.onResendInvitationComplete,
    isFetchingMore = _ref.isFetchingMore,
    onFetchMore = _ref.onFetchMore,
    hasMoreRecords = _ref.hasMoreRecords,
    currentTab = _ref.currentTab,
    tabs = _ref.tabs,
    onChangeTab = _ref.onChangeTab;
  return /*#__PURE__*/React.createElement(PageContainer, {
    "data-testid": "UsersPage"
  }, /*#__PURE__*/React.createElement(PageSideBarWithState, null), /*#__PURE__*/React.createElement(PageContent, null, /*#__PURE__*/React.createElement(PageHeader, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Users"
    }),
    breadcrumbsItems: [{
      text: /*#__PURE__*/React.createElement(Trans, {
        id: "Users"
      }),
      to: '/settings/users'
    }],
    rightChildren: /*#__PURE__*/React.createElement(HasPermission, {
      type: PERMISSION_WRITE_USERS
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/settings/users/create"
    }, /*#__PURE__*/React.createElement(Button, {
      "data-testid": "InviteUserBtn",
      className: "btn-primary"
    }, /*#__PURE__*/React.createElement(Trans, {
      id: "Invite User"
    }))))
  }), /*#__PURE__*/React.createElement(Tabs$1, {
    className: "mb-12",
    currentTab: currentTab.value,
    tabs: tabs,
    onChangeTab: onChangeTab
  }), /*#__PURE__*/React.createElement(UsersPageTable, {
    adminUsers: adminUsers,
    onResendInvitationComplete: onResendInvitationComplete,
    isFetchingMore: isFetchingMore,
    onFetchMore: onFetchMore,
    hasMoreRecords: hasMoreRecords
  })));
};

var _templateObject$w;
var PAGE_INFO_FRAGMENT = gql(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral(["\n    fragment PageInfo on PageInfo {\n        hasNextPage\n        startCursor\n        endCursor\n    }\n"])));

var _templateObject$v;
var USERS_PAGE_QUERY = gql(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral(["\n    query usersPage($after: String, $first: Int) {\n        adminUsers(\n            after: $after,\n            first: $first\n        ) {\n            edges {\n                cursor\n                node {\n                    ...UserPageTableRowUser\n                }\n            }\n            pageInfo {\n                ...PageInfo\n            }\n        }\n    }\n    ", "\n    ", "\n"])), PAGE_INFO_FRAGMENT, USER_PAGE_TABLE_ROW);
var useUsersPageQuery = function useUsersPageQuery(first) {
  var variables = {
    first: first
  };
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFetchingMore = _useState2[0],
    setIsFetchingMore = _useState2[1];
  var _useQuery = useQuery(USERS_PAGE_QUERY, {
      variables: variables
    }),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? {} : _useQuery$data,
    error = _useQuery.error,
    loading = _useQuery.loading,
    fetchMore = _useQuery.fetchMore,
    refetch = _useQuery.refetch;
  var handleFetchMore = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var after;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsFetchingMore(true);
            after = data.adminUsers.pageInfo.endCursor;
            _context.next = 4;
            return fetchMore({
              variables: {
                after: after
              },
              updateQuery: function updateQuery(previousResult, _ref2) {
                var fetchMoreResult = _ref2.fetchMoreResult;
                setIsFetchingMore(false);
                return mergeQueryResults(previousResult, fetchMoreResult, 'adminUsers');
              }
            });
          case 4:
            setIsFetchingMore(false);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleFetchMore() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    error: error,
    adminUsers: connectionToCollection(data.adminUsers),
    isFetching: loading,
    isFetchingMore: isFetchingMore,
    refetch: refetch,
    handleFetchMore: handleFetchMore,
    hasMore: !loading && !error && data.adminUsers.pageInfo.hasNextPage
  };
};

/*
* Expected payload:
* [{
*     label: t`Label`,
*     value: label,
*     disabled: true / false, (optional)
* }]
*/

var useTabs = function useTabs(tabs) {
  var _useLingui = useLingui(),
    i18n = _useLingui.i18n;
  var _useQueryParams = useQueryParams(),
    _useQueryParams$param = _useQueryParams.params.tab,
    currentTab = _useQueryParams$param === void 0 ? tabs[0].value : _useQueryParams$param,
    onChangeParam = _useQueryParams.onChangeParam;
  return {
    tabs: tabs.map(function (tab) {
      return _objectSpread2(_objectSpread2({}, tab), {}, {
        label: i18n._(tab.label)
      });
    }),
    currentTab: tabs.find(function (_ref) {
      var value = _ref.value;
      return value === currentTab;
    }),
    onChangeTab: function onChangeTab(newTab) {
      return onChangeParam('tab', newTab);
    }
  };
};

var UsersPageWithState = function UsersPageWithState() {
  var _useUsersPageQuery = useUsersPageQuery(),
    adminUsers = _useUsersPageQuery.adminUsers,
    refetch = _useUsersPageQuery.refetch,
    isFetchingMore = _useUsersPageQuery.isFetchingMore,
    handleFetchMore = _useUsersPageQuery.handleFetchMore,
    hasMore = _useUsersPageQuery.hasMore;
  var _useTabs = useTabs([{
      label: /*i18n*/i18n._("Active"),
      value: USERS_TAB_ACTIVE
    }, {
      label: /*i18n*/i18n._("Pending Invitations"),
      value: USERS_TAB_PENDING_INVITATIONS,
      disabled: true
    }]),
    tabs = _useTabs.tabs,
    currentTab = _useTabs.currentTab,
    onChangeTab = _useTabs.onChangeTab;
  return /*#__PURE__*/React.createElement(UsersPage, {
    adminUsers: adminUsers,
    onResendInvitationComplete: function onResendInvitationComplete() {
      refetch();
    },
    isFetchingMore: isFetchingMore,
    onFetchMore: handleFetchMore,
    hasMoreRecords: hasMore,
    currentTab: currentTab,
    tabs: tabs,
    onChangeTab: onChangeTab
  });
};

var _excluded$c = ["children"];
var FormElement$2 = function FormElement(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$c);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "col-span-4 sm:col-span-2"
  }, props), children);
};

var FormHeader = function FormHeader(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    actions = _ref.actions;
  return /*#__PURE__*/React.createElement("div", {
    className: "border-b mb-6 pb-5 px-4 sm:px-6 flex justify-between"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    id: "payment_details_heading",
    className: "text-base leading-6 font-medium text-gray-900"
  }, title), subtitle && /*#__PURE__*/React.createElement("p", {
    className: "mt-1 text-xs text-gray-500"
  }, subtitle)), typeof actions !== 'undefined' && /*#__PURE__*/React.createElement("div", null, actions));
};

var FormContainer = function FormContainer(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    actions = _ref.actions,
    _ref$onSave = _ref.onSave,
    onSave = _ref$onSave === void 0 ? null : _ref$onSave,
    children = _ref.children,
    gridClassName = _ref.gridClassName,
    saveIsDisabled = _ref.saveIsDisabled;
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-6 md:px-0 lg:col-span-9 bg-white shadow sm:rounded-md sm:overflow-hidden py-6"
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: function onSubmit(e) {
      return e.preventDefault();
    }
  }, /*#__PURE__*/React.createElement(FormHeader, {
    title: title,
    subtitle: subtitle,
    actions: actions
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx(['grid gap-6 px-4 sm:px-6', typeof gridClassName !== 'undefined' ? gridClassName : 'grid-cols-4'])
  }, children), onSave !== null && /*#__PURE__*/React.createElement("div", {
    className: "px-4 pt-4 text-right sm:px-6"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    disabled: saveIsDisabled,
    onClick: onSave,
    className: "btn-primary"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Save"
  })))));
};

var PermissionCheckboxItem = function PermissionCheckboxItem(_ref) {
  var permission = _ref.permission,
    _ref$checkedPermissio = _ref.checkedPermissions,
    checkedPermissions = _ref$checkedPermissio === void 0 ? [] : _ref$checkedPermissio,
    name = _ref.name,
    description = _ref.description,
    _ref$isEditable = _ref.isEditable,
    isEditable = _ref$isEditable === void 0 ? true : _ref$isEditable,
    _onChange = _ref.onChange;
  if (typeof permission === 'undefined') {
    return null;
  }
  var isChecked = checkedPermissions.find(function (type) {
    return type === permission;
  });
  var inputId = "permission-".concat(permission);
  return /*#__PURE__*/React.createElement("div", {
    className: "relative flex items-start mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center h-5"
  }, /*#__PURE__*/React.createElement("input", {
    id: inputId,
    disabled: !isEditable,
    type: "checkbox",
    checked: isChecked || false,
    onChange: function onChange(e) {
      if (isEditable) {
        _onChange(permission, e.target.checked);
      }
    },
    className: clsx('form-checkbox h-4 w-4 text-primary-600 transition duration-150 ease-in-out', isChecked && 'opacity-100')
  })), /*#__PURE__*/React.createElement("div", {
    className: "ml-3 text-sm leading-5"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: inputId,
    className: clsx('font-medium text-gray-400', isChecked && 'text-gray-700')
  }, name), /*#__PURE__*/React.createElement("p", {
    className: clsx('text-gray-400', isChecked && 'text-gray-500')
  }, description)));
};

var READ_PRODUCTS$1 = PERMISSION_READ_PRODUCTS,
  WRITE_PRODUCTS = PERMISSION_WRITE_PRODUCTS,
  READ_ORDERS$1 = PERMISSION_READ_ORDERS,
  READ_USERS$1 = PERMISSION_READ_USERS,
  WRITE_USERS$1 = PERMISSION_WRITE_USERS;
var PermissionsForm = function PermissionsForm(_ref) {
  var isEditable = _ref.isEditable,
    permissions = _ref.permissions,
    checkedPermissions = _ref.checkedPermissions,
    onChangePermission = _ref.onChangePermission;
  return /*#__PURE__*/React.createElement("div", {
    className: "opacity-60"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("fieldset", {
    className: "flex-1"
  }, /*#__PURE__*/React.createElement("legend", {
    className: "text-base font-medium text-gray-900"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Products"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement(PermissionCheckboxItem, {
    isEditable: isEditable,
    permission: permissions.find(function (permission) {
      return permission === READ_PRODUCTS$1;
    }),
    checkedPermissions: checkedPermissions,
    name: "Read Products",
    description: "User can view all products",
    onChange: onChangePermission
  }), /*#__PURE__*/React.createElement(PermissionCheckboxItem, {
    permission: permissions.find(function (permission) {
      return permission === WRITE_PRODUCTS;
    }),
    checkedPermissions: checkedPermissions,
    name: "Write Products",
    description: "User can create and update products",
    onChange: onChangePermission
  }))), /*#__PURE__*/React.createElement("fieldset", {
    className: "flex-1"
  }, /*#__PURE__*/React.createElement("legend", {
    className: "text-base font-medium text-gray-900"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Orders"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement(PermissionCheckboxItem, {
    isEditable: isEditable,
    permission: permissions.find(function (permission) {
      return permission === READ_ORDERS$1;
    }),
    checkedPermissions: checkedPermissions,
    name: "Read Orders",
    description: "User can view all orders",
    onChange: onChangePermission
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex mt-6"
  }, /*#__PURE__*/React.createElement("fieldset", {
    className: "flex-1"
  }, /*#__PURE__*/React.createElement("legend", {
    className: "text-base font-medium text-gray-900"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Users"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement(PermissionCheckboxItem, {
    isEditable: isEditable,
    permission: permissions.find(function (permission) {
      return permission === READ_USERS$1;
    }),
    checkedPermissions: checkedPermissions,
    name: "Read Users",
    description: "User can view other users",
    onChange: onChangePermission
  }), /*#__PURE__*/React.createElement(PermissionCheckboxItem, {
    isEditable: isEditable,
    permission: permissions.find(function (permission) {
      return permission === WRITE_USERS$1;
    }),
    checkedPermissions: checkedPermissions,
    name: "Write Users",
    description: "User can create and update other users",
    onChange: onChangePermission
  })))));
};

var CreateUserForm = function CreateUserForm(_ref) {
  var formState = _ref.formState,
    permissions = _ref.permissions,
    roles = _ref.roles,
    selectedRole = _ref.selectedRole,
    onCreateRole = _ref.onCreateRole,
    _ref$isCreateForm = _ref.isCreateForm,
    isCreateForm = _ref$isCreateForm === void 0 ? true : _ref$isCreateForm;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormContainer, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "User Information"
    }),
    subtitle: /*#__PURE__*/React.createElement(Trans, {
      id: "All information related to the user him or her self."
    })
  }, /*#__PURE__*/React.createElement(FormElement$2, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "First name"
    }),
    htmlFor: "firstName"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    id: "firstName",
    errors: formState.getErrorMessages('firstName')
  }, formState.getNativeInputProps('firstName'))))), /*#__PURE__*/React.createElement(FormElement$2, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Last name"
    }),
    htmlFor: "lastName"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    id: "lastName",
    errors: formState.getErrorMessages('lastName')
  }, formState.getNativeInputProps('lastName'))))), /*#__PURE__*/React.createElement(FormElement$2, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Email address"
    }),
    htmlFor: "email"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    id: "email",
    type: "email",
    errors: formState.getErrorMessages('email')
  }, formState.getNativeInputProps('email'))), isCreateForm && /*#__PURE__*/React.createElement(FormCheckbox, _extends({
    className: "mt-4",
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Send invitation email"
    })
  }, formState.getNativeInputProps('sendInvitationEmail')))))), /*#__PURE__*/React.createElement(FormContainer, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Permissions"
    })
  }, /*#__PURE__*/React.createElement(FormElement$2, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Role"
    }),
    htmlFor: "roleId"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "max-w-lg flex-grow sm:max-w-xs"
  }, /*#__PURE__*/React.createElement(FormSelect, _extends({
    id: "roleId",
    value: selectedRole.id,
    errors: formState.getErrorMessages('roleId')
  }, formState.getNativeInputProps('roleId')), roles.map(function (role) {
    return /*#__PURE__*/React.createElement("option", {
      key: role.id,
      value: role.id
    }, role.name);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "ml-4 mt-1"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onCreateRole,
    className: "btn btn-primary"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "New Role"
  })))))), /*#__PURE__*/React.createElement(FormElement$2, {
    className: "col-span-8 sm:col-span-4"
  }, /*#__PURE__*/React.createElement(PermissionsForm, {
    isEditable: false,
    permissions: permissions,
    checkedPermissions: selectedRole.permissions
  }))));
};

var UsersCreatePage = function UsersCreatePage(_ref) {
  var formState = _ref.formState,
    permissions = _ref.permissions,
    roles = _ref.roles,
    selectedRole = _ref.selectedRole,
    onCreateRole = _ref.onCreateRole,
    onSubmit = _ref.onSubmit,
    isCreatingAdminUser = _ref.isCreatingAdminUser;
  return /*#__PURE__*/React.createElement(PageContainer, {
    "data-testid": "UsersCreatePage"
  }, /*#__PURE__*/React.createElement(PageSideBarWithState, null), /*#__PURE__*/React.createElement(PageContent, null, /*#__PURE__*/React.createElement(PageHeader, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Invite User"
    }),
    breadcrumbsItems: [{
      text: /*#__PURE__*/React.createElement(Trans, {
        id: "Users"
      }),
      to: '/settings/users'
    }, {
      text: /*#__PURE__*/React.createElement(Trans, {
        id: "Invite"
      })
    }],
    rightChildren: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      "data-testid": "DoneButton",
      onClick: onSubmit,
      className: "btn btn-primary mr-4",
      loading: isCreatingAdminUser,
      disabled: isCreatingAdminUser
    }, /*#__PURE__*/React.createElement(Trans, {
      id: "Invite"
    })), /*#__PURE__*/React.createElement(Link, {
      to: "/settings/users"
    }, /*#__PURE__*/React.createElement(Button, {
      "data-testid": "CancelButton",
      className: "btn btn-white"
    }, /*#__PURE__*/React.createElement(Trans, {
      id: "Cancel"
    }))))
  }), /*#__PURE__*/React.createElement(CreateUserForm, {
    formState: formState,
    permissions: permissions,
    roles: roles,
    selectedRole: selectedRole,
    onCreateRole: onCreateRole
  })));
};

var validation$6 = createFormValidation([{
  path: 'firstName',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The first name is required"
  })
}, {
  path: 'lastName',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The last name is required"
  })
}, {
  path: 'email',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The email is required"
  })
}, {
  path: 'roleId',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "Please select a role."
  })
}]);
var useCreateUserFormState = function useCreateUserFormState() {
  return useFormState({
    firstName: '',
    lastName: '',
    email: '',
    roleId: '',
    sendInvitationEmail: false
  }, {
    validation: validation$6
  });
};

var _templateObject$u;
var USERS_CREATE_PAGE_QUERY = gql(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral(["\n    query usersCreatePage {\n        roles {\n            id\n            name\n            permissions\n        }\n        permissions\n    }\n"])));
var useUsersCreatePageQuery = function useUsersCreatePageQuery() {
  var _useQuery = useQuery(USERS_CREATE_PAGE_QUERY),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? {} : _useQuery$data,
    error = _useQuery.error,
    loading = _useQuery.loading,
    refetch = _useQuery.refetch;
  return {
    error: error,
    roles: data.roles || [],
    permissions: data.permissions || [],
    isFetching: loading,
    refetch: refetch
  };
};

var CreateRoleForm = function CreateRoleForm(_ref) {
  var permissions = _ref.permissions,
    formState = _ref.formState;
  return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Name"
    }),
    htmlFor: "roleName"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    id: "roleName",
    className: "max-w-lg",
    errors: formState.getErrorMessages('name')
  }, formState.getNativeInputProps('name')))), /*#__PURE__*/React.createElement(PermissionsForm, {
    isEditable: true,
    permissions: permissions,
    checkedPermissions: formState.values.permissions,
    onChangePermission: function onChangePermission(permission, isChecked) {
      var newPermissions = [];
      if (isChecked) {
        newPermissions = [].concat(_toConsumableArray(formState.values.permissions), [permission]);
      } else {
        newPermissions.filter(function (type) {
          return type === permission;
        });
      }
      formState.handleChange('permissions', newPermissions);
    }
  }));
};

var CreateRoleModal = function CreateRoleModal(_ref) {
  var permissions = _ref.permissions,
    formState = _ref.formState,
    isOpen = _ref.isOpen,
    onDismiss = _ref.onDismiss,
    onSubmit = _ref.onSubmit;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onDismiss: onDismiss,
    style: {
      padding: 0
    },
    className: "bg-white rounded-lg"
  }, /*#__PURE__*/React.createElement(ModalTitle, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "New Role"
    }),
    description: /*#__PURE__*/React.createElement(Trans, {
      id: "Create new role description"
    }),
    onClose: onDismiss
  }), /*#__PURE__*/React.createElement(CreateRoleForm, {
    permissions: permissions,
    formState: formState
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-10 sm:mt-10 sm:flex sm:flex-row-reverse"
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onSubmit,
    className: "btn-primary"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Create Role"
  }))), /*#__PURE__*/React.createElement("span", {
    className: "mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onDismiss,
    className: "btn-white"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Cancel"
  })))));
};

var _templateObject$t;
var CREATE_ROLE_MUTATION = gql(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral(["\n    mutation createRole($input: CreateRoleInput!) {\n        createRole(input: $input) {\n            role {\n                id\n                name\n                permissions\n            }\n        }\n    }\n"])));
var useCreateRoleMutation = function useCreateRoleMutation() {
  return useMutation(CREATE_ROLE_MUTATION);
};

var validation$5 = createFormValidation([{
  path: 'name',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The role name is required"
  })
}]);
var useCreateRoleFormState = function useCreateRoleFormState() {
  return useFormState({
    name: '',
    permissions: []
  }, {
    validation: validation$5
  });
};

var _templateObject$s;
var CREATE_ROLE_MODAL_QUERY = gql(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral(["\n    query usersCreateRoleModal {\n        permissions\n    }\n"])));
var useCreateRoleModalQuery = function useCreateRoleModalQuery(options) {
  var _useQuery = useQuery(CREATE_ROLE_MODAL_QUERY, options),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? {} : _useQuery$data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  return {
    error: error,
    permissions: data.permissions || [],
    isFetching: loading
  };
};

var CreateRoleModalWithState = function CreateRoleModalWithState(_ref) {
  var permissions = _ref.permissions,
    isOpen = _ref.isOpen,
    _onDismiss = _ref.onDismiss,
    onSuccess = _ref.onSuccess,
    onError = _ref.onError;
  var canSkipDataFetching = typeof permissions !== 'undefined';
  var query = useCreateRoleModalQuery({
    skip: canSkipDataFetching
  });
  var _useNotifications = useNotifications(),
    dispatchSuccess = _useNotifications.dispatchSuccess,
    dispatchError = _useNotifications.dispatchError;
  var formState = useCreateRoleFormState();
  var _useCreateRoleMutatio = useCreateRoleMutation(),
    _useCreateRoleMutatio2 = _slicedToArray(_useCreateRoleMutatio, 1),
    createRole = _useCreateRoleMutatio2[0];
  return /*#__PURE__*/React.createElement(CreateRoleModal, {
    permissions: permissions || query.permissions,
    isOpen: isOpen,
    formState: formState,
    onDismiss: function onDismiss() {
      formState.resetForm();
      _onDismiss();
    },
    onSubmit: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var name, input, _yield$createRole, data, message;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!formState.validate()) {
              _context.next = 19;
              break;
            }
            _context.prev = 1;
            name = formState.values.name;
            input = {
              name: name,
              permissions: formState.values.permissions
            };
            _context.next = 6;
            return createRole({
              variables: {
                input: input
              }
            });
          case 6:
            _yield$createRole = _context.sent;
            data = _yield$createRole.data;
            formState.resetForm();
            _onDismiss();
            dispatchSuccess({
              message: "New role ".concat(name, " created successfully!")
            });
            if (typeof onSuccess === 'function') {
              onSuccess(data.createRole.role);
            }
            _context.next = 19;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](1);
            message = _context.t0.graphQLErrors[0].message;
            dispatchError({
              message: message
            });
            if (typeof onError === 'function') {
              onError(_context.t0);
            }
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 14]]);
    }))
  });
};

var _templateObject$r;
var CREATE_ADMIN_USER_MUTATION = gql(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral(["\n    mutation createAdminUser($input: CreateAdminUserInput!) {\n        createAdminUser(input: $input) {\n            adminUser {\n                ...UserPageTableRowUser\n            }\n        }\n    }\n    ", "\n"])), USER_PAGE_TABLE_ROW);
var useCreateAdminUserMutation = function useCreateAdminUserMutation() {
  return useMutation(CREATE_ADMIN_USER_MUTATION, {
    update: function update(cache, _ref) {
      var newAdminUser = _ref.data.createAdminUser.adminUser;
      cache.modify({
        fields: {
          adminUsers: function adminUsers() {
            var existingAdminUsers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var newAdminUserRef = cache.writeFragment({
              data: newAdminUser,
              fragment: USER_PAGE_TABLE_ROW
            });
            return {
              edges: [].concat(_toConsumableArray(existingAdminUsers.edges), [newAdminUserRef]),
              pageInfo: existingAdminUsers.pageInfo
            };
          }
        }
      });
    }
  });
};

var useSelectedRole = function useSelectedRole(formState, roles) {
  var selectedRoleId = formState.values.roleId || null;
  useEffect(function () {
    if (selectedRoleId === null && roles.length > 0) {
      formState.handleChange('roleId', roles[0].id);
    }
  }, [roles, selectedRoleId, formState]);
  var selectedRole = roles.find(function (role) {
    return role.id === selectedRoleId;
  }) || {
    permissions: []
  };
  return selectedRole;
};
var UsersCreatePageWithState = function UsersCreatePageWithState() {
  var _useLingui = useLingui(),
    i18n = _useLingui.i18n;
  var history = useHistory();
  var formState = useCreateUserFormState();
  var _useNotifications = useNotifications(),
    dispatchSuccess = _useNotifications.dispatchSuccess,
    dispatchError = _useNotifications.dispatchError;
  var _useUsersCreatePageQu = useUsersCreatePageQuery(),
    roles = _useUsersCreatePageQu.roles,
    permissions = _useUsersCreatePageQu.permissions,
    refetch = _useUsersCreatePageQu.refetch;
  var _useCreateAdminUserMu = useCreateAdminUserMutation(),
    _useCreateAdminUserMu2 = _slicedToArray(_useCreateAdminUserMu, 2),
    creatAdminUser = _useCreateAdminUserMu2[0],
    isCreatingAdminUser = _useCreateAdminUserMu2[1].loading;
  var selectedRole = useSelectedRole(formState, roles);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    createRoleModalIsOpen = _useState2[0],
    setCreateRoleModalOpen = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CreateRoleModalWithState, {
    permissions: permissions,
    isOpen: createRoleModalIsOpen,
    onDismiss: function onDismiss() {
      return setCreateRoleModalOpen(false);
    },
    onSuccess: (/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(role) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return refetch();
            case 2:
              formState.handleChange('roleId', role.id);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }())
  }), /*#__PURE__*/React.createElement(UsersCreatePage, {
    permissions: permissions,
    roles: roles,
    selectedRole: selectedRole,
    formState: formState,
    isCreatingAdminUser: isCreatingAdminUser,
    onCreateRole: function onCreateRole() {
      return setCreateRoleModalOpen(true);
    },
    onSubmit: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var input, firstName, lastName, message;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!formState.validate()) {
              _context2.next = 15;
              break;
            }
            _context2.prev = 1;
            input = formState.values;
            firstName = input.firstName, lastName = input.lastName;
            _context2.next = 6;
            return creatAdminUser({
              variables: {
                input: input
              }
            });
          case 6:
            formState.resetForm();
            dispatchSuccess({
              message: i18n._(/*i18n*/i18n._("New user {firstName} {lastName} invited!", {
                firstName: firstName,
                lastName: lastName
              }))
            });
            history.push('/settings/users');
            _context2.next = 15;
            break;
          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](1);
            message = _context2.t0.graphQLErrors[0].message;
            dispatchError({
              message: message
            });
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 11]]);
    }))
  }));
};

var UpdateUserPage = function UpdateUserPage(_ref) {
  var adminUser = _ref.adminUser,
    permissions = _ref.permissions,
    roles = _ref.roles,
    formState = _ref.formState,
    selectedRole = _ref.selectedRole,
    onCreateRole = _ref.onCreateRole,
    isUpdatingAdminUser = _ref.isUpdatingAdminUser,
    onSubmit = _ref.onSubmit;
  return /*#__PURE__*/React.createElement(PageContainer, null, /*#__PURE__*/React.createElement(PageSideBarWithState, null), /*#__PURE__*/React.createElement(PageContent, null, /*#__PURE__*/React.createElement(PageHeader, {
    title: adminUser.fullName,
    breadcrumbsItems: [{
      text: /*#__PURE__*/React.createElement(Trans, {
        id: "Users"
      }),
      to: '/settings/users'
    }, {
      text: adminUser.fullName
    }],
    rightChildren: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      onClick: onSubmit,
      className: "btn-primary mr-4",
      loading: isUpdatingAdminUser,
      disabled: isUpdatingAdminUser
    }, /*#__PURE__*/React.createElement(Trans, {
      id: "Update"
    })), /*#__PURE__*/React.createElement(Link, {
      to: "/users"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "btn-white"
    }, /*#__PURE__*/React.createElement(Trans, {
      id: "Cancel"
    }))))
  }), /*#__PURE__*/React.createElement(CreateUserForm, {
    formState: formState,
    permissions: permissions,
    roles: roles,
    selectedRole: selectedRole,
    onCreateRole: onCreateRole,
    isCreateForm: false
  })));
};

var _templateObject$q;
var UPDATE_USER_PAGE_QUERY = gql(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral(["\n    query updateUserPageQuery($id: ID!) {\n        adminUser(id: $id) {\n            id\n            firstName\n            lastName\n            fullName\n            email\n            phone\n            status\n            role {\n                id\n            }\n        }\n        roles {\n            id\n            name\n            permissions\n        }\n        permissions\n    }\n"])));
var useUpdateUserPageQuery = function useUpdateUserPageQuery(id, options) {
  var variables = {
    id: id
  };
  var _useQuery = useQuery(UPDATE_USER_PAGE_QUERY, _objectSpread2({
      variables: variables
    }, options)),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? {} : _useQuery$data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  return {
    error: error,
    adminUser: data.adminUser || {},
    roles: data.roles || [],
    permissions: data.permissions || [],
    isFetching: loading
  };
};

var validation$4 = createFormValidation([{
  path: 'firstName',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The first name is required"
  })
}, {
  path: 'lastName',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The last name is required"
  })
}, {
  path: 'email',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The email is required"
  })
}, {
  path: 'roleId',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "Please select a role."
  })
}]);
var useUpdateUserFormState = function useUpdateUserFormState(initialValues) {
  return useFormState(_objectSpread2({
    firstName: '',
    lastName: '',
    email: '',
    roleId: ''
  }, initialValues), {
    validation: validation$4
  });
};

var _templateObject$p;
var UPDATE_ADMIN_USER_MUTATION = gql(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral(["\n    mutation updateAdminUser($userId: ID!, $input: UpdateAdminUserInput!) {\n        updateAdminUser(userId: $userId, input: $input) {\n            adminUser {\n                ...UserPageTableRowUser\n            }\n        }\n    }\n    ", "\n"])), USER_PAGE_TABLE_ROW);
var useUpdateAdminUserMutation = function useUpdateAdminUserMutation() {
  return useMutation(UPDATE_ADMIN_USER_MUTATION, {
    update: function update(cache, _ref) {
      var updatedAdminUser = _ref.data.updateAdminUser.adminUser;
      cache.modify({
        fields: {
          adminUsers: function adminUsers() {
            var existingAdminUsers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var updatedAdminUserRef = cache.writeFragment({
              data: updatedAdminUser,
              fragment: USER_PAGE_TABLE_ROW
            });
            var updatedAdminUsers = existingAdminUsers.edges.map(function (existingAdminUser) {
              if (existingAdminUser.node.__ref === updatedAdminUserRef.__ref) {
                return updatedAdminUserRef;
              }
              return existingAdminUser;
            });
            return {
              edges: updatedAdminUsers,
              pageInfo: existingAdminUsers.pageInfo
            };
          }
        }
      });
    }
  });
};

var UpdateUserPageWithState = function UpdateUserPageWithState() {
  var _useParams = useParams(),
    userId = _useParams.userId;
  var _useLingui = useLingui(),
    i18n = _useLingui.i18n;
  var history = useHistory();
  var _useUpdateUserPageQue = useUpdateUserPageQuery(userId),
    roles = _useUpdateUserPageQue.roles,
    permissions = _useUpdateUserPageQue.permissions,
    adminUser = _useUpdateUserPageQue.adminUser,
    refetch = _useUpdateUserPageQue.refetch;
  var formState = useUpdateUserFormState(adminUser);
  var _useNotifications = useNotifications(),
    dispatchSuccess = _useNotifications.dispatchSuccess,
    dispatchError = _useNotifications.dispatchError;
  var selectedRole = useSelectedRole(formState, roles);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    createRoleModalIsOpen = _useState2[0],
    setCreateRoleModalOpen = _useState2[1];
  var _useUpdateAdminUserMu = useUpdateAdminUserMutation(),
    _useUpdateAdminUserMu2 = _slicedToArray(_useUpdateAdminUserMu, 2),
    updateAdminUser = _useUpdateAdminUserMu2[0],
    isUpdatingAdminUser = _useUpdateAdminUserMu2[1].loading;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CreateRoleModalWithState, {
    permissions: permissions,
    isOpen: createRoleModalIsOpen,
    onDismiss: function onDismiss() {
      return setCreateRoleModalOpen(false);
    },
    onSuccess: (/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(role) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return refetch();
            case 2:
              formState.handleChange('roleId', role.id);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }())
  }), /*#__PURE__*/React.createElement(UpdateUserPage, {
    formState: formState,
    permissions: permissions,
    roles: roles,
    adminUser: adminUser,
    selectedRole: selectedRole,
    onCreateRole: function onCreateRole() {
      return setCreateRoleModalOpen(true);
    },
    isUpdatingAdminUser: isUpdatingAdminUser,
    onSubmit: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _formState$values, firstName, lastName, email, roleId, input, message;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!formState.validate()) {
              _context2.next = 15;
              break;
            }
            _context2.prev = 1;
            _formState$values = formState.values, firstName = _formState$values.firstName, lastName = _formState$values.lastName, email = _formState$values.email, roleId = _formState$values.roleId;
            input = {
              firstName: firstName,
              lastName: lastName,
              email: email,
              roleId: roleId
            };
            _context2.next = 6;
            return updateAdminUser({
              variables: {
                userId: userId,
                input: input
              }
            });
          case 6:
            formState.resetForm();
            dispatchSuccess({
              message: i18n._(/*i18n*/i18n._("User {firstName} {lastName} successfully updated!", {
                firstName: firstName,
                lastName: lastName
              }))
            });
            history.push('/settings/users');
            _context2.next = 15;
            break;
          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](1);
            message = _context2.t0.graphQLErrors[0].message;
            dispatchError({
              message: message
            });
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 11]]);
    }))
  }));
};

var ProfilePage = function ProfilePage(_ref) {
  var onLogout = _ref.onLogout;
  return /*#__PURE__*/React.createElement(PageContainer, null, /*#__PURE__*/React.createElement(PageSideBarWithState, null), /*#__PURE__*/React.createElement(PageContent, null, /*#__PURE__*/React.createElement(PageHeader, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Profile"
    }),
    breadcrumbsItems: [{
      text: /*#__PURE__*/React.createElement(Trans, {
        id: "Profile"
      }),
      to: '/profile'
    }]
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: onLogout,
    className: "btn-primary"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Logout"
  }))));
};

var ProfilePageWithState = function ProfilePageWithState() {
  var _useAppState = useAppState(),
    logout = _useAppState.logout;
  return /*#__PURE__*/React.createElement(ProfilePage, {
    onLogout: logout
  });
};

var TableBody = function TableBody(props) {
  return /*#__PURE__*/React.createElement("tbody", _extends({
    className: "bg-white divide-y divide-gray-200"
  }, props));
};

var ProductsPageTableHeaderRow$1 = function ProductsPageTableHeaderRow() {
  return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Title"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Updated"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Price"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null));
};

var Tag = function Tag(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'filled' : _ref$type,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    className = _ref.className,
    children = _ref.children;
  var isLight = type === 'light';
  var isFilled = type === 'filled';
  var isPrimary = color === 'primary';
  var isGreen = color === 'green';
  return /*#__PURE__*/React.createElement("span", {
    className: clsx('px-2 inline-flex text-xs leading-5 font-semibold rounded-full', isLight && isPrimary && 'bg-primary-100 primary', isLight && color === 'gray' && 'bg-gray-200 text-gray-800', isLight && color === 'red' && 'bg-red-100 text-red-800', isLight && color === 'blue' && 'bg-blue-100 text-blue-800', isLight && color === 'yellow' && 'bg-yellow-100 text-yellow-800', isLight && isGreen && 'bg-green-100 text-green-800', isFilled && 'shadow-sm', isFilled && isPrimary && 'bg-primary-600 text-white', isFilled && isGreen && 'bg-green-500 text-white', className)
  }, children);
};

var ProductPageTableRowActionButton = function ProductPageTableRowActionButton(_ref) {
  var product = _ref.product,
    isLoading = _ref.isLoading,
    canDeleteProduct = _ref.canDeleteProduct,
    onDeleteProduct = _ref.onDeleteProduct,
    isImported = _ref.isImported;
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    position: "bottom-start",
    content: function content(_ref2) {
      var close = _ref2.close;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
        to: "/products/".concat(product.slug)
      }, /*#__PURE__*/React.createElement(DropdownMenuItem, {
        disabled: isImported,
        iconName: "edit"
      }, "Edit product")), /*#__PURE__*/React.createElement(DropdownMenuItem, {
        disabled: isLoading || !canDeleteProduct,
        onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return onDeleteProduct();
              case 2:
                close();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        })),
        iconName: "bin"
      }, "Delete product"));
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "inline-flex rounded-md p-1.5 focus:outline-none transition ease-in-out duration-150 hover:bg-gray-100 focus:bg-gray-100",
    "aria-label": "Dismiss"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "group-hover:text-gray-500 group-focus:text-gray-500",
    name: "menu-dots"
  })));
};

var RemoveProductModal$1 = function RemoveProductModal(_ref) {
  var isOpen = _ref.isOpen,
    onDismiss = _ref.onDismiss,
    product = _ref.product,
    onConfirm = _ref.onConfirm,
    isRemovingProduct = _ref.isRemovingProduct;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onDismiss: onDismiss,
    style: {
      padding: 0
    },
    className: "bg-white rounded-lg"
  }, /*#__PURE__*/React.createElement(ModalTitle, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Delete product"
    }),
    description: /*#__PURE__*/React.createElement(Trans, {
      id: "Are you sure you want to delete {product}?",
      values: {
        product: product
      }
    }),
    onClose: onDismiss
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-10 sm:mt-10 sm:flex sm:flex-row-reverse"
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn-danger",
    onClick: onConfirm,
    loading: isRemovingProduct,
    disabled: isRemovingProduct
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Delete product"
  }))), /*#__PURE__*/React.createElement("span", {
    className: "mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn-white",
    onClick: onDismiss,
    loading: isRemovingProduct,
    disabled: isRemovingProduct
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Cancel"
  })))));
};

var _templateObject$o;
var REMOVE_PRODUCT_MUTATION = gql(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n    mutation deleteProduct($productId: ID!) {\n        deleteProduct(productId: $productId) {\n            product {\n                id\n            }\n        }\n    }\n"])));
var useRemoveProductMutation = function useRemoveProductMutation(productFragment) {
  return useMutation(REMOVE_PRODUCT_MUTATION, {
    update: function update(cache, _ref) {
      var removedProduct = _ref.data.deleteProduct.product;
      cache.modify({
        fields: {
          products: function products() {
            var existingProducts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var removedProductRef = cache.writeFragment({
              data: removedProduct,
              fragment: productFragment
            });
            return {
              edges: existingProducts.edges.filter(function (_ref2) {
                var __ref = _ref2.node.__ref;
                return __ref !== removedProductRef.__ref;
              }),
              pageInfo: existingProducts.pageInfo
            };
          }
        }
      });
    }
  });
};

var RemoveProductModalWithState = function RemoveProductModalWithState(_ref) {
  var isOpen = _ref.isOpen,
    onDismiss = _ref.onDismiss,
    product = _ref.product,
    productFragment = _ref.productFragment;
  var _useNotifications = useNotifications(),
    dispatchSuccess = _useNotifications.dispatchSuccess,
    dispatchError = _useNotifications.dispatchError;
  var _useRemoveProductMuta = useRemoveProductMutation(productFragment),
    _useRemoveProductMuta2 = _slicedToArray(_useRemoveProductMuta, 2),
    deleteProduct = _useRemoveProductMuta2[0],
    loading = _useRemoveProductMuta2[1].loading;
  return /*#__PURE__*/React.createElement(RemoveProductModal$1, {
    isOpen: isOpen,
    onDismiss: onDismiss,
    product: product.title,
    isRemovingProduct: loading,
    onConfirm: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _ref3, message;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return deleteProduct({
              variables: {
                productId: product.id
              }
            });
          case 3:
            dispatchSuccess({
              message: /*#__PURE__*/React.createElement(Trans, {
                id: "{0} successfully deleted.",
                values: {
                  "0": product.name
                }
              })
            });
            _context.next = 10;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            _ref3 = _context.t0.graphQLErrors[0] || {}, message = _ref3.message;
            dispatchError({
              message: message
            });
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    }))
  });
};

function ProductPageTableRowActionButtonWithState(_ref) {
  var product = _ref.product,
    productFragment = _ref.productFragment;
  var _usePermissions = usePermissions(),
    canWriteProducts = _usePermissions.canWriteProducts;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isRemoveProductModalOpen = _useState2[0],
    setIsRemoveProductModalOpen = _useState2[1];
  var isImported = product.importId !== null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProductPageTableRowActionButton, {
    product: product,
    isImported: isImported,
    canDeleteProduct: canWriteProducts && !isImported,
    onDeleteProduct: function onDeleteProduct() {
      return setIsRemoveProductModalOpen(true);
    }
  }), /*#__PURE__*/React.createElement(RemoveProductModalWithState, {
    product: product,
    productFragment: productFragment,
    isOpen: isRemoveProductModalOpen,
    onDismiss: function onDismiss() {
      return setIsRemoveProductModalOpen(false);
    }
  }));
}

var _templateObject$n;
var PRODUCT_PAGE_TABLE_ROW = gql(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n    fragment ProductPageTableRowProduct on Product {\n        id\n        slug\n        title\n        price\n        updatedAt\n        importId\n        featuredImage {\n            id\n            url\n        }\n    }\n"])));
var ProductsPageTableRow = function ProductsPageTableRow(_ref) {
  var product = _ref.product;
  var id = product.id,
    title = product.title,
    slug = product.slug,
    price = product.price,
    updatedAt = product.updatedAt,
    importId = product.importId,
    featuredImage = product.featuredImage;
  return /*#__PURE__*/React.createElement("tr", {
    "data-testid": "ProductsPageTableRow",
    "data-id": id
  }, /*#__PURE__*/React.createElement(TableCell, {
    className: "font-medium"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(Avatar, {
    iconName: "product",
    imageUrl: featuredImage && featuredImage.url,
    className: "mr-4"
  }), /*#__PURE__*/React.createElement(Link, {
    "data-testid": "LinkToProductDetailPage",
    to: "/products/".concat(slug)
  }, title))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Tag, null, importId && /*#__PURE__*/React.createElement(Trans, {
    id: "Imported"
  }))), /*#__PURE__*/React.createElement(TableCell, null, formatDate(new Date(updatedAt))), /*#__PURE__*/React.createElement(TableCell, null, priceHelper(price)), /*#__PURE__*/React.createElement(TableCell, {
    className: "text-right"
  }, /*#__PURE__*/React.createElement(ProductPageTableRowActionButtonWithState, {
    product: product,
    productFragment: PRODUCT_PAGE_TABLE_ROW
  })));
};

var ProductsPageTable = function ProductsPageTable(_ref) {
  var _ref$products = _ref.products,
    products = _ref$products === void 0 ? [] : _ref$products,
    isFetchingMore = _ref.isFetchingMore,
    onFetchMore = _ref.onFetchMore,
    hasMoreRecords = _ref.hasMoreRecords;
  return /*#__PURE__*/React.createElement(InfiniteScroll, {
    isFetchingMore: isFetchingMore,
    onFetchMore: onFetchMore,
    hasMoreRecords: hasMoreRecords
  }, /*#__PURE__*/React.createElement(Table, {
    "data-testid": "ProductsPageTable"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement(ProductsPageTableHeaderRow$1, null)), /*#__PURE__*/React.createElement(TableBody, null, products.map(function (product) {
    return /*#__PURE__*/React.createElement(ProductsPageTableRow, {
      key: product.id,
      product: product
    });
  }))));
};

var useTranslatedConstants = (function () {
  var _useLingui = useLingui(),
    i18n = _useLingui.i18n;
  return {
    languages: _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, LANGUAGE_NL, i18n._(/*i18n*/i18n._("Dutch (nl)"))), LANGUAGE_EN, i18n._(/*i18n*/i18n._("English (en)"))), LANGUAGE_FR, i18n._(/*i18n*/i18n._("French (fr)"))), LANGUAGE_DE, i18n._(/*i18n*/i18n._("German (de)"))),
    currencies: _defineProperty(_defineProperty({}, CURRENCY_UNIT_EUR, i18n._(/*i18n*/i18n._("Euro (EUR)"))), CURRENCY_UNIT_USD, i18n._(/*i18n*/i18n._("Dollar (USD)")))
  };
});

var FormElement$1 = function FormElement(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-span-4 sm:col-span-1"
  }, children);
};
var RemoveProductModal = function RemoveProductModal(_ref2) {
  var isOpen = _ref2.isOpen,
    onDismiss = _ref2.onDismiss,
    onConfirm = _ref2.onConfirm,
    isRemovingProduct = _ref2.isRemovingProduct,
    formState = _ref2.formState;
  var values = formState.values,
    handleChange = formState.handleChange,
    getErrorMessages = formState.getErrorMessages,
    getNativeInputProps = formState.getNativeInputProps;
  var _useAppState = useAppState(),
    defaultLanguage = _useAppState.store;
  var _useTranslatedConstan = useTranslatedConstants(),
    translatedLanguages = _useTranslatedConstan.languages;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onDismiss: onDismiss,
    style: {
      padding: 0
    },
    className: "bg-white rounded-lg",
    size: MEDIUM
  }, /*#__PURE__*/React.createElement(ModalTitle, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Create product"
    }),
    onClose: onDismiss
  }), /*#__PURE__*/React.createElement("form", {
    className: "grid gap-6 grid-cols-2",
    onSubmit: function onSubmit(e) {
      e.preventDefault();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-span-2"
  }, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement("span", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement(Trans, {
      id: "Name"
    }), /*#__PURE__*/React.createElement("span", {
      className: "ml-4 flex items-center font-normal text-xs text-gray-500"
    }, /*#__PURE__*/React.createElement(Flag, {
      language: defaultLanguage,
      className: "mr-1 opacity-70",
      size: 15
    }), translatedLanguages[defaultLanguage])),
    htmlFor: "title"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    name: "title",
    id: "title",
    errors: getErrorMessages('title')
  }, getNativeInputProps('title'))))), /*#__PURE__*/React.createElement(FormElement$1, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Sku"
    }),
    htmlFor: "sku"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    name: "sku",
    id: "sku",
    errors: getErrorMessages('sku')
  }, getNativeInputProps('sku'))))), /*#__PURE__*/React.createElement(FormElement$1, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Price"
    }),
    htmlFor: "price"
  }, /*#__PURE__*/React.createElement(FormInput, {
    name: "price",
    id: "price",
    type: "number",
    errors: getErrorMessages('price'),
    value: values.price,
    min: 0,
    max: 99999.99,
    step: 0.01,
    onChange: function onChange(_ref3) {
      var target = _ref3.target;
      return handleChange('price', parseFloat(target.value));
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "mt-10 sm:mt-10 sm:flex sm:flex-row-reverse"
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn-primary",
    onClick: onConfirm,
    loading: isRemovingProduct,
    disabled: isRemovingProduct,
    type: "submit"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Save"
  }))), /*#__PURE__*/React.createElement("span", {
    className: "mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn-white",
    onClick: onDismiss,
    loading: isRemovingProduct,
    disabled: isRemovingProduct
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Cancel"
  }))))));
};

var _templateObject$m;
var CREATE_PRODUCT_MUTATION = gql(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n    mutation createProduct($input: CreateProductInput!) {\n        createProduct(input: $input) {\n            product {\n                id\n                slug\n            }\n        }\n    }\n"])));
var useCreateProductMutation = function useCreateProductMutation(options) {
  return useMutation(CREATE_PRODUCT_MUTATION, options);
};

var _excluded$b = ["shippingSettings"];
var INITIAL_FORM_STATE = {
  title: '',
  sku: '',
  price: 0
};
var validation$3 = createFormValidation([{
  path: 'title',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "Please fill in a valid name."
  })
}, {
  path: 'sku',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "Please fill in a valid sku."
  })
}, {
  path: 'price',
  validate: function validate(price) {
    return isGreaterOrEqualThan(0)(price);
  },
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "Please fill in a valid price."
  })
}]);
var valuesToInput$2 = function valuesToInput(_ref) {
  _ref.shippingSettings;
    var values = _objectWithoutProperties(_ref, _excluded$b);
  return _objectSpread2({
    price: Math.round(values.price * 100)
  }, values);
};
var useCreateProductFormState = function useCreateProductFormState(initialFormState) {
  return useFormState(initialFormState || INITIAL_FORM_STATE, {
    validation: validation$3,
    valuesToInput: valuesToInput$2
  });
};

var _excluded$a = ["price"];
var CreateProductModalWithState = function CreateProductModalWithState(_ref) {
  var isOpen = _ref.isOpen,
    onDismiss = _ref.onDismiss,
    onCreateCompleted = _ref.onCreateCompleted;
  var history = useHistory();
  var _useNotifications = useNotifications(),
    dispatchError = _useNotifications.dispatchError;
  var formState = useCreateProductFormState();
  var _useCreateProductMuta = useCreateProductMutation({
      onCompleted: onCreateCompleted
    }),
    _useCreateProductMuta2 = _slicedToArray(_useCreateProductMuta, 2),
    createProduct = _useCreateProductMuta2[0],
    isCreatingProduct = _useCreateProductMuta2[1].loading;
  return /*#__PURE__*/React.createElement(RemoveProductModal, {
    isOpen: isOpen,
    onDismiss: onDismiss,
    isCreatingProduct: isCreatingProduct,
    onConfirm: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _formState$valuesToIn, price, rest, input, variables, response, product, _ref3, message;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!formState.validate()) {
              _context.next = 16;
              break;
            }
            _context.prev = 1;
            _formState$valuesToIn = formState.valuesToInput(), price = _formState$valuesToIn.price, rest = _objectWithoutProperties(_formState$valuesToIn, _excluded$a);
            input = _objectSpread2({
              price: parseInt(price, 10) * 100
            }, rest);
            variables = {
              input: input
            };
            _context.next = 7;
            return createProduct({
              variables: variables
            });
          case 7:
            response = _context.sent;
            product = response.data.createProduct.product;
            history.push("/products/".concat(product.slug));
            _context.next = 16;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            _ref3 = _context.t0.graphQLErrors[0] || {}, message = _ref3.message;
            dispatchError({
              message: message
            });
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 12]]);
    })),
    formState: formState
  });
};

var ProductsPage = function ProductsPage(_ref) {
  var products = _ref.products,
    isFetchingMore = _ref.isFetchingMore,
    onFetchMore = _ref.onFetchMore,
    hasMoreRecords = _ref.hasMoreRecords,
    currentTab = _ref.currentTab,
    tabs = _ref.tabs,
    onChangeTab = _ref.onChangeTab,
    createProductModalIsOpen = _ref.createProductModalIsOpen,
    onDismissCreateProduct = _ref.onDismissCreateProduct,
    onCreateProduct = _ref.onCreateProduct;
  return /*#__PURE__*/React.createElement(PageContainer, {
    "data-testid": "ProductsPage"
  }, /*#__PURE__*/React.createElement(PageSideBarWithState, null), /*#__PURE__*/React.createElement(PageContent, null, /*#__PURE__*/React.createElement(PageHeader, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Products"
    }),
    breadcrumbsItems: [{
      text: /*#__PURE__*/React.createElement(Trans, {
        id: "Products"
      }),
      to: '/products'
    }],
    rightChildren: /*#__PURE__*/React.createElement(HasPermission, {
      type: PERMISSION_WRITE_PRODUCTS
    }, /*#__PURE__*/React.createElement(Button, {
      className: "btn-primary",
      onClick: onCreateProduct
    }, /*#__PURE__*/React.createElement(Trans, {
      id: "Create new product"
    })))
  }), /*#__PURE__*/React.createElement(Tabs$1, {
    className: "mb-12",
    currentTab: currentTab.value,
    tabs: tabs,
    onChangeTab: onChangeTab
  }), /*#__PURE__*/React.createElement(ProductsPageTable, {
    products: products,
    isFetchingMore: isFetchingMore,
    onFetchMore: onFetchMore,
    hasMoreRecords: hasMoreRecords
  }), /*#__PURE__*/React.createElement(CreateProductModalWithState, {
    isOpen: createProductModalIsOpen,
    onDismiss: onDismissCreateProduct
  })));
};

var _templateObject$l;
var PRODUCTS_PAGE_QUERY = gql(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n    query productsPage($after: String, $first: Int) {\n        products(\n            after: $after,\n            first: $first\n        ) {\n            edges {\n                cursor\n                node {\n                    ...ProductPageTableRowProduct\n                }\n            }\n            pageInfo {\n                ...PageInfo\n            }\n        }\n    }\n    ", "\n    ", "\n"])), PAGE_INFO_FRAGMENT, PRODUCT_PAGE_TABLE_ROW);
var useProductsPageQuery = function useProductsPageQuery(first) {
  var variables = {
    first: first
  };
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFetchingMore = _useState2[0],
    setIsFetchingMore = _useState2[1];
  var _useQuery = useQuery(PRODUCTS_PAGE_QUERY, {
      variables: variables,
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first'
    }),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? {} : _useQuery$data,
    error = _useQuery.error,
    loading = _useQuery.loading,
    fetchMore = _useQuery.fetchMore,
    refetch = _useQuery.refetch;
  var handleFetchMore = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var after;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsFetchingMore(true);
            after = data.products.pageInfo.endCursor;
            _context.next = 4;
            return fetchMore({
              variables: {
                after: after
              },
              updateQuery: function updateQuery(previousResult, _ref2) {
                var fetchMoreResult = _ref2.fetchMoreResult;
                setIsFetchingMore(false);
                return mergeQueryResults(previousResult, fetchMoreResult, 'products');
              }
            });
          case 4:
            setIsFetchingMore(false);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleFetchMore() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    error: error,
    products: connectionToCollection(data.products),
    store: data.store,
    isFetching: loading,
    isFetchingMore: isFetchingMore,
    refetch: refetch,
    handleFetchMore: handleFetchMore,
    hasMore: !loading && !error && data.products.pageInfo.hasNextPage
  };
};

var ProductsPageWithState = function ProductsPageWithState() {
  var _useProductsPageQuery = useProductsPageQuery(),
    products = _useProductsPageQuery.products,
    isFetchingMore = _useProductsPageQuery.isFetchingMore,
    handleFetchMore = _useProductsPageQuery.handleFetchMore,
    hasMore = _useProductsPageQuery.hasMore;
  var _useTabs = useTabs([{
      label: /*i18n*/i18n._("All Products"),
      value: PRODUCTS_TAB_ALL
    }]),
    tabs = _useTabs.tabs,
    currentTab = _useTabs.currentTab,
    onChangeTab = _useTabs.onChangeTab;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    createProductModalIsOpen = _useState2[0],
    setCreateProductModalIsOpen = _useState2[1];
  return /*#__PURE__*/React.createElement(ProductsPage, {
    products: products,
    isFetchingMore: isFetchingMore,
    onFetchMore: handleFetchMore,
    hasMoreRecords: hasMore,
    tabs: tabs,
    currentTab: currentTab,
    onChangeTab: onChangeTab,
    createProductModalIsOpen: createProductModalIsOpen,
    onDismissCreateProduct: function onDismissCreateProduct() {
      return setCreateProductModalIsOpen(false);
    },
    onCreateProduct: function onCreateProduct() {
      return setCreateProductModalIsOpen(true);
    }
  });
};

var _excluded$9 = ["onChange", "onSearch"];
var SearchBox = function SearchBox(_ref) {
  var _onChange = _ref.onChange,
    onSearch = _ref.onSearch,
    props = _objectWithoutProperties(_ref, _excluded$9);
  return /*#__PURE__*/React.createElement(FormInput, _extends({
    onChange: function onChange(_ref2) {
      var target = _ref2.target;
      return _onChange(target.value);
    },
    onKeyDown: function onKeyDown(_ref3) {
      var key = _ref3.key;
      if (key === 'Enter') {
        onSearch();
      }
    }
  }, props));
};

var OrdersPageTableHeaderRow = function OrdersPageTableHeaderRow() {
  return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Number"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Date"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Total"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Status"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null));
};

var _templateObject$k;
var ADDRESS_FRAGMENT = gql(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n    fragment Address on Address {\n        name\n        companyName\n        address\n        boxNumber\n        city\n        postalCode\n        countryCode\n        phone\n        email\n    }\n"])));

var _templateObject$j;
var ORDER_FRAGMENT = gql(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n    fragment Order on Order {\n        id\n        number,\n        status\n        subTotal\n        shippingCost\n        grandTotal\n        createdAt\n        updatedAt\n        guestId\n        billingAddressEqualsShippingAddress\n        customer {\n            fullName\n            email\n        }\n        shipping {\n            ...Address\n        }\n        billing {\n            ...Address\n        }\n        orderLines {\n            title\n            variationId\n            price\n            quantity\n            totalPrice\n            slug\n            featuredImage {\n                url\n            }\n        }\n    }\n    ", "\n"])), ADDRESS_FRAGMENT);

var _templateObject$i;
var SHIP_ORDER_MUTATION = gql(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n    mutation shipOrder($id: ID!) {\n        shipOrder(id: $id) {\n            ...Order\n        }\n    }\n    ", "\n"])), ORDER_FRAGMENT);
var useShipOrderMutation = function useShipOrderMutation() {
  return useMutation(SHIP_ORDER_MUTATION, {
    update: function update(cache, _ref) {
      var data = _ref.data;
      cache.modify({
        fields: {
          orders: function orders() {
            var existingOrders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var updatedOrderRef = cache.writeFragment({
              data: data.shipOrder,
              fragment: ORDER_FRAGMENT,
              fragmentName: 'Order'
            });
            return _objectSpread2(_objectSpread2({}, existingOrders), {}, {
              edges: [].concat(_toConsumableArray(existingOrders.edges), [updatedOrderRef])
            });
          }
        }
      });
    }
  });
};

var WarningModal = function WarningModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    title = _ref.title,
    children = _ref.children,
    confirmText = _ref.confirmText,
    onConfirm = _ref.onConfirm,
    isConfirming = _ref.isConfirming,
    dismissText = _ref.dismissText;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onDismiss: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "sm:flex sm:items-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "h-10 w-10 text-yellow-300",
    name: "warning-circle"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-lg leading-6 font-medium text-gray-900",
    id: "modal-headline"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "mt-2"
  }, children))), /*#__PURE__*/React.createElement("div", {
    className: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm bg-yellow-600 hover:bg-yellow-400 focus:ring-yellow-200",
    onClick: onConfirm,
    loading: isConfirming
  }, confirmText), /*#__PURE__*/React.createElement(Button, {
    className: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm",
    onClick: onClose
  }, dismissText)));
};

var useShipOrder = function useShipOrder() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    orderId = _useState2[0],
    setOrderId = _useState2[1];
  var _usePermissions = usePermissions(),
    canWriteOrders = _usePermissions.canWriteOrders;
  var _useNotifications = useNotifications(),
    dispatchSuccess = _useNotifications.dispatchSuccess,
    dispatchError = _useNotifications.dispatchError;
  var _useShipOrderMutation = useShipOrderMutation(),
    _useShipOrderMutation2 = _slicedToArray(_useShipOrderMutation, 2),
    shipOrder = _useShipOrderMutation2[0],
    isShippingOrder = _useShipOrderMutation2[1].loading;
  var handleShipOrder = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var variables, _ref2, message;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            variables = {
              id: orderId
            };
            _context.next = 4;
            return shipOrder({
              variables: variables
            });
          case 4:
            dispatchSuccess({
              message: /*#__PURE__*/React.createElement(Trans, {
                id: "Order with ID <0>{orderId}</0> is shipped.",
                values: {
                  orderId: orderId
                },
                components: {
                  "0": /*#__PURE__*/React.createElement("strong", null)
                }
              })
            });
            _context.next = 11;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            _ref2 = _context.t0.graphQLErrors[0] || {}, message = _ref2.message;
            dispatchError({
              message: message
            });
          case 11:
            _context.prev = 11;
            setOrderId(null);
            return _context.finish(11);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7, 11, 14]]);
    }));
    return function handleShipOrder() {
      return _ref.apply(this, arguments);
    };
  }();
  var confirmationModal = orderId !== null ? /*#__PURE__*/React.createElement(WarningModal, {
    isOpen: true,
    onClose: function onClose() {
      return setOrderId(null);
    },
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Ship order"
    }),
    dismissText: /*#__PURE__*/React.createElement(Trans, {
      id: "Cancel"
    }),
    confirmText: /*#__PURE__*/React.createElement(Trans, {
      id: "Ship"
    }),
    onConfirm: handleShipOrder,
    isConfirming: isShippingOrder
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-sm text-gray-500"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Trans, {
    id: "The order status will be set to shipped and the customer will be able to see this in their account. A follow-up email with the track-and-trace code has to be sent manually."
  })), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Trans, {
    id: "Do you want to continue?"
  })))) : null;
  return {
    hasShippingPermission: canWriteOrders,
    shipOrder: setOrderId,
    isShippingOrder: isShippingOrder,
    confirmationModal: confirmationModal
  };
};

var PAID = ORDER_STATUS_PAID;
var OrdersPageTableRowActionButton = function OrdersPageTableRowActionButton(_ref) {
  var order = _ref.order,
    isLoading = _ref.isLoading,
    canAdjustOrder = _ref.canAdjustOrder,
    onShipOrder = _ref.onShipOrder;
  var shippedStatuses = [PAID];
  var orderCanBeShipped = shippedStatuses.includes(order.status);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownMenu, {
    position: "bottom-start",
    content: function content(_ref2) {
      var close = _ref2.close;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownMenuItem, {
        disabled: isLoading || !orderCanBeShipped || !canAdjustOrder,
        onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return onShipOrder();
              case 2:
                close();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        })),
        iconName: "delivery-truck"
      }, /*#__PURE__*/React.createElement(Trans, {
        id: "Ship order"
      })));
    }
  }, /*#__PURE__*/React.createElement("button", {
    disabled: isLoading,
    type: "button",
    className: "inline-flex rounded-md p-1.5 focus:outline-none transition ease-in-out duration-150 hover:bg-gray-100 focus:bg-gray-100",
    "aria-label": "Dismiss"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "group-hover:text-gray-500 group-focus:text-gray-500",
    name: "menu-dots"
  }))));
};

var OrdersPageTableRowActionButtonWithState = function OrdersPageTableRowActionButtonWithState(_ref) {
  var order = _ref.order;
  var _useShipOrder = useShipOrder(),
    hasShippingPermission = _useShipOrder.hasShippingPermission,
    shipOrder = _useShipOrder.shipOrder,
    isShippingOrder = _useShipOrder.isShippingOrder,
    confirmationModal = _useShipOrder.confirmationModal;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OrdersPageTableRowActionButton, {
    isLoading: isShippingOrder,
    order: order,
    canAdjustOrder: hasShippingPermission,
    onShipOrder: function onShipOrder() {
      return shipOrder(order.id);
    }
  }), confirmationModal);
};

var OrdersPageTableRow = function OrdersPageTableRow(_ref) {
  var order = _ref.order;
  var id = order.id,
    number = order.number,
    status = order.status,
    grandTotal = order.grandTotal,
    createdAt = order.createdAt;
  return /*#__PURE__*/React.createElement("tr", {
    "data-testid": "OrdersPageTableRow"
  }, /*#__PURE__*/React.createElement(TableCell, {
    className: "font-medium"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/orders/".concat(id)
  }, number)), /*#__PURE__*/React.createElement(TableCell, null, formatDate(new Date(createdAt))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("span", {
    className: "text-gray-900 font-medium"
  }, priceHelper(grandTotal)), " EUR"), /*#__PURE__*/React.createElement(TableCell, null, status), /*#__PURE__*/React.createElement(TableCell, {
    hasText: false,
    className: "text-right"
  }, /*#__PURE__*/React.createElement(OrdersPageTableRowActionButtonWithState, {
    order: order
  })));
};

var OrdersPageTable = function OrdersPageTable(_ref) {
  var _ref$orders = _ref.orders,
    orders = _ref$orders === void 0 ? [] : _ref$orders,
    isFetchingMore = _ref.isFetchingMore,
    onFetchMore = _ref.onFetchMore,
    hasMoreRecords = _ref.hasMoreRecords;
  return /*#__PURE__*/React.createElement(InfiniteScroll, {
    isFetchingMore: isFetchingMore,
    onFetchMore: onFetchMore,
    hasMoreRecords: hasMoreRecords
  }, /*#__PURE__*/React.createElement(Table, {
    "data-testid": "OrdersPageTable"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement(OrdersPageTableHeaderRow, null)), /*#__PURE__*/React.createElement(TableBody, null, orders.map(function (order) {
    return /*#__PURE__*/React.createElement(OrdersPageTableRow, {
      key: order.id,
      order: order
    });
  }))));
};

var Loader = function Loader() {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center items-center h-10"
  }, /*#__PURE__*/React.createElement("div", null, "Loading..."));
};

var _excluded$8 = ["children"];
var EmptyList = function EmptyList(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$8);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "flex justify-center border border-gray-300 rounded-md shadow-sm"
  }, props), /*#__PURE__*/React.createElement("p", {
    className: "text-sm text-gray-500 my-24"
  }, children));
};

var OrdersPage = function OrdersPage(_ref) {
  var i18n = _ref.i18n,
    orders = _ref.orders,
    isFetching = _ref.isFetching,
    isFetchingMore = _ref.isFetchingMore,
    onFetchMore = _ref.onFetchMore,
    hasMoreRecords = _ref.hasMoreRecords,
    currentTab = _ref.currentTab,
    tabs = _ref.tabs,
    onChangeTab = _ref.onChangeTab,
    search = _ref.search,
    searchParam = _ref.searchParam,
    onChangeSearch = _ref.onChangeSearch,
    onSearch = _ref.onSearch;
  return /*#__PURE__*/React.createElement(PageContainer, {
    "data-testid": "OrdersPage"
  }, /*#__PURE__*/React.createElement(PageSideBarWithState, null), /*#__PURE__*/React.createElement(PageContent, null, /*#__PURE__*/React.createElement(PageHeader, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Orders"
    }),
    breadcrumbsItems: [{
      text: /*#__PURE__*/React.createElement(Trans, {
        id: "Orders"
      }),
      to: '/orders'
    }]
  }), /*#__PURE__*/React.createElement(Tabs$1, {
    currentTab: currentTab.value,
    tabs: tabs,
    onChangeTab: onChangeTab
  }), /*#__PURE__*/React.createElement(SearchBox, {
    placeholder: i18n._(/*i18n*/i18n._("Search orders by order number")),
    className: "my-8",
    value: search,
    onChange: onChangeSearch,
    onSearch: onSearch
  }), function () {
    if (isFetching) {
      return /*#__PURE__*/React.createElement(Loader, null);
    }
    if (orders.length > 0) {
      return /*#__PURE__*/React.createElement(OrdersPageTable, {
        orders: orders,
        isFetchingMore: isFetchingMore,
        onFetchMore: onFetchMore,
        hasMoreRecords: hasMoreRecords
      });
    }
    return /*#__PURE__*/React.createElement(EmptyList, null, /*#__PURE__*/React.createElement(Trans, {
      id: "No orders found matching \"{searchParam}\"",
      values: {
        searchParam: searchParam
      }
    }));
  }()));
};

var _templateObject$h;
var ORDERS_PAGE_QUERY = gql(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n    query ordersPage($after: String, $first: Int, $where: OrderWhereInput) {\n        orders(\n            after: $after,\n            first: $first,\n            where: $where\n        ) {\n            edges {\n                cursor\n                node {\n                    ...Order\n                }\n            }\n            pageInfo {\n                ...PageInfo\n            }\n        }\n    }\n    ", "\n    ", "\n"])), ORDER_FRAGMENT, PAGE_INFO_FRAGMENT);
var useOrdersPageQuery = function useOrdersPageQuery(where) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFetchingMore = _useState2[0],
    setIsFetchingMore = _useState2[1];
  var variables = {
    where: where
  };
  var _useQuery = useQuery(ORDERS_PAGE_QUERY, {
      variables: variables
    }),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? {} : _useQuery$data,
    error = _useQuery.error,
    loading = _useQuery.loading,
    fetchMore = _useQuery.fetchMore,
    refetch = _useQuery.refetch;
  var handleFetchMore = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var after;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsFetchingMore(true);
            after = data.orders.pageInfo.endCursor;
            _context.next = 4;
            return fetchMore({
              variables: {
                after: after
              },
              updateQuery: function updateQuery(previousResult, _ref2) {
                var fetchMoreResult = _ref2.fetchMoreResult;
                setIsFetchingMore(false);
                return mergeQueryResults(previousResult, fetchMoreResult, 'orders');
              }
            });
          case 4:
            setIsFetchingMore(false);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleFetchMore() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    error: error,
    orders: connectionToCollection(data.orders),
    isFetching: loading,
    isFetchingMore: isFetchingMore,
    refetch: refetch,
    handleFetchMore: handleFetchMore,
    hasMore: !loading && !error && data.orders.pageInfo.hasNextPage
  };
};

var composeWhere$1 = function composeWhere(currentTab, tabs, search) {
  var where = {};
  if (typeof search !== 'undefined' && search !== '') {
    where.number = search;
  }
  var tab = tabs.find(whereValue(currentTab));
  if (currentTab !== 'all' && typeof tab !== 'undefined') {
    where.status = tab.status;
  }
  return where;
};
var OrdersPageWithState = function OrdersPageWithState() {
  var _useLingui = useLingui(),
    i18n = _useLingui.i18n;
  var _useQueryParams = useQueryParams(),
    searchParam = _useQueryParams.params.search,
    onChangeParam = _useQueryParams.onChangeParam;
  var _useTabs = useTabs([{
      label: i18n._(/*i18n*/i18n._("All orders")),
      value: 'all'
    }, {
      label: i18n._(/*i18n*/i18n._("Awaiting payment")),
      value: 'unpaid',
      status: ORDER_STATUS_CREATED
    }, {
      label: i18n._(/*i18n*/i18n._("Ready to ship")),
      value: 'ready',
      status: ORDER_STATUS_PAID$1
    }]),
    tabs = _useTabs.tabs,
    currentTab = _useTabs.currentTab,
    onChangeTab = _useTabs.onChangeTab;
  var where = composeWhere$1(currentTab.value, tabs, searchParam);
  var _useState = useState(searchParam),
    _useState2 = _slicedToArray(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  var _useOrdersPageQuery = useOrdersPageQuery(where),
    orders = _useOrdersPageQuery.orders,
    isFetching = _useOrdersPageQuery.isFetching,
    isFetchingMore = _useOrdersPageQuery.isFetchingMore,
    handleFetchMore = _useOrdersPageQuery.handleFetchMore,
    hasMore = _useOrdersPageQuery.hasMore;
  return /*#__PURE__*/React.createElement(OrdersPage, {
    i18n: i18n,
    orders: orders,
    isFetching: isFetching,
    isFetchingMore: isFetchingMore,
    onFetchMore: handleFetchMore,
    hasMoreRecords: hasMore,
    currentTab: currentTab,
    tabs: tabs,
    onChangeTab: onChangeTab,
    search: search,
    searchParam: searchParam,
    onChangeSearch: setSearch,
    onSearch: function onSearch() {
      return onChangeParam('search', search);
    }
  });
};

var CustomersPageTableHeaderRow = function CustomersPageTableHeaderRow() {
  return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Customer"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Since"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Email"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Phone"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Orders"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Total Spent"
  })));
};

var _templateObject$g;
var CUSTOMER_PAGE_TABLE_ROW = gql(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n    fragment CustomerPageTableRow on Customer {\n        id\n        fullName\n        email\n        createdAt\n        ordersInfo {\n            ordersCount\n            totalSpent\n        }\n        shipping {\n            phone\n        }\n    }\n"])));
var CustomersPageTableRow = function CustomersPageTableRow(_ref) {
  var customer = _ref.customer;
  var id = customer.id,
    fullName = customer.fullName,
    email = customer.email,
    shipping = customer.shipping,
    createdAt = customer.createdAt,
    ordersInfo = customer.ordersInfo;
  return /*#__PURE__*/React.createElement("tr", {
    "data-testid": "CustomersPageTableRow"
  }, /*#__PURE__*/React.createElement(TableCell, {
    className: "font-medium"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/customers/".concat(id)
  }, fullName)), /*#__PURE__*/React.createElement(TableCell, null, formatDate(new Date(createdAt))), /*#__PURE__*/React.createElement(TableCell, null, email), /*#__PURE__*/React.createElement(TableCell, null, shipping !== null && shipping.phone), /*#__PURE__*/React.createElement(TableCell, null, ordersInfo.ordersCount), /*#__PURE__*/React.createElement(TableCell, null, priceHelper(ordersInfo.totalSpent)));
};

var CustomersPageTable = function CustomersPageTable(_ref) {
  var _ref$customers = _ref.customers,
    customers = _ref$customers === void 0 ? [] : _ref$customers,
    isFetchingMore = _ref.isFetchingMore,
    onFetchMore = _ref.onFetchMore,
    hasMoreRecords = _ref.hasMoreRecords;
  return /*#__PURE__*/React.createElement(InfiniteScroll, {
    isFetchingMore: isFetchingMore,
    onFetchMore: onFetchMore,
    hasMoreRecords: hasMoreRecords
  }, /*#__PURE__*/React.createElement(Table, {
    "data-testid": "CustomersPageTable"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement(CustomersPageTableHeaderRow, null)), /*#__PURE__*/React.createElement(TableBody, null, customers.map(function (customer) {
    return /*#__PURE__*/React.createElement(CustomersPageTableRow, {
      key: customer.id,
      customer: customer
    });
  }))));
};

var CustomersPage = function CustomersPage(_ref) {
  var i18n = _ref.i18n,
    isFetching = _ref.isFetching,
    customers = _ref.customers,
    isFetchingMore = _ref.isFetchingMore,
    onFetchMore = _ref.onFetchMore,
    hasMoreRecords = _ref.hasMoreRecords,
    search = _ref.search,
    searchParam = _ref.searchParam,
    onChangeSearch = _ref.onChangeSearch,
    onSearch = _ref.onSearch;
  return /*#__PURE__*/React.createElement(PageContainer, {
    "data-testid": "CustomersPage"
  }, /*#__PURE__*/React.createElement(PageSideBarWithState, null), /*#__PURE__*/React.createElement(PageContent, null, /*#__PURE__*/React.createElement(PageHeader, {
    title: "Customers",
    breadcrumbsItems: [{
      text: 'Customers',
      to: '/'
    }]
  }), /*#__PURE__*/React.createElement(SearchBox, {
    placeholder: i18n._(/*i18n*/i18n._("Search customers by email")),
    className: "my-8",
    value: search,
    onChange: onChangeSearch,
    onSearch: onSearch
  }), function () {
    if (isFetching) {
      return /*#__PURE__*/React.createElement(Loader, null);
    }
    if (customers.length > 0) {
      return /*#__PURE__*/React.createElement(CustomersPageTable, {
        customers: customers,
        isFetchingMore: isFetchingMore,
        onFetchMore: onFetchMore,
        hasMoreRecords: hasMoreRecords
      });
    }
    return /*#__PURE__*/React.createElement(EmptyList, null, /*#__PURE__*/React.createElement(Trans, {
      id: "No customers found with email address \"{searchParam}\"",
      values: {
        searchParam: searchParam
      }
    }));
  }()));
};

var _templateObject$f;
var CUSTOMERS_PAGE_QUERY = gql(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n    query customersPage($after: String, $first: Int, $where: CustomerWhereInput) {\n        customers(\n            after: $after,\n            first: $first,\n            where: $where\n        ) {\n            edges {\n                cursor\n                node {\n                    ...CustomerPageTableRow\n                }\n            }\n            pageInfo {\n                ...PageInfo\n            }\n        }\n    }\n    ", "\n    ", "\n"])), PAGE_INFO_FRAGMENT, CUSTOMER_PAGE_TABLE_ROW);
var useCustomersPageQuery = function useCustomersPageQuery(where) {
  var variables = {
    where: where
  };
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFetchingMore = _useState2[0],
    setIsFetchingMore = _useState2[1];
  var _useQuery = useQuery(CUSTOMERS_PAGE_QUERY, {
      variables: variables
    }),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? {} : _useQuery$data,
    error = _useQuery.error,
    loading = _useQuery.loading,
    fetchMore = _useQuery.fetchMore,
    refetch = _useQuery.refetch;
  var handleFetchMore = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var after;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsFetchingMore(true);
            after = data.customers.pageInfo.endCursor;
            _context.next = 4;
            return fetchMore({
              variables: {
                after: after
              },
              updateQuery: function updateQuery(previousResult, _ref2) {
                var fetchMoreResult = _ref2.fetchMoreResult;
                setIsFetchingMore(false);
                return mergeQueryResults(previousResult, fetchMoreResult, 'customers');
              }
            });
          case 4:
            setIsFetchingMore(false);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleFetchMore() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    error: error,
    customers: connectionToCollection(data.customers),
    isFetching: loading,
    isFetchingMore: isFetchingMore,
    refetch: refetch,
    handleFetchMore: handleFetchMore,
    hasMore: !loading && !error && data.customers.pageInfo.hasNextPage
  };
};

var composeWhere = function composeWhere(search) {
  var where = {};
  if (typeof search !== 'undefined' && search !== '') {
    where.email = search;
  }
  return where;
};
var CustomersPageWithState = function CustomersPageWithState() {
  var _useLingui = useLingui(),
    i18n = _useLingui.i18n;
  var _useQueryParams = useQueryParams(),
    searchParam = _useQueryParams.params.search,
    onChangeParam = _useQueryParams.onChangeParam;
  var where = composeWhere(searchParam);
  var _useState = useState(searchParam),
    _useState2 = _slicedToArray(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  var _useCustomersPageQuer = useCustomersPageQuery(where),
    isFetching = _useCustomersPageQuer.isFetching,
    customers = _useCustomersPageQuer.customers,
    isFetchingMore = _useCustomersPageQuer.isFetchingMore,
    handleFetchMore = _useCustomersPageQuer.handleFetchMore,
    hasMore = _useCustomersPageQuer.hasMore;
  return /*#__PURE__*/React.createElement(CustomersPage, {
    i18n: i18n,
    isFetching: isFetching,
    customers: customers,
    isFetchingMore: isFetchingMore,
    onFetchMore: handleFetchMore,
    hasMoreRecords: hasMore,
    search: search,
    searchParam: searchParam,
    onChangeSearch: setSearch,
    onSearch: function onSearch() {
      return onChangeParam('search', search);
    }
  });
};

var ShippingSettings = function ShippingSettings(_ref) {
  var formState = _ref.formState,
    countries = _ref.countries,
    onSaveSettings = _ref.onSaveSettings;
  var values = formState.values,
    handleChange = formState.handleChange,
    getErrorMessages = formState.getErrorMessages,
    getNativeInputProps = formState.getNativeInputProps;
  var shippingSettings = values.shippingSettings;
  var canAddShippingRule = shippingSettings && shippingSettings.countryRules.length < countries.length;
  var onAddShippingRule = function onAddShippingRule() {
    var countryCodes = countries.map(function (_ref2) {
      var code = _ref2.code;
      return code;
    });
    var usedCountryCodes = shippingSettings.countryRules.map(function (_ref3) {
      var countryCode = _ref3.countryCode;
      return countryCode;
    });
    var countryCode = countryCodes.find(function (code) {
      return !usedCountryCodes.includes(code);
    });
    var updatedCountryRules = [].concat(_toConsumableArray(shippingSettings.countryRules), [{
      countryCode: countryCode,
      cost: 0
    }]);
    formState.handleChange('shippingSettings.countryRules', updatedCountryRules);
  };
  var onRemoveShippingRule = function onRemoveShippingRule(code) {
    var updatedCountryRules = shippingSettings.countryRules.filter(function (_ref4) {
      var countryCode = _ref4.countryCode;
      return countryCode !== code;
    });
    formState.handleChange('shippingSettings.countryRules', updatedCountryRules);
  };
  var currencyToValue = function currencyToValue(currency) {
    return currency && currency.toString().replace(',', '.');
  };
  return /*#__PURE__*/React.createElement(FormContainer, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Shipping settings"
    }),
    onSave: onSaveSettings
  }, /*#__PURE__*/React.createElement(FormElement$2, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Free shipping from"
    }),
    htmlFor: "free_shipping"
  }, /*#__PURE__*/React.createElement(FormInput, {
    type: "number",
    name: "free_shipping",
    id: "free_shipping",
    min: 0,
    max: 99999.99,
    step: 0.01,
    errors: getErrorMessages('shippingSettings.freeShippingFromAmount'),
    value: shippingSettings && currencyToValue(shippingSettings.freeShippingFromAmount),
    onChange: function onChange(_ref5) {
      var target = _ref5.target;
      return handleChange('shippingSettings.freeShippingFromAmount', parseFloat(target.value));
    }
  }))), /*#__PURE__*/React.createElement(FormElement$2, {
    className: "col-span-8 sm:col-span-4"
  }, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Shipping rules"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-4 flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
  }, /*#__PURE__*/React.createElement(Table, {
    variant: "borderLess",
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Country"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Shipping cost"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null))), /*#__PURE__*/React.createElement(TableBody, null, shippingSettings && shippingSettings.countryRules.map(function (_ref6, index) {
    var countryCode = _ref6.countryCode,
      cost = _ref6.cost;
    return /*#__PURE__*/React.createElement("tr", {
      key: countryCode
    }, /*#__PURE__*/React.createElement(TableCell, {
      className: "align-top"
    }, /*#__PURE__*/React.createElement(FormSelect, _extends({
      disabled: !canAddShippingRule,
      name: "country_rule_code_".concat(index),
      id: "country_rule_code_".concat(index),
      errors: getErrorMessages("shippingSettings.countryRules.".concat(index, ".countryCode"))
    }, getNativeInputProps("shippingSettings.countryRules.".concat(index, ".countryCode"))), countries.map(function (country) {
      return /*#__PURE__*/React.createElement("option", {
        key: country.code,
        value: country.code
      }, country.name);
    }))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(FormInput, {
      type: "number",
      name: "country_rule_cost_".concat(index),
      id: "country_rule_cost_".concat(index),
      min: 0.01,
      max: 99999.99,
      step: 0.01,
      errors: getErrorMessages("shippingSettings.countryRules.".concat(index, ".cost")),
      value: currencyToValue(cost),
      onChange: function onChange(_ref7) {
        var target = _ref7.target;
        return handleChange("shippingSettings.countryRules.".concat(index, ".cost"), parseFloat(target.value));
      }
    })), /*#__PURE__*/React.createElement(TableCell, {
      className: "text-right"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return onRemoveShippingRule(countryCode);
      },
      className: "btn-icon"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "trash",
      className: "text-red-400"
    }))));
  }))), canAddShippingRule && /*#__PURE__*/React.createElement(Button, {
    onClick: onAddShippingRule,
    className: "btn btn-secondary"
  }, "Add shipping rule")))))));
};

var StoreDetailSettings = function StoreDetailSettings(_ref) {
  var formState = _ref.formState,
    onSaveSettings = _ref.onSaveSettings;
  var getErrorMessages = formState.getErrorMessages,
    getNativeInputProps = formState.getNativeInputProps;
  return /*#__PURE__*/React.createElement(FormContainer, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Store details"
    }),
    subtitle: /*#__PURE__*/React.createElement(Trans, {
      id: "This information is presented to your customers in store and elsewhere"
    }),
    onSave: onSaveSettings
  }, /*#__PURE__*/React.createElement(FormElement$2, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Store name"
    }),
    htmlFor: "store_name"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    name: "store_name",
    id: "store_name",
    errors: getErrorMessages('name')
  }, getNativeInputProps('name'))))), /*#__PURE__*/React.createElement(FormElement$2, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Store url"
    }),
    htmlFor: "store_url"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    name: "store_url",
    id: "store_url",
    errors: getErrorMessages('url'),
    prepend: "https://"
  }, getNativeInputProps('url'))))), /*#__PURE__*/React.createElement(FormElement$2, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Customer support email"
    }),
    htmlFor: "support_email"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    name: "support_email",
    id: "support_email",
    type: "email",
    errors: getErrorMessages('customerSupportEmail')
  }, getNativeInputProps('customerSupportEmail'))))), /*#__PURE__*/React.createElement(FormElement$2, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Customer support phone"
    }),
    htmlFor: "support_phone"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    name: "support_phone",
    id: "support_phone",
    type: "tel",
    errors: getErrorMessages('customerSupportPhone')
  }, getNativeInputProps('customerSupportPhone'))))));
};

var BusinessDetailsSettings = function BusinessDetailsSettings(_ref) {
  var formState = _ref.formState,
    countries = _ref.countries,
    onSaveSettings = _ref.onSaveSettings;
  var getErrorMessages = formState.getErrorMessages,
    getNativeInputProps = formState.getNativeInputProps;
  return /*#__PURE__*/React.createElement(FormContainer, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Business details"
    }),
    subtitle: /*#__PURE__*/React.createElement(Trans, {
      id: "This information is displayed on invoices"
    }),
    onSave: onSaveSettings
  }, /*#__PURE__*/React.createElement(FormElement$2, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Legal name"
    }),
    htmlFor: "legal_name"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    name: "legal_name",
    id: "legal_name",
    errors: getErrorMessages('legalName')
  }, getNativeInputProps('legalName'))))), /*#__PURE__*/React.createElement(FormElement$2, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "VAT number"
    }),
    htmlFor: "vat_number"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    name: "vat_number",
    id: "vat_number",
    errors: getErrorMessages('vatNumber')
  }, getNativeInputProps('vatNumber'))))), /*#__PURE__*/React.createElement("div", {
    className: "col-span-4 sm:col-span-3"
  }, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Address"
    }),
    htmlFor: "address"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    name: "address",
    id: "address",
    errors: getErrorMessages('address')
  }, getNativeInputProps('address'))))), /*#__PURE__*/React.createElement("div", {
    className: "col-span-4 sm:col-span-1"
  }, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Country code"
    }),
    htmlFor: "country_code"
  }, /*#__PURE__*/React.createElement(FormSelect, _extends({
    name: "country_code",
    id: "country_code",
    type: "select",
    errors: getErrorMessages('countryCode')
  }, getNativeInputProps('countryCode')), countries.map(function (country) {
    return /*#__PURE__*/React.createElement("option", {
      key: country.code,
      value: country.code
    }, country.name);
  })))), /*#__PURE__*/React.createElement(FormElement$2, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Order number format"
    }),
    htmlFor: "order_number_format"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    name: "order_number_format",
    id: "order_number_format",
    errors: getErrorMessages('orderNumberFormat')
  }, getNativeInputProps('orderNumberFormat'))))));
};

function LocaleActionButton(_ref) {
  var code = _ref.code,
    isDefault = _ref.isDefault,
    setAsDefault = _ref.setAsDefault,
    isActive = _ref.isActive,
    toggleActive = _ref.toggleActive;
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    position: "bottom-start",
    content: function content(_ref2) {
      var close = _ref2.close;
      return /*#__PURE__*/React.createElement(React.Fragment, null, !isDefault && isActive && /*#__PURE__*/React.createElement(DropdownMenuItem, {
        onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                setAsDefault(code);
                close();
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        })),
        iconName: "globe"
      }, /*#__PURE__*/React.createElement(Trans, {
        id: "Set as default"
      })), /*#__PURE__*/React.createElement(DropdownMenuItem, {
        disabled: isDefault,
        onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                toggleActive(code);
                close();
              case 2:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        })),
        iconName: "power"
      }, isActive ? /*#__PURE__*/React.createElement(Trans, {
        id: "Deactivate"
      }) : /*#__PURE__*/React.createElement(Trans, {
        id: "Activate"
      })), /*#__PURE__*/React.createElement(DropdownMenuItem, {
        disabled: true,
        iconName: "trash"
      }, /*#__PURE__*/React.createElement(Trans, {
        id: "Delete language"
      })));
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "inline-flex rounded-md p-1.5 focus:outline-none transition ease-in-out duration-150 hover:bg-gray-100 focus:bg-gray-100",
    "aria-label": "Dismiss"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "group-hover:text-gray-500 group-focus:text-gray-500",
    name: "menu-dots"
  })));
}

var _excluded$7 = ["value", "availableLanguages", "onChange"];
function LanguageFormSelect(_ref) {
  var value = _ref.value,
    _ref$availableLanguag = _ref.availableLanguages,
    availableLanguages = _ref$availableLanguag === void 0 ? [] : _ref$availableLanguag,
    _onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$7);
  // TODO: translate in backend
  var _useTranslatedConstan = useTranslatedConstants(),
    languages = _useTranslatedConstan.languages;
  return /*#__PURE__*/React.createElement(FormSelect, _extends({
    name: "language",
    id: "language",
    type: "select",
    value: value,
    flagBefore: value,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  }, props), availableLanguages.map(function (_ref2) {
    var code = _ref2.code;
    return /*#__PURE__*/React.createElement("option", {
      key: code,
      value: code
    }, languages[code]);
  }));
}

var getAvailableLanguages = function getAvailableLanguages() {
  var availableLanguages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var languages = arguments.length > 1 ? arguments[1] : undefined;
  return availableLanguages.map(function (code) {
    return languages.find(function (language) {
      return language.code === code;
    });
  });
};

var FormElement = function FormElement(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-span-4 sm:col-span-1"
  }, children);
};
var LocaleAndTimezoneSettings = function LocaleAndTimezoneSettings(_ref2) {
  var formState = _ref2.formState,
    languages = _ref2.languages,
    onSaveSettings = _ref2.onSaveSettings,
    onSetActive = _ref2.onSetActive;
  var values = formState.values,
    getErrorMessages = formState.getErrorMessages,
    getNativeInputProps = formState.getNativeInputProps,
    getInputProps = formState.getInputProps;
  var _useTranslatedConstan = useTranslatedConstants(),
    translatedLanguages = _useTranslatedConstan.languages;
  var availableLanguages = getAvailableLanguages(values.availableLanguages, languages);
  return /*#__PURE__*/React.createElement(FormContainer, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Locale and timezone"
    }),
    subtitle: /*#__PURE__*/React.createElement(Trans, {
      id: "This information is displayed on invoices"
    }),
    onSave: onSaveSettings,
    gridClassName: "grid-cols-3"
  }, /*#__PURE__*/React.createElement(FormElement, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Default language"
    }),
    htmlFor: "default_language"
  }, /*#__PURE__*/React.createElement(LanguageFormSelect, _extends({
    name: "default_language",
    id: "default_language",
    errors: getErrorMessages('defaultLanguage')
  }, getInputProps('defaultLanguage'), {
    availableLanguages: availableLanguages
  })))), /*#__PURE__*/React.createElement(FormElement, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Time zone"
    }),
    htmlFor: "time_zone"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    name: "time_zone",
    id: "time_zone",
    errors: getErrorMessages('timeZone')
  }, getNativeInputProps('timeZone'))))), /*#__PURE__*/React.createElement(FormElement, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Date format"
    }),
    htmlFor: "date_format"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    name: "date_format",
    id: "date_format",
    errors: getErrorMessages('dateFormat')
  }, getNativeInputProps('dateFormat'))))), /*#__PURE__*/React.createElement("div", {
    className: "col-span-4"
  }, /*#__PURE__*/React.createElement(Table, {
    variant: "borderLess"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Available languages"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Status"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null))), /*#__PURE__*/React.createElement(TableBody, null, languages.map(function (_ref3) {
    var name = _ref3.name,
      code = _ref3.code;
    var isActive = values.availableLanguages && typeof values.availableLanguages.find(function (language) {
      return language === code;
    }) !== 'undefined';
    var status = isActive ? /*#__PURE__*/React.createElement(Trans, {
      id: "Active"
    }) : /*#__PURE__*/React.createElement(Trans, {
      id: "Deactivated"
    });
    var isDefaultLanguage = code === values.defaultLanguage && isActive;
    return /*#__PURE__*/React.createElement("tr", {
      key: code
    }, /*#__PURE__*/React.createElement(TableCell, {
      className: "align-top"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement(Flag, {
      language: name,
      className: "mr-4"
    }), translatedLanguages[name])), /*#__PURE__*/React.createElement(TableCell, {
      className: isActive ? 'text-black' : 'text-gray-400'
    }, isDefaultLanguage ? /*#__PURE__*/React.createElement(Trans, {
      id: "Default"
    }) : status), /*#__PURE__*/React.createElement(TableCell, {
      className: "text-right"
    }, /*#__PURE__*/React.createElement(LocaleActionButton, {
      code: code,
      isDefault: isDefaultLanguage,
      setAsDefault: function setAsDefault() {
        return formState.handleChange('defaultLanguage', code);
      },
      isActive: isActive,
      toggleActive: onSetActive
    })));
  }))), /*#__PURE__*/React.createElement(Button, {
    className: "btn btn-secondary",
    disabled: true
  }, "Add language")));
};

var CurrencyAndWeightSettings = function CurrencyAndWeightSettings(_ref) {
  var formState = _ref.formState,
    currencyUnits = _ref.currencyUnits,
    weightUnits = _ref.weightUnits,
    onSaveSettings = _ref.onSaveSettings;
  var getErrorMessages = formState.getErrorMessages,
    getNativeInputProps = formState.getNativeInputProps;
  var _useTranslatedConstan = useTranslatedConstants(),
    currencies = _useTranslatedConstan.currencies;
  return /*#__PURE__*/React.createElement(FormContainer, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Currency and weights"
    }),
    subtitle: /*#__PURE__*/React.createElement(Trans, {
      id: "Set the base currency and weight units that orders and products will be created with. You may change currency later without affecting existing orders or products"
    }),
    onSave: onSaveSettings
  }, /*#__PURE__*/React.createElement(FormElement$2, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Currency unit"
    }),
    htmlFor: "currency_unit"
  }, /*#__PURE__*/React.createElement(FormSelect, _extends({
    name: "currency_unit",
    id: "currency_unit",
    errors: getErrorMessages('currencyUnit')
  }, getNativeInputProps('currencyUnit')), currencyUnits.map(function (currency) {
    return /*#__PURE__*/React.createElement("option", {
      key: currency,
      value: currency
    }, currencies[currency]);
  })))), /*#__PURE__*/React.createElement(FormElement$2, null, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Weight unit"
    }),
    htmlFor: "weight_unit"
  }, /*#__PURE__*/React.createElement(FormSelect, _extends({
    name: "weightUnit",
    id: "weightUnit",
    errors: getErrorMessages('weightUnit')
  }, getNativeInputProps('weightUnit')), weightUnits.map(function (weightUnit) {
    return /*#__PURE__*/React.createElement("option", {
      key: weightUnit,
      value: weightUnit
    }, weightUnit);
  })))));
};

var SettingsPage = function SettingsPage(_ref) {
  var isFetching = _ref.isFetching,
    countries = _ref.countries,
    languages = _ref.languages,
    currencyUnits = _ref.currencyUnits,
    weightUnits = _ref.weightUnits,
    formState = _ref.formState,
    onSaveSettings = _ref.onSaveSettings,
    onSetActive = _ref.onSetActive,
    currentTab = _ref.currentTab,
    tabs = _ref.tabs,
    onChangeTab = _ref.onChangeTab;
  return /*#__PURE__*/React.createElement(PageContainer, null, /*#__PURE__*/React.createElement(PageSideBarWithState, null), /*#__PURE__*/React.createElement(PageContent, null, /*#__PURE__*/React.createElement(PageHeader, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Settings"
    }),
    breadcrumbsItems: [{
      text: /*#__PURE__*/React.createElement(Trans, {
        id: "Settings"
      }),
      to: '/settings'
    }, {
      text: currentTab.label
    }]
  }), /*#__PURE__*/React.createElement(Tabs$1, {
    className: "mb-12",
    currentTab: currentTab.value,
    tabs: tabs,
    onChangeTab: onChangeTab
  }), function () {
    if (isFetching) {
      return /*#__PURE__*/React.createElement(Loader, null);
    }
    switch (currentTab.value) {
      case SETTINGS_TAB_GENERAL:
        return /*#__PURE__*/React.createElement(Fade, {
          key: SETTINGS_TAB_GENERAL
        }, /*#__PURE__*/React.createElement(StoreDetailSettings, {
          formState: formState,
          onSaveSettings: onSaveSettings
        }), /*#__PURE__*/React.createElement(BusinessDetailsSettings, {
          formState: formState,
          countries: countries,
          onSaveSettings: onSaveSettings
        }), /*#__PURE__*/React.createElement(LocaleAndTimezoneSettings, {
          formState: formState,
          languages: languages,
          onSaveSettings: onSaveSettings,
          onSetActive: onSetActive
        }), /*#__PURE__*/React.createElement(CurrencyAndWeightSettings, {
          formState: formState,
          currencyUnits: currencyUnits,
          weightUnits: weightUnits,
          onSaveSettings: onSaveSettings
        }));
      case SETTINGS_TAB_SHIPPING:
        return /*#__PURE__*/React.createElement(Fade, {
          key: SETTINGS_TAB_SHIPPING
        }, /*#__PURE__*/React.createElement(ShippingSettings, {
          formState: formState,
          countries: countries,
          onSaveSettings: onSaveSettings
        }));
      default:
        return null;
    }
  }()));
};

var _templateObject$e;
var STORE_PAGE_QUERY = gql(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n    query storePageQuery {\n        countries {\n            code\n            name\n        }\n        languages {\n            code\n            name\n        }\n        currencyUnits\n        weightUnits\n    }\n"])));
var useSettingsPageQuery = function useSettingsPageQuery(options) {
  var _useQuery = useQuery(STORE_PAGE_QUERY, _objectSpread2({}, options)),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? {} : _useQuery$data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  return {
    error: error,
    isFetching: loading,
    countries: data.countries || [],
    languages: data.languages || [],
    currencyUnits: data.currencyUnits || [],
    weightUnits: data.weightUnits || []
  };
};

var _excluded$6 = ["shippingSettings", "url"],
  _excluded2$1 = ["cost"];
var getCleanShippingSettings = function getCleanShippingSettings(shippingSettings) {
  if (typeof shippingSettings === 'undefined') {
    return {
      countryRules: []
    };
  }
  var freeShippingFromAmount = shippingSettings.freeShippingFromAmount,
    countryRules = shippingSettings.countryRules;
  return {
    freeShippingFromAmount: freeShippingFromAmount / 100,
    countryRules: countryRules.map(function (_ref) {
      var countryCode = _ref.countryCode,
        cost = _ref.cost;
      return {
        countryCode: countryCode,
        cost: cost / 100
      };
    })
  };
};
var storeToSettingsFormValues = function storeToSettingsFormValues(_ref2) {
  var name = _ref2.name,
    _ref2$url = _ref2.url,
    url = _ref2$url === void 0 ? '' : _ref2$url,
    customerSupportEmail = _ref2.customerSupportEmail,
    customerSupportPhone = _ref2.customerSupportPhone,
    legalName = _ref2.legalName,
    vatNumber = _ref2.vatNumber,
    address = _ref2.address,
    countryCode = _ref2.countryCode,
    orderNumberFormat = _ref2.orderNumberFormat,
    defaultLanguage = _ref2.defaultLanguage,
    availableLanguages = _ref2.availableLanguages,
    timeZone = _ref2.timeZone,
    dateFormat = _ref2.dateFormat,
    currencyUnit = _ref2.currencyUnit,
    weightUnit = _ref2.weightUnit,
    shippingSettings = _ref2.shippingSettings;
  return {
    name: name,
    url: url.replace('https://', ''),
    customerSupportEmail: customerSupportEmail,
    customerSupportPhone: customerSupportPhone,
    legalName: legalName,
    vatNumber: vatNumber,
    address: address,
    countryCode: countryCode,
    orderNumberFormat: orderNumberFormat,
    defaultLanguage: defaultLanguage,
    availableLanguages: availableLanguages,
    timeZone: timeZone,
    dateFormat: dateFormat,
    currencyUnit: currencyUnit,
    weightUnit: weightUnit,
    // To remove __typename from the objects, which causes issues
    shippingSettings: getCleanShippingSettings(shippingSettings)
  };
};
var validation$2 = createFormValidation([{
  path: 'name',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The store name field is required"
  })
}, {
  path: 'url',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The store url field is required"
  })
}, {
  path: 'customerSupportEmail',
  validate: isValidEmail,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The customer support email field is required"
  })
}, {
  path: 'customerSupportPhone',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The customer support phone field is required"
  })
}, {
  path: 'legalName',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The store legal name field is required"
  })
}, {
  path: 'vatNumber',
  validate: function validate(vatNumber, _ref3) {
    var countryCode = _ref3.countryCode;
    if (vatNumber) {
      var regex = VAT_REGEX_STRINGS[countryCode];
      return regex.test(vatNumber);
    }
    return true;
  },
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "Please enter a correct VAT number"
  })
}, {
  path: 'countryCode',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The country code field is required"
  })
}, {
  path: 'shippingSettings.freeShippingFromAmount',
  validate: function validate(freeShippingFromAmount) {
    return isGreaterOrEqualThan(0)(freeShippingFromAmount);
  },
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The free shipping from field has to be 0 or more"
  })
}, {
  path: 'shippingSettings.countryRules.*.cost',
  validate: function validate(cost) {
    return isGreaterOrEqualThan(0)(cost);
  },
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "The shipping cost has to be 0 or more"
  })
}]);
var valuesToInput$1 = function valuesToInput(_ref4) {
  var shippingSettings = _ref4.shippingSettings,
    url = _ref4.url,
    settings = _objectWithoutProperties(_ref4, _excluded$6);
  return _objectSpread2(_objectSpread2({
    shippingSettings: {
      freeShippingFromAmount: Math.round(shippingSettings.freeShippingFromAmount * 100),
      countryRules: shippingSettings.countryRules.map(function (_ref5) {
        var cost = _ref5.cost,
          rule = _objectWithoutProperties(_ref5, _excluded2$1);
        return _objectSpread2({
          cost: Math.round(cost * 100)
        }, rule);
      })
    }
  }, settings), {}, {
    url: "https://".concat(url)
  });
};
var useSettingsPageFormState = function useSettingsPageFormState(store, languages, options) {
  return useFormState(storeToSettingsFormValues(store), _objectSpread2({
    validation: validation$2,
    valuesToInput: valuesToInput$1
  }, options));
};

var _templateObject$d;
var UPDATE_SETTINGS_MUTATION = gql(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n    mutation updateStoreSettings($input: UpdateSettingsInput!) {\n        updateStoreSettings(input: $input) {\n            store {\n                ...StoreFragment\n            }\n        }\n    }\n    ", "\n"])), STORE_FRAGMENT);
var useUpdateSettingsMutation = function useUpdateSettingsMutation() {
  return useMutation(UPDATE_SETTINGS_MUTATION, {
    update: function update(cache, _ref) {
      var updatedStoreSettings = _ref.data.updateStoreSettings.store;
      cache.modify({
        fields: {
          store: function store() {
            return _objectSpread2({}, updatedStoreSettings);
          }
        }
      });
    }
  });
};

var SettingsPageWithState = function SettingsPageWithState() {
  var _useLingui = useLingui(),
    i18n = _useLingui.i18n;
  var _useSettingsPageQuery = useSettingsPageQuery(),
    isFetching = _useSettingsPageQuery.isFetching,
    countries = _useSettingsPageQuery.countries,
    languages = _useSettingsPageQuery.languages,
    currencyUnits = _useSettingsPageQuery.currencyUnits,
    weightUnits = _useSettingsPageQuery.weightUnits;
  var _useAppState = useAppState(),
    store = _useAppState.store;
  var formState = useSettingsPageFormState(store);
  var _useNotifications = useNotifications(),
    dispatchSuccess = _useNotifications.dispatchSuccess,
    dispatchError = _useNotifications.dispatchError;
  var _useUpdateSettingsMut = useUpdateSettingsMutation(),
    _useUpdateSettingsMut2 = _slicedToArray(_useUpdateSettingsMut, 1),
    updateStoreSettings = _useUpdateSettingsMut2[0];
  var _useTabs = useTabs([{
      label: /*i18n*/i18n._("General"),
      value: SETTINGS_TAB_GENERAL
    }, {
      label: /*i18n*/i18n._("Shipping"),
      value: SETTINGS_TAB_SHIPPING
    }, {
      label: /*i18n*/i18n._("Theme"),
      value: SETTINGS_TAB_THEME,
      disabled: true
    }]),
    tabs = _useTabs.tabs,
    currentTab = _useTabs.currentTab,
    onChangeTab = _useTabs.onChangeTab;
  return /*#__PURE__*/React.createElement(SettingsPage, {
    isFetching: isFetching,
    countries: countries,
    languages: languages,
    currencyUnits: currencyUnits,
    weightUnits: weightUnits,
    formState: formState,
    onSaveSettings: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var input, variables, message;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!formState.validate()) {
              _context.next = 13;
              break;
            }
            _context.prev = 1;
            input = formState.valuesToInput();
            variables = {
              input: input
            };
            _context.next = 6;
            return updateStoreSettings({
              variables: variables
            });
          case 6:
            dispatchSuccess({
              message: i18n._(/*i18n*/i18n._("Store settings successfully updated!"))
            });
            _context.next = 13;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            message = _context.t0.graphQLErrors[0].message;
            dispatchError({
              message: message
            });
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9]]);
    })),
    onSetActive: function onSetActive(code) {
      var values = formState.values;
      var availableLanguages = values.availableLanguages;
      var isActive = typeof availableLanguages.find(function (language) {
        return language === code;
      }) !== 'undefined';
      var updatedAvailableLanguages = isActive ? availableLanguages.filter(function (language) {
        return language !== code;
      }) : [].concat(_toConsumableArray(availableLanguages), [code]);
      formState.handleChange('availableLanguages', updatedAvailableLanguages);
    },
    currentTab: currentTab,
    tabs: tabs,
    onChangeTab: onChangeTab
  });
};

var _excluded$5 = ["className"];
var Spinner = function Spinner(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$5);
  return /*#__PURE__*/React.createElement(Icon, _extends({
    name: "spinner",
    className: clsx('animate-spin', className)
  }, props));
};

var _excluded$4 = ["children"];
var PageLoading = function PageLoading(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$4);
  return /*#__PURE__*/React.createElement(PageContainer, _extends({
    "data-testid": "PageLoading"
  }, props), /*#__PURE__*/React.createElement(PageSideBarWithState, null), /*#__PURE__*/React.createElement(PageContent, null, children, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center items-center h-96"
  }, /*#__PURE__*/React.createElement(Spinner, null))));
};

var ProductDetailPageDetailsCard = function ProductDetailPageDetailsCard(_ref) {
  var language = _ref.language,
    formState = _ref.formState,
    availableLanguages = _ref.availableLanguages,
    onLangChange = _ref.onLangChange,
    onSaveProductDetail = _ref.onSaveProductDetail,
    isReadOnly = _ref.isReadOnly;
  var values = formState.values,
    getErrorMessages = formState.getErrorMessages,
    getNativeInputProps = formState.getNativeInputProps,
    handleChange = formState.handleChange;
  return /*#__PURE__*/React.createElement(FormContainer, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Details"
    }),
    actions: /*#__PURE__*/React.createElement(LanguageFormSelect, {
      value: language,
      onChange: onLangChange,
      availableLanguages: availableLanguages
    }),
    onSave: onSaveProductDetail,
    saveIsDisabled: isReadOnly
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-span-4"
  }, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Name"
    }),
    htmlFor: "title"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    name: "title",
    id: "title",
    errors: getErrorMessages('title')
  }, getNativeInputProps('title'), {
    onChange: function onChange(e) {
      var value = e.target.value;
      handleChange('title', value);
      var slug = slugify(value);
      // Slugify if title is the same or when slug is empty
      if (slugify(values.title) === values.slug || values.slug === '') {
        handleChange('slug', slug);
      }
    },
    disabled: isReadOnly
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-span-4 sm:col-span-3"
  }, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Slug"
    }),
    htmlFor: "slug"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    name: "slug",
    id: "slug",
    errors: getErrorMessages('slug')
  }, getNativeInputProps('slug'), {
    disabled: isReadOnly
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-span-4 sm:col-span-1"
  }, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Sku"
    }),
    htmlFor: "sku"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    name: "sku",
    id: "sku",
    errors: getErrorMessages('sku')
  }, getNativeInputProps('sku'), {
    disabled: isReadOnly
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-span-4"
  }, /*#__PURE__*/React.createElement(FormGroup, {
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Description"
    }),
    htmlFor: "description"
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    as: "textarea",
    name: "description",
    id: "description",
    errors: getErrorMessages('description')
  }, getNativeInputProps('description'), {
    disabled: isReadOnly
  })))));
};

var validation$1 = createFormValidation([{
  path: 'title',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "Please fill in the name."
  })
}, {
  path: 'slug',
  validate: function validate(slug) {
    return isRequired(slug) && slug.match(/^[0-9a-z\s\-]+$/);
  },
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "Please fill in a valid slug. (only lowercase letters and - are allowed)"
  })
}, {
  path: 'sku',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "Please fill in the sku."
  })
}]);
var productToFormState = function productToFormState(values, language) {
  var sku = values.sku;
  var translatedValues = getTranslatedValues(values, language);
  return _objectSpread2({
    sku: sku
  }, translatedValues);
};
var _valuesToInput = function valuesToInput(_ref, language) {
  var title = _ref.title,
    slug = _ref.slug,
    description = _ref.description,
    sku = _ref.sku;
  return _objectSpread2(_objectSpread2({}, setTranslatedValues({
    title: title,
    slug: slug,
    description: description
  }, language)), {}, {
    sku: sku
  });
};
var useProductDetailFormState$1 = function useProductDetailFormState(product, language) {
  return useFormState(productToFormState(product, language), {
    validation: validation$1,
    valuesToInput: function valuesToInput(values) {
      return _valuesToInput(values, language);
    }
  });
};

var _templateObject$c;
var UPDATE_PRODUCT_DETAIL_MUTATION = gql(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n    mutation updateProductDetail($productId: ID!, $input: UpdateProductDetailInput!) {\n        updateProductDetail(productId: $productId, input: $input) {\n            product {\n                id\n                slug\n                translations {\n                    title\n                    slug\n                    description\n                }\n                sku\n            }\n        }\n    }\n"])));
var useUpdateProductDetailMutation = function useUpdateProductDetailMutation() {
  return useMutation(UPDATE_PRODUCT_DETAIL_MUTATION);
};

function ProductDetailPageCardWithState(_ref) {
  var product = _ref.product,
    availableLanguages = _ref.availableLanguages,
    isReadOnly = _ref.isReadOnly;
  var _useLingui = useLingui(),
    i18n = _useLingui.i18n;
  var _useAppState = useAppState(),
    defaultLanguage = _useAppState.store.defaultLanguage;
  var _useState = useState(defaultLanguage),
    _useState2 = _slicedToArray(_useState, 2),
    language = _useState2[0],
    setLanguage = _useState2[1];
  var formState = useProductDetailFormState$1(product, language);
  var _useNotifications = useNotifications(),
    dispatchSuccess = _useNotifications.dispatchSuccess,
    dispatchError = _useNotifications.dispatchError;
  var history = useHistory();
  var _useUpdateProductDeta = useUpdateProductDetailMutation(),
    _useUpdateProductDeta2 = _slicedToArray(_useUpdateProductDeta, 1),
    updateProductDetail = _useUpdateProductDeta2[0];
  return /*#__PURE__*/React.createElement(ProductDetailPageDetailsCard, {
    language: language,
    formState: formState,
    availableLanguages: availableLanguages,
    onLangChange: setLanguage,
    onSaveProductDetail: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var input, variables, newSlug, message;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!formState.validate()) {
              _context.next = 15;
              break;
            }
            _context.prev = 1;
            input = formState.valuesToInput();
            variables = {
              productId: product.id,
              input: input
            };
            _context.next = 6;
            return updateProductDetail({
              variables: variables
            });
          case 6:
            newSlug = input.slug[defaultLanguage];
            if (typeof newSlug !== 'undefined') {
              history.push("/products/".concat(input.slug[defaultLanguage]));
            }
            dispatchSuccess({
              message: i18n._(/*i18n*/i18n._("Product successfully updated!"))
            });
            _context.next = 15;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            message = _context.t0.graphQLErrors[0].message;
            dispatchError({
              message: message
            });
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 11]]);
    })),
    isReadOnly: isReadOnly
  });
}

var _templateObject$b;
var UPDATE_PRODUCT_IMAGES_MUTATION = gql(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n    mutation updateProductImages($productId: ID!, $input: UpdateProductImagesInput!) {\n        updateProductImages(productId: $productId, input: $input) {\n            product {\n                id\n            }\n        }\n    }\n"])));
var useUpdateProductImagesMutation = function useUpdateProductImagesMutation(options) {
  return useMutation(UPDATE_PRODUCT_IMAGES_MUTATION, options);
};

var _excluded$3 = ["className", "children", "loading", "disabled", "onClick"];
var ActionButton = function ActionButton(_ref) {
  var className = _ref.className;
    _ref.children;
    var loading = _ref.loading,
    disabled = _ref.disabled;
    _ref.onClick;
    var props = _objectWithoutProperties(_ref, _excluded$3);
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    className: clsx('inline-flex rounded-md p-1.5 focus:outline-none transition ease-in-out duration-150 hover:bg-gray-100 focus:bg-gray-100', className, loading && 'opacity-75', disabled && 'cursor-not-allowed')
  }, props), function () {
    return /*#__PURE__*/React.createElement(Icon, {
      className: "group-hover:text-gray-500 group-focus:text-gray-500",
      name: "menu-dots"
    });
  }());
};

var ProductDetailsPageImageActionButton = function ProductDetailsPageImageActionButton(_ref) {
  var image = _ref.image,
    isFeatured = _ref.isFeatured,
    isLoading = _ref.isLoading,
    onRemove = _ref.onRemove,
    onSetFeatured = _ref.onSetFeatured;
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    position: "bottom-start",
    content: function content(_ref2) {
      var close = _ref2.close;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownMenuItem, {
        iconName: "edit",
        disabled: isLoading || isFeatured,
        onClick: function onClick() {
          onSetFeatured(image);
          close();
        }
      }, "Make featured image"), /*#__PURE__*/React.createElement(DropdownMenuItem, {
        iconName: "bin",
        disabled: isLoading,
        onClick: function onClick() {
          onRemove(image);
          close();
        }
      }, "Remove image"));
    }
  }, /*#__PURE__*/React.createElement(ActionButton, {
    className: "absolute right-4 top-4 bg-white border border-gray-300 shadow-sm"
  }));
};

/* eslint-disable jsx-a11y/alt-text */
var ProductDetailsPageImage = function ProductDetailsPageImage(_ref) {
  var image = _ref.image,
    isNew = _ref.isNew,
    isFeatured = _ref.isFeatured,
    className = _ref.className,
    onRemove = _ref.onRemove,
    onSetFeatured = _ref.onSetFeatured,
    isDisabled = _ref.isDisabled;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('relative w-64 h-64 bg-white rounded-md overflow-hidden border mr-4 mb-4 ', isFeatured && 'border-primary-600', isNew && 'border-green-500', className)
  }, !isDisabled && /*#__PURE__*/React.createElement("div", {
    className: "absolute top-0 right-0"
  }, /*#__PURE__*/React.createElement(ProductDetailsPageImageActionButton, {
    image: image,
    isFeatured: isFeatured,
    isNew: isNew,
    onRemove: onRemove,
    onSetFeatured: onSetFeatured
  })), /*#__PURE__*/React.createElement("div", {
    className: "absolute left-4 bottom-4 flex"
  }, isNew && /*#__PURE__*/React.createElement(Tag, {
    color: "green",
    className: "mr-2"
  }, "New"), isFeatured && /*#__PURE__*/React.createElement(Tag, {
    className: "mr-2"
  }, "Featured")), /*#__PURE__*/React.createElement("img", {
    className: "w-64 h-64 object-contain",
    src: image.url
  }));
};

var _templateObject$a;
var UPLOAD_MUTATION = gql(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n    mutation upload($upload: Upload!, $fileType: FileType!) {\n        upload(upload: $upload, fileType: $fileType) {\n            id\n            url\n        }\n    }\n"])));
var useUploadDropzone = function useUploadDropzone(_ref) {
  var fileType = _ref.fileType,
    multiple = _ref.multiple,
    maxSize = _ref.maxSize,
    accept = _ref.accept,
    onUploadCompleted = _ref.onUploadCompleted,
    onUploadError = _ref.onUploadError;
  var _useMutation = useMutation(UPLOAD_MUTATION, {
      onCompleted: onUploadCompleted,
      onError: onUploadError
    }),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    uploadProductImage = _useMutation2[0],
    _useMutation2$ = _useMutation2[1],
    loading = _useMutation2$.loading,
    error = _useMutation2$.error,
    data = _useMutation2$.data;
  var onDrop = useCallback(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var _ref4, upload, variables;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref4 = _slicedToArray(_ref2, 1), upload = _ref4[0];
            variables = {
              upload: upload,
              fileType: fileType
            };
            uploadProductImage({
              variables: variables
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), []);
  var _useDropzone = useDropzone({
      multiple: multiple,
      accept: accept,
      maxSize: maxSize,
      onDrop: onDrop
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps;
  return {
    error: error,
    data: data,
    loading: loading,
    getRootProps: getRootProps,
    getInputProps: getInputProps
  };
};

var PRODUCT_IMAGE = FILE_TYPE_PRODUCT_IMAGE;
var ProductDetailsPageImageUpload = function ProductDetailsPageImageUpload(_ref) {
  var _onUploadCompleted = _ref.onUploadCompleted;
  var _useUploadDropzone = useUploadDropzone({
      fileType: PRODUCT_IMAGE,
      multiple: false,
      accept: 'image/*',
      maxSize: 5242880,
      onUploadCompleted: function onUploadCompleted(_ref2) {
        var upload = _ref2.upload;
        return _onUploadCompleted(upload);
      }
    }),
    error = _useUploadDropzone.error,
    loading = _useUploadDropzone.loading,
    getRootProps = _useUploadDropzone.getRootProps,
    getInputProps = _useUploadDropzone.getInputProps;
  var hasError = !!error;
  return /*#__PURE__*/React.createElement("div", _extends({}, getRootProps(), {
    className: clsx('block w-64 h-64 border border-dashed flex items-center justify-center rounded-lg  cursor-pointer hover:border-solid hover:bg-gray-50 focus:outline-none', !hasError && 'border-primary-600', hasError && 'border-red-500')
  }), /*#__PURE__*/React.createElement("input", getInputProps()), function () {
    if (loading) {
      return /*#__PURE__*/React.createElement(Spinner, null);
    }
    return /*#__PURE__*/React.createElement(Icon, {
      name: "plus",
      size: "largest",
      className: "text-primary-600"
    });
  }());
};

var _excluded$2 = ["className", "title", "description"],
  _excluded2 = ["className", "hasGrid"],
  _excluded3 = ["className", "title", "leftChildren", "children"],
  _excluded4 = ["className"];
var CardHeader = function CardHeader(_ref) {
  var className = _ref.className,
    title = _ref.title,
    description = _ref.description,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx(['flex justify-between border-b px-8 py-4', className])
  }, props), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    className: "text-base leading-6 font-medium text-gray-900"
  }, title), description && /*#__PURE__*/React.createElement("p", {
    className: "mt-1 text-xs text-gray-500"
  }, description)));
};
var CardContent = function CardContent(_ref2) {
  var className = _ref2.className,
    hasGrid = _ref2.hasGrid,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx(['px-8 py-4', hasGrid && 'grid gap-6 grid-cols-4', className])
  }, props));
};
var CardFooter = function CardFooter(_ref3) {
  var className = _ref3.className;
    _ref3.title;
    var leftChildren = _ref3.leftChildren,
    children = _ref3.children,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx(['px-8 py-4 flex justify-between', className])
  }, props), /*#__PURE__*/React.createElement("div", null, leftChildren), /*#__PURE__*/React.createElement("div", null, children));
};
var Card = function Card(_ref4) {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx(['bg-white shadow-sm rounded-md', className])
  }, props));
};

var ProductDetailsPageImagesCard = function ProductDetailsPageImagesCard(_ref) {
  var featuredImage = _ref.featuredImage,
    _ref$images = _ref.images,
    images = _ref$images === void 0 ? [] : _ref$images,
    _ref$newImages = _ref.newImages,
    newImages = _ref$newImages === void 0 ? [] : _ref$newImages,
    isReadOnly = _ref.isReadOnly,
    onSave = _ref.onSave,
    onNewImageUploaded = _ref.onNewImageUploaded,
    onRemoveImage = _ref.onRemoveImage,
    onSetFeaturedImage = _ref.onSetFeaturedImage;
  return /*#__PURE__*/React.createElement(Card, {
    className: "mb-6"
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Images"
    })
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap"
  }, featuredImage !== null && /*#__PURE__*/React.createElement(ProductDetailsPageImage, {
    key: featuredImage.id,
    image: featuredImage,
    isNew: newImages.find(whereId(featuredImage.id)),
    isFeatured: true,
    isDisabled: isReadOnly,
    onRemove: onRemoveImage
  }), images.map(function (image) {
    return /*#__PURE__*/React.createElement(ProductDetailsPageImage, {
      key: image.id,
      image: image,
      isNew: newImages.find(whereId(image.id)),
      isDisabled: isReadOnly,
      onRemove: onRemoveImage,
      onSetFeatured: onSetFeaturedImage
    });
  }), !isReadOnly && /*#__PURE__*/React.createElement(ProductDetailsPageImageUpload, {
    onUploadCompleted: onNewImageUploaded
  }))), /*#__PURE__*/React.createElement(CardFooter, null, /*#__PURE__*/React.createElement(Button, {
    className: "btn-primary",
    onClick: onSave,
    disabled: isReadOnly
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Save"
  }))));
};

var useProductImageState = function useProductImageState() {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _product$featuredImag = product.featuredImage,
    featuredImage = _product$featuredImag === void 0 ? null : _product$featuredImag,
    _product$images = product.images,
    images = _product$images === void 0 ? [] : _product$images;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    newImages = _useState2[0],
    setNewImages = _useState2[1];
  var _useState3 = useState(images),
    _useState4 = _slicedToArray(_useState3, 2),
    currentImages = _useState4[0],
    setImages = _useState4[1];
  var _useState5 = useState(featuredImage),
    _useState6 = _slicedToArray(_useState5, 2),
    currentFeaturedImage = _useState6[0],
    setFeaturedImage = _useState6[1];
  var newImagesRef = useRef();
  var currentImagesRef = useRef();
  newImagesRef.current = newImages;
  currentImagesRef.current = currentImages;
  useEffect(function () {
    if (featuredImage === null) {
      setFeaturedImage(featuredImage);
    }
  }, [product.id, featuredImage]);
  var hasFeaturedImage = currentFeaturedImage !== null;
  var hasNoImages = currentImagesRef.current.length === 0;
  var handleSetFeaturedImage = function handleSetFeaturedImage(image) {
    var imagesWithoutFeaturedImage = currentImagesRef.current.filter(whereIsNotId(image.id));
    setImages([].concat(_toConsumableArray(imagesWithoutFeaturedImage), [currentFeaturedImage]));
    setFeaturedImage(image);
  };
  var handleAddNewImage = function handleAddNewImage(image) {
    if (hasNoImages && !hasFeaturedImage) {
      setFeaturedImage(image);
    } else {
      setNewImages([].concat(_toConsumableArray(newImagesRef.current), [image]));
      setImages([].concat(_toConsumableArray(currentImagesRef.current), [image]));
    }
  };
  var handleRemoveImage = function handleRemoveImage(image) {
    var isRemovingFeaturedImage = hasFeaturedImage && image.id === currentFeaturedImage.id;
    if (isRemovingFeaturedImage) {
      setFeaturedImage(null);
      if (!hasNoImages) {
        var _currentImagesRef$cur = _slicedToArray(currentImagesRef.current, 1),
          newFeaturedImage = _currentImagesRef$cur[0];
        setFeaturedImage(newFeaturedImage);
        var imagesWithoutNewFeaturedImage = currentImagesRef.current.filter(function (_ref) {
          var id = _ref.id;
          return id !== newFeaturedImage.id;
        });
        setImages(imagesWithoutNewFeaturedImage);
      }
    } else {
      setNewImages(newImagesRef.current.filter(whereIsNotId(image.id)));
      setImages(currentImagesRef.current.filter(whereIsNotId(image.id)));
    }
  };
  return {
    newImages: newImages,
    images: currentImages,
    featuredImage: currentFeaturedImage,
    setFeaturedImage: handleSetFeaturedImage,
    addNewImage: handleAddNewImage,
    removeImage: handleRemoveImage
  };
};
function ProductDetailPageDetailWithState$1(_ref2) {
  var product = _ref2.product,
    onUpdateCompleted = _ref2.onUpdateCompleted,
    isReadOnly = _ref2.isReadOnly;
  var _useProductImageState = useProductImageState(product),
    newImages = _useProductImageState.newImages,
    images = _useProductImageState.images,
    featuredImage = _useProductImageState.featuredImage,
    addNewImage = _useProductImageState.addNewImage,
    removeImage = _useProductImageState.removeImage,
    setFeaturedImage = _useProductImageState.setFeaturedImage;
  var _useNotifications = useNotifications(),
    dispatchSuccess = _useNotifications.dispatchSuccess,
    dispatchError = _useNotifications.dispatchError;
  var _useUpdateProductImag = useUpdateProductImagesMutation({
      onCompleted: onUpdateCompleted
    }),
    _useUpdateProductImag2 = _slicedToArray(_useUpdateProductImag, 1),
    updateProductImages = _useUpdateProductImag2[0];
  return /*#__PURE__*/React.createElement(ProductDetailsPageImagesCard, {
    featuredImage: featuredImage,
    images: images,
    newImages: newImages,
    isReadOnly: isReadOnly,
    onNewImageUploaded: addNewImage,
    onRemoveImage: removeImage,
    onSetFeaturedImage: setFeaturedImage,
    onSave: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var featuredImageId, imageIds, input, variables, message;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            featuredImageId = featuredImage !== null ? featuredImage.id : null;
            imageIds = images.map(function (_ref4) {
              var id = _ref4.id;
              return id;
            });
            input = {
              featuredImageId: featuredImageId,
              imageIds: imageIds
            };
            variables = {
              productId: product.id,
              input: input
            };
            _context.next = 7;
            return updateProductImages({
              variables: variables
            });
          case 7:
            dispatchSuccess({
              message: /*#__PURE__*/React.createElement(Trans, {
                id: "Product successfully updated!"
              })
            });
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            message = _context.t0.graphQLErrors[0].message;
            dispatchError({
              message: message
            });
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 10]]);
    }))
  });
}

var _excluded$1 = ["to", "exact", "className", "isDisabled"];
var Tab = function Tab(_ref) {
  var className = _ref.className,
    isActive = _ref.isActive,
    isDisabled = _ref.isDisabled,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-current": isActive && 'page',
    className: clsx('whitespace-no-wrap pb-4 px-1 border-b-2 border-transparent font-medium text-sm leading-5 focus:outline-none focus:text-gray-700 focus:border-gray-300', !isActive && '', isActive && 'whitespace-no-wrap pb-4 px-1 border-b-2 border-primary-600 font-medium text-sm leading-5 text-primary-600 focus:outline-none focus:text-primary-700 focus:border-primary-700', !isActive && !isDisabled && 'text-gray-500 hover:text-gray-700 hover:border-gray-300', isDisabled && 'text-gray-300 cursor-not-allowed', className)
  }, children);
};
var TabLink = function TabLink(_ref2) {
  var to = _ref2.to,
    exact = _ref2.exact,
    className = _ref2.className,
    isDisabled = _ref2.isDisabled,
    props = _objectWithoutProperties(_ref2, _excluded$1);
  var isActive = useRouteMatch({
    path: to,
    exact: exact
  });
  return /*#__PURE__*/React.createElement(Link, {
    to: to,
    onClick: function onClick(e) {
      return isDisabled && e.preventDefault();
    }
  }, /*#__PURE__*/React.createElement(Tab, _extends({
    className: className,
    isActive: isActive,
    isDisabled: isDisabled
  }, props)));
};
var Tabs = function Tabs(_ref3) {
  var className = _ref3.className,
    children = _ref3.children;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('border-b border-gray-200 mb-8', className)
  }, /*#__PURE__*/React.createElement("nav", {
    className: "-mb-px flex space-x-8"
  }, children));
};

var _templateObject$9;
var FRAGMENT$2 = gql(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n    fragment ProductUpdatePageHeader on Product {\n        title\n        slug\n    }\n"])));
var ProductUpdatePageHeader = function ProductUpdatePageHeader(_ref) {
  var _ref$product = _ref.product,
    product = _ref$product === void 0 ? {} : _ref$product;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageHeader, {
    title: product.title,
    breadcrumbsItems: [{
      text: /*#__PURE__*/React.createElement(Trans, {
        id: "Products"
      }),
      to: '/products'
    }, {
      text: product.title
    }]
  }), /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(TabLink, {
    exact: true,
    to: "/products/".concat(product.slug)
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Details"
  })), /*#__PURE__*/React.createElement(TabLink, {
    exact: true,
    to: "/products/".concat(product.slug, "/pricing")
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Pricing"
  })), /*#__PURE__*/React.createElement(TabLink, {
    isDisabled: true,
    to: "/products/".concat(product.slug, "/variants")
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Options & variations"
  }))));
};
ProductUpdatePageHeader.FRAGMENT = FRAGMENT$2;

var _loop = function loop(loopData, key, callback) {
  loopData.forEach(function (item, index, arr) {
    if (item.key === key) {
      callback(item, index, arr);
      return;
    }
    if (item.children) {
      _loop(item.children, key, callback);
    }
  });
};

// TODO: improve. This is copy paste from example
var getNewDataAfterDrop = function getNewDataAfterDrop(data, info) {
  var dropKey = info.node.props.eventKey;
  var dragKey = info.dragNode.props.eventKey;
  var dropPos = info.node.props.pos.split('-');
  var dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
  var hasChildren = (info.node.props.children || []).length > 0;
  var isExpanded = info.node.props.expanded;
  var isOnBottomGap = dropPosition === 1;

  // Find dragObject
  var newData = _toConsumableArray(data);
  var dragObj;
  _loop(newData, dragKey, function (item, index, arr) {
    arr.splice(index, 1);
    dragObj = item;
  });
  if (!info.dropToGap) {
    // Drop on the content
    _loop(newData, dropKey, function (item) {
      item.children = item.children || [];
      // where to insert
      item.children.push(dragObj);
    });
  } else if (hasChildren && isExpanded && isOnBottomGap) {
    _loop(newData, dropKey, function (item) {
      item.children = item.children || [];
      // where to initialize
      item.children.unshift(dragObj);
    });
  } else {
    // Drop on the gap
    var ar;
    var i;
    _loop(newData, dropKey, function (item, index, arr) {
      ar = arr;
      i = index;
    });
    if (dropPosition === -1) {
      ar.splice(i, 0, dragObj);
    } else {
      ar.splice(i + 1, 0, dragObj);
    }
  }
  return newData;
};
var _getKeysWithChildren = function getKeysWithChildren(data) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return data.reduce(function (keysAcc, _ref) {
    var key = _ref.key,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? [] : _ref$children;
    if (children.length > 0) {
      return _getKeysWithChildren(children, [key].concat(_toConsumableArray(keysAcc)));
    }
    return keysAcc;
  }, keys);
};

/*
* Example for how data should look (can be nested infinitely):
*   [
*       title: 'Title',
*       key: 'unique-key',
*       children: {
*           title: 'Title',
*           ...
*       }
*   ]
*/

function Tree(_ref2) {
  var data = _ref2.data,
    onChange = _ref2.onChange,
    actionRenderer = _ref2.actionRenderer,
    _onCheck = _ref2.onCheck,
    _ref2$expandAll = _ref2.expandAll,
    expandAll = _ref2$expandAll === void 0 ? true : _ref2$expandAll,
    _ref2$isDraggable = _ref2.isDraggable,
    isDraggable = _ref2$isDraggable === void 0 ? true : _ref2$isDraggable,
    _ref2$checkedKeys = _ref2.checkedKeys,
    checkedKeys = _ref2$checkedKeys === void 0 ? [] : _ref2$checkedKeys,
    isReadOnly = _ref2.isReadOnly;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    autoExpandParent = _useState2[0],
    setAutoExpandParent = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    expandedKeys = _useState4[0],
    setExpandedKeys = _useState4[1];
  var isCheckable = typeof _onCheck === 'function';
  var topLevelWithChildren = data.find(function (_ref3) {
    var _ref3$children = _ref3.children,
      children = _ref3$children === void 0 ? [] : _ref3$children;
    return children.length > 0;
  });
  var isTopLevelOnly = typeof topLevelWithChildren === 'undefined';
  useEffect(function () {
    // Expand all
    if (expandAll) {
      setExpandedKeys(_getKeysWithChildren(data));
    }
  }, [expandAll]);
  var onDragEnter = function onDragEnter(values) {
    setExpandedKeys(values.expandedKeys);
  };
  var onDrop = function onDrop(info) {
    var newData = getNewDataAfterDrop(data, info);
    onChange(newData);
  };
  var onExpand = function onExpand(keys) {
    setExpandedKeys(keys);
    setAutoExpandParent(false);
  };

  // Since we can't add components to the tree we add a renderer for reach row
  var _renderRow = function renderRow() {
    return data.reduce(function (dataAcc, item) {
      var _item$children = item.children,
        children = _item$children === void 0 ? [] : _item$children,
        _title = item.title,
        key = item.key;
      var checkedHasKey = checkedKeys.find(function (checkedKey) {
        return checkedKey === key;
      });
      var isChecked = typeof checkedHasKey !== 'undefined';
      var itemWithNewTitle = _objectSpread2(_objectSpread2({}, item), {}, {
        title: function title() {
          return /*#__PURE__*/React.createElement("span", {
            className: clsx(['flex justify-between items-center py-3', isDraggable && 'cursor-pointer', isCheckable && !isChecked ? 'text-gray-400' : 'text-black', isTopLevelOnly && !isCheckable ? 'px-4' : 'px-2'])
          }, /*#__PURE__*/React.createElement("span", {
            className: "flex items-center"
          }, isDraggable && /*#__PURE__*/React.createElement(Icon, {
            name: "drag",
            className: "mr-2"
          }), _title), typeof actionRenderer === 'function' && actionRenderer(key));
        }
      });
      if (children.length > 0) {
        return [].concat(_toConsumableArray(dataAcc), [_objectSpread2(_objectSpread2({}, itemWithNewTitle), {}, {
          children: _renderRow()
        })]);
      }
      return [].concat(_toConsumableArray(dataAcc), [itemWithNewTitle]);
    }, []);
  };
  return /*#__PURE__*/React.createElement(RcTree, {
    className: clsx([isTopLevelOnly && 'isTopLevelOnly', isDraggable && 'isDraggable', isCheckable && 'isCheckable', isReadOnly && 'isReadOnly']),
    prefixCls: "toway-tree",
    expandedKeys: expandedKeys,
    onExpand: onExpand,
    autoExpandParent: autoExpandParent,
    draggable: isDraggable,
    onDragEnter: onDragEnter,
    onDrop: onDrop,
    checkable: isCheckable,
    onCheck: function onCheck(values) {
      return !isReadOnly && _onCheck(values);
    },
    checkedKeys: checkedKeys,
    treeData: _renderRow(),
    switcherIcon: function switcherIcon(_ref4) {
      var expanded = _ref4.expanded,
        _ref4$data$children = _ref4.data.children,
        children = _ref4$data$children === void 0 ? [] : _ref4$data$children;
      if (children.length === 0) {
        return null;
      }
      return /*#__PURE__*/React.createElement("span", {
        className: clsx(['transform transition-transform block', !expanded && '-rotate-90'])
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "chevron-down"
      }));
    }
  });
}

var ProductDetailsPageCategoriesCard = function ProductDetailsPageCategoriesCard(_ref) {
  var categories = _ref.categories,
    selectedCategories = _ref.selectedCategories,
    onChangeCategories = _ref.onChangeCategories,
    onSave = _ref.onSave,
    isReadOnly = _ref.isReadOnly;
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Categories"
    })
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Tree, {
    data: categories,
    checkedKeys: selectedCategories,
    onCheck: onChangeCategories,
    isDraggable: false,
    isReadOnly: isReadOnly
  })), /*#__PURE__*/React.createElement("div", {
    className: "border-t py-4 px-6 flex justify-end"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    onClick: onSave,
    className: "btn-primary",
    disabled: isReadOnly
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Save"
  }))));
};

var _templateObject$8;
var UPDATE_PRODUCT_CATEGORIES_MUTATION = gql(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n    mutation updateProductCategories($productId: ID!, $input: UpdateProductCategoriesInput!) {\n        updateProductCategories(productId: $productId, input: $input) {\n            product {\n                categories {\n                    id\n                }\n            }\n        }\n    }\n"])));
var useUpdateProductCategoriesMutation = function useUpdateProductCategoriesMutation(options) {
  return useMutation(UPDATE_PRODUCT_CATEGORIES_MUTATION, options);
};

function ProductDetailPageDetailWithState(_ref) {
  var product = _ref.product,
    categories = _ref.categories,
    isReadOnly = _ref.isReadOnly;
  var _useNotifications = useNotifications(),
    dispatchSuccess = _useNotifications.dispatchSuccess,
    dispatchError = _useNotifications.dispatchError;
  var _useState = useState(product.categories),
    _useState2 = _slicedToArray(_useState, 2),
    selectedCategories = _useState2[0],
    setSelectedCategories = _useState2[1];
  var _useUpdateProductCate = useUpdateProductCategoriesMutation(),
    _useUpdateProductCate2 = _slicedToArray(_useUpdateProductCate, 1),
    updateProductCategories = _useUpdateProductCate2[0];
  return /*#__PURE__*/React.createElement(ProductDetailsPageCategoriesCard, {
    categories: categories,
    selectedCategories: selectedCategories,
    onChangeCategories: setSelectedCategories,
    onSave: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var input, variables, message;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            input = {
              categoryIds: selectedCategories
            };
            variables = {
              productId: product.id,
              input: input
            };
            _context.next = 5;
            return updateProductCategories({
              variables: variables
            });
          case 5:
            dispatchSuccess({
              message: /*#__PURE__*/React.createElement(Trans, {
                id: "Product successfully updated!"
              })
            });
            _context.next = 12;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            message = _context.t0.graphQLErrors[0].message;
            dispatchError({
              message: message
            });
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    })),
    isReadOnly: isReadOnly
  });
}

var ProductDetailPage = function ProductDetailPage(_ref) {
  var product = _ref.product,
    availableLanguages = _ref.availableLanguages,
    categories = _ref.categories,
    isLoading = _ref.isLoading,
    onUpdateCompleted = _ref.onUpdateCompleted,
    isReadOnly = _ref.isReadOnly;
  if (isLoading) {
    return /*#__PURE__*/React.createElement(PageLoading, null);
  }
  return /*#__PURE__*/React.createElement(PageContainer, {
    "data-testid": "ProductDetailPage"
  }, /*#__PURE__*/React.createElement(PageSideBarWithState, null), /*#__PURE__*/React.createElement(PageContent, null, /*#__PURE__*/React.createElement(ProductUpdatePageHeader, {
    product: product
  }), /*#__PURE__*/React.createElement(ProductDetailPageCardWithState, {
    product: product,
    availableLanguages: availableLanguages,
    isReadOnly: isReadOnly
  }), /*#__PURE__*/React.createElement(ProductDetailPageDetailWithState$1, {
    product: product,
    onUpdateCompleted: onUpdateCompleted,
    isReadOnly: isReadOnly
  }), /*#__PURE__*/React.createElement(ProductDetailPageDetailWithState, {
    product: product,
    categories: categories,
    isReadOnly: isReadOnly
  })));
};

var _templateObject$7;
var PRODUCT_PAGE_QUERY$1 = gql(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n    query productPageQuery($slug: String) {\n        product(slug: $slug) {\n            id\n            title\n            slug\n            translations {\n                slug\n                title\n                description\n\n            }\n            isInStock\n            sku\n            categories {\n                id\n            }\n            price\n            importId\n            featuredImage {\n                id,\n                url\n            }\n            images {\n                id\n                url\n            }\n        }\n        languages {\n            code\n            name\n        }\n        categories {\n            id\n            name\n        }\n    }\n"])));
var mapProductData = function mapProductData() {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _product$categories = product.categories,
    categories = _product$categories === void 0 ? [] : _product$categories;
  return _objectSpread2(_objectSpread2({}, product), {}, {
    title: product.title || 'Title',
    categories: categories.map(function (_ref) {
      var id = _ref.id;
      return id;
    })
  });
};
var useProductDetailPageQuery = function useProductDetailPageQuery(slug, options) {
  var variables = {
    slug: slug
  };
  var _useQuery = useQuery(PRODUCT_PAGE_QUERY$1, _objectSpread2({
      variables: variables
    }, options)),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? {} : _useQuery$data,
    error = _useQuery.error,
    loading = _useQuery.loading,
    refetch = _useQuery.refetch;
  return {
    error: error,
    product: mapProductData(data.product),
    languages: data.languages || [],
    categories: mapCategoriesToTreeData(data.categories),
    isLoading: loading,
    refetch: refetch
  };
};

var ProductDetailPageWithState$1 = function ProductDetailPageWithState() {
  var _useParams = useParams(),
    slug = _useParams.slug;
  var _useProductDetailPage = useProductDetailPageQuery(slug),
    product = _useProductDetailPage.product,
    languages = _useProductDetailPage.languages,
    categories = _useProductDetailPage.categories,
    isLoading = _useProductDetailPage.isLoading,
    refetch = _useProductDetailPage.refetch;
  var _useAppState = useAppState(),
    store = _useAppState.store;
  var availableLanguages = getAvailableLanguages(store.availableLanguages, languages);
  return /*#__PURE__*/React.createElement(ProductDetailPage, {
    product: product,
    categories: categories,
    isLoading: isLoading,
    availableLanguages: availableLanguages,
    onUpdateCompleted: function onUpdateCompleted() {
      return refetch();
    },
    isReadOnly: product.importId !== null
  });
};

var OrderPageStatus = function OrderPageStatus(_ref) {
  var createdAt = _ref.createdAt,
    updatedAt = _ref.updatedAt,
    status = _ref.status;
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 rounded-md bg-white overflow-hidden shadow md:grid-cols-3"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "p-4 text-sm"
  }, /*#__PURE__*/React.createElement("p", {
    className: "uppercase text-gray-500"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Created"
  })), /*#__PURE__*/React.createElement("p", null, formatDate(new Date(createdAt))), /*#__PURE__*/React.createElement("p", null, formatTime(new Date(createdAt))))), /*#__PURE__*/React.createElement("div", {
    className: "border-t border-gray-200 md:border-0 md:border-l"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4 text-sm"
  }, /*#__PURE__*/React.createElement("p", {
    className: "uppercase text-gray-500"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Updated"
  })), /*#__PURE__*/React.createElement("p", null, formatDate(new Date(updatedAt))), /*#__PURE__*/React.createElement("p", null, formatTime(new Date(updatedAt))))), /*#__PURE__*/React.createElement("div", {
    className: "border-t border-gray-200 md:border-0 md:border-l"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4 text-sm"
  }, /*#__PURE__*/React.createElement("p", {
    className: "uppercase text-gray-500"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Status"
  })), /*#__PURE__*/React.createElement("p", null, status))));
};

var DetailSection = function DetailSection(_ref) {
  var title = _ref.title,
    details = _ref.details,
    className = _ref.className;
  if (details === null || typeof details === 'undefined') {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('text-sm', className)
  }, /*#__PURE__*/React.createElement("p", {
    className: "uppercase font-bold mb-2"
  }, title), Object.keys(details).map(function (key) {
    return /*#__PURE__*/React.createElement("p", {
      key: key
    }, details[key]);
  }));
};

var OrderPageAddress = function OrderPageAddress(_ref) {
  var customer = _ref.customer,
    shipping = _ref.shipping,
    billingAddressEqualsShippingAddress = _ref.billingAddressEqualsShippingAddress,
    billing = _ref.billing;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center border-b border-gray-200 p-4"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "user",
    className: "h-16 w-16"
  }), customer !== null ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "text-sm font-bold mt-4"
  }, customer.fullName), /*#__PURE__*/React.createElement("p", {
    className: "text-sm"
  }, customer.email)) : /*#__PURE__*/React.createElement("p", {
    className: "text-sm font-bold mt-4"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Guest"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/React.createElement(DetailSection, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Shipping address"
    }),
    details: shipping,
    className: "mt-2"
  }), billingAddressEqualsShippingAddress ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "text-sm uppercase font-bold mt-6"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Billing address"
  })), /*#__PURE__*/React.createElement("p", {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Same as shipping"
  }))) : /*#__PURE__*/React.createElement(DetailSection, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Billing address"
    }),
    details: billing,
    className: "mt-6"
  })));
};

var OrderPageProductsTableRow = function OrderPageProductsTableRow(_ref) {
  var product = _ref.product;
  var featuredImage = product.featuredImage,
    title = product.title,
    slug = product.slug,
    quantity = product.quantity,
    price = product.price,
    totalPrice = product.totalPrice;
  var indexOfBracket = title.indexOf('(');
  return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-8"
  }, featuredImage !== null && featuredImage.url !== null ? /*#__PURE__*/React.createElement("img", {
    className: "h-10 w-10",
    src: featuredImage.url,
    alt: title
  }) : /*#__PURE__*/React.createElement(Icon, {
    name: "image",
    className: "h-10 w-10"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
    className: "text-sm",
    to: "/products/".concat(slug)
  }, indexOfBracket < 0 ? title : title.substring(0, indexOfBracket)), indexOfBracket >= 0 && /*#__PURE__*/React.createElement("p", {
    className: "text-sm text-gray-500"
  }, title.substring(indexOfBracket, title.length))))), /*#__PURE__*/React.createElement(TableCell, null, quantity), /*#__PURE__*/React.createElement(TableCell, null, priceHelper(price)), /*#__PURE__*/React.createElement(TableCell, null, priceHelper(totalPrice)));
};

var ProductsPageTableHeaderRow = function ProductsPageTableHeaderRow() {
  return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Product"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Quantity"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Price"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Total"
  })));
};

var OrderPageProductsTable = function OrderPageProductsTable(_ref) {
  var products = _ref.products,
    subTotal = _ref.subTotal,
    discount = _ref.discount,
    shippingCost = _ref.shippingCost,
    grandTotal = _ref.grandTotal,
    status = _ref.status,
    hasShippingPermission = _ref.hasShippingPermission,
    onShipOrder = _ref.onShipOrder,
    isShippingOrder = _ref.isShippingOrder;
  return /*#__PURE__*/React.createElement(Table, {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement(ProductsPageTableHeaderRow, null)), /*#__PURE__*/React.createElement(TableBody, null, products.map(function (product) {
    return /*#__PURE__*/React.createElement(OrderPageProductsTableRow, {
      key: product.slug,
      product: product
    });
  }), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: "4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between px-6 py-8"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "text-sm"
  }, "Subtotal"), /*#__PURE__*/React.createElement("p", {
    className: "text-sm"
  }, "Shipping"), /*#__PURE__*/React.createElement("p", {
    className: "text-sm"
  }, "Discount"), /*#__PURE__*/React.createElement("p", {
    className: "font-bold mt-8"
  }, "Total")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "text-sm"
  }, priceHelper(subTotal)), /*#__PURE__*/React.createElement("p", {
    className: "text-sm"
  }, priceHelper(shippingCost)), /*#__PURE__*/React.createElement("p", {
    className: "text-sm"
  }, priceHelper(-discount)), /*#__PURE__*/React.createElement("p", {
    className: "font-bold mt-8"
  }, priceHelper(grandTotal)))))), status === ORDER_STATUS_PAID$1 && hasShippingPermission && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: "4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end px-6 py-2"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn-secondary",
    onClick: onShipOrder,
    loading: isShippingOrder
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Ship order"
  })))))));
};

var _templateObject$6;
var FRAGMENT$1 = gql(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n    fragment OrderDetail on Order {\n        id\n        status\n        discount\n        customer {\n            id\n            email\n            fullName\n        }\n        shipping {\n            ...Address\n        }\n        billingAddressEqualsShippingAddress\n        billing {\n            ...Address\n        }\n        orderLines {\n            title\n            variationId\n            price\n            quantity\n            totalPrice\n            slug\n            featuredImage {\n                url\n            }\n        }\n        subTotal\n        shippingCost\n        grandTotal\n        createdAt\n        updatedAt\n    }\n    ", "\n"])), ADDRESS_FRAGMENT);
var OrderDetail = function OrderDetail(_ref) {
  var order = _ref.order,
    hasShippingPermission = _ref.hasShippingPermission,
    onShipOrder = _ref.onShipOrder,
    isShippingOrder = _ref.isShippingOrder;
  var createdAt = order.createdAt,
    updatedAt = order.updatedAt,
    status = order.status,
    discount = order.discount,
    customer = order.customer,
    shipping = order.shipping,
    billingAddressEqualsShippingAddress = order.billingAddressEqualsShippingAddress,
    billing = order.billing,
    orderLines = order.orderLines,
    subTotal = order.subTotal,
    shippingCost = order.shippingCost,
    grandTotal = order.grandTotal;
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 gap-4 items-start lg:grid-cols-3 lg:gap-8 mt-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 gap-4 lg:col-span-2"
  }, /*#__PURE__*/React.createElement(OrderPageStatus, {
    createdAt: createdAt,
    updatedAt: updatedAt,
    status: status
  }), /*#__PURE__*/React.createElement(OrderPageProductsTable, {
    products: orderLines,
    subTotal: subTotal,
    discount: discount,
    shippingCost: shippingCost,
    grandTotal: grandTotal,
    status: status,
    hasShippingPermission: hasShippingPermission,
    onShipOrder: onShipOrder,
    isShippingOrder: isShippingOrder
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-md bg-white overflow-hidden shadow"
  }, /*#__PURE__*/React.createElement(OrderPageAddress, {
    customer: customer,
    shipping: shipping,
    billingAddressEqualsShippingAddress: billingAddressEqualsShippingAddress,
    billing: billing
  }))));
};
OrderDetail.FRAGMENT = FRAGMENT$1;

var OrderDetailPage = function OrderDetailPage(_ref) {
  var isFetching = _ref.isFetching,
    order = _ref.order,
    hasShippingPermission = _ref.hasShippingPermission,
    onShipOrder = _ref.onShipOrder,
    isShippingOrder = _ref.isShippingOrder;
  return /*#__PURE__*/React.createElement(PageContainer, null, /*#__PURE__*/React.createElement(PageSideBarWithState, null), /*#__PURE__*/React.createElement(PageContent, null, isFetching ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageHeader, {
    title: order.number,
    breadcrumbsItems: [{
      text: /*#__PURE__*/React.createElement(Trans, {
        id: "Orders"
      }),
      to: '/orders'
    }, {
      text: order.number
    }],
    rightChildren: /*#__PURE__*/React.createElement(Link, {
      to: "/orders"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "btn-white"
    }, /*#__PURE__*/React.createElement(Trans, {
      id: "Back"
    })))
  }), /*#__PURE__*/React.createElement(OrderDetail, {
    order: order,
    hasShippingPermission: hasShippingPermission,
    onShipOrder: onShipOrder,
    isShippingOrder: isShippingOrder
  }))));
};

var _templateObject$5;
var ORDER_PAGE_QUERY = gql(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n    query orderPageQuery($id: ID!) {\n        order(id: $id) {\n            ...OrderDetail\n        }\n    }\n    ", "\n"])), OrderDetail.FRAGMENT);
var useOrderDetailPageQuery = function useOrderDetailPageQuery(id, options) {
  var variables = {
    id: id
  };
  var _useQuery = useQuery(ORDER_PAGE_QUERY, _objectSpread2({
      variables: variables
    }, options)),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? {} : _useQuery$data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  return {
    error: error,
    order: data.order || {},
    isFetching: loading
  };
};

var OrderDetailPageWithState = function OrderDetailPageWithState() {
  var _useParams = useParams(),
    id = _useParams.id;
  var _useShipOrder = useShipOrder(),
    hasShippingPermission = _useShipOrder.hasShippingPermission,
    shipOrder = _useShipOrder.shipOrder,
    isShippingOrder = _useShipOrder.isShippingOrder,
    confirmationModal = _useShipOrder.confirmationModal;
  var _useOrderDetailPageQu = useOrderDetailPageQuery(id),
    isFetching = _useOrderDetailPageQu.isFetching,
    order = _useOrderDetailPageQu.order;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OrderDetailPage, {
    isFetching: isFetching,
    order: order,
    hasShippingPermission: hasShippingPermission,
    onShipOrder: function onShipOrder() {
      return shipOrder(id);
    },
    isShippingOrder: isShippingOrder
  }), confirmationModal);
};

var CustomerStats = function CustomerStats(_ref) {
  var totalSpent = _ref.totalSpent,
    averageOrder = _ref.averageOrder;
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 rounded-md bg-white overflow-hidden shadow md:grid-cols-2"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "p-4 text-sm"
  }, /*#__PURE__*/React.createElement("p", {
    className: "uppercase text-gray-500"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Total spent"
  })), /*#__PURE__*/React.createElement("p", null, priceHelper(totalSpent)))), /*#__PURE__*/React.createElement("div", {
    className: "border-t border-gray-200 md:border-0 md:border-l"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4 text-sm"
  }, /*#__PURE__*/React.createElement("p", {
    className: "uppercase text-gray-500"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Average order"
  })), /*#__PURE__*/React.createElement("p", null, priceHelper(averageOrder)))));
};

var CustomerInformation = function CustomerInformation(_ref) {
  var fullName = _ref.fullName,
    email = _ref.email;
    _ref.phone;
    var shipping = _ref.shipping,
    billing = _ref.billing;
  return /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/React.createElement(DetailSection, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Contact"
    }),
    details: {
      fullName: fullName,
      email: email
    }
  }), /*#__PURE__*/React.createElement(DetailSection, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Shipping address"
    }),
    details: shipping,
    className: "mt-6"
  }), /*#__PURE__*/React.createElement(DetailSection, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Billing address"
    }),
    details: billing,
    className: "mt-6"
  }));
};

var CustomerOrderTableRow = function CustomerOrderTableRow(_ref) {
  var order = _ref.order;
  var id = order.id,
    number = order.number,
    createdAt = order.createdAt,
    status = order.status,
    grandTotal = order.grandTotal;
  return /*#__PURE__*/React.createElement("tr", {
    "data-testid": "CustomerOrderTableRow"
  }, /*#__PURE__*/React.createElement(TableCell, {
    className: "font-medium"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/orders/".concat(id)
  }, number)), /*#__PURE__*/React.createElement(TableCell, null, formatDate(new Date(createdAt))), /*#__PURE__*/React.createElement(TableCell, null, status), /*#__PURE__*/React.createElement(TableCell, null, priceHelper(grandTotal)));
};

var CustomersPageOrdersTableHeaderRow = function CustomersPageOrdersTableHeaderRow() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: "border-b border-gray-200"
  }, /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Orders"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null), /*#__PURE__*/React.createElement(TableHeaderCell, null), /*#__PURE__*/React.createElement(TableHeaderCell, null)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Number"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Date"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Status"
  })), /*#__PURE__*/React.createElement(TableHeaderCell, null, /*#__PURE__*/React.createElement(Trans, {
    id: "Total"
  }))));
};

var CustomersPageOrdersTable = function CustomersPageOrdersTable(_ref) {
  var orders = _ref.orders;
  return /*#__PURE__*/React.createElement(Table, {
    "data-testid": "CustomerOrdersPageTable",
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement(CustomersPageOrdersTableHeaderRow, null)), /*#__PURE__*/React.createElement(TableBody, null, orders.map(function (order) {
    return /*#__PURE__*/React.createElement(CustomerOrderTableRow, {
      key: order.id,
      order: order
    });
  })));
};

var CustomerDetail = function CustomerDetail(_ref) {
  var customer = _ref.customer;
  var fullName = customer.fullName,
    email = customer.email,
    shipping = customer.shipping,
    billing = customer.billing,
    _customer$ordersInfo = customer.ordersInfo,
    totalSpent = _customer$ordersInfo.totalSpent,
    averageOrder = _customer$ordersInfo.averageOrder,
    orders = _customer$ordersInfo.orders;
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 gap-4 items-start lg:grid-cols-3 lg:gap-8 mt-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 gap-4 lg:col-span-2"
  }, /*#__PURE__*/React.createElement(CustomerStats, {
    totalSpent: totalSpent,
    averageOrder: averageOrder
  }), /*#__PURE__*/React.createElement(CustomersPageOrdersTable, {
    orders: orders
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-md bg-white overflow-hidden shadow"
  }, /*#__PURE__*/React.createElement(CustomerInformation, {
    fullName: fullName,
    email: email,
    shipping: shipping,
    billing: billing
  }))));
};

var CustomerDetailPage = function CustomerDetailPage(_ref) {
  var customer = _ref.customer,
    isFetching = _ref.isFetching;
  return /*#__PURE__*/React.createElement(PageContainer, {
    "data-testid": "CustomerDetailPage"
  }, /*#__PURE__*/React.createElement(PageSideBarWithState, null), /*#__PURE__*/React.createElement(PageContent, null, isFetching ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageHeader, {
    title: customer.fullName,
    subtitle: /*#__PURE__*/React.createElement("div", {
      className: "flex text-gray-500"
    }, /*#__PURE__*/React.createElement("p", {
      className: "mr-1"
    }, /*#__PURE__*/React.createElement(Trans, {
      id: "Since"
    })), /*#__PURE__*/React.createElement("p", null, formatDate(new Date(customer.createdAt)))),
    breadcrumbsItems: [{
      text: /*#__PURE__*/React.createElement(Trans, {
        id: "Customers"
      }),
      to: '/customers'
    }, {
      text: customer.fullName
    }],
    rightChildren: /*#__PURE__*/React.createElement(Link, {
      to: "/customers"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "btn-white"
    }, /*#__PURE__*/React.createElement(Trans, {
      id: "Back"
    }))),
    leftChildren: /*#__PURE__*/React.createElement(Icon, {
      name: "user",
      className: "w-14 h-14"
    })
  }), /*#__PURE__*/React.createElement(CustomerDetail, {
    customer: customer
  }))));
};

var _templateObject$4;
var CUSTOMER_PAGE_QUERY = gql(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n    query customerPageQuery($id: ID!) {\n        customer(id: $id) {\n            id\n            firstName\n            lastName\n            fullName\n            email\n            phone\n            preferredLanguageCode\n            createdAt\n            shipping {\n                ...Address\n            }\n            billing {\n                ...Address\n            }\n            ordersInfo {\n                totalSpent\n                averageOrder\n                orders {\n                    ...Order\n                }\n            }\n        }\n    }\n    ", "\n"])), ORDER_FRAGMENT);
var useCustomerDetailPageQuery = function useCustomerDetailPageQuery(id, options) {
  var variables = {
    id: id
  };
  var _useQuery = useQuery(CUSTOMER_PAGE_QUERY, _objectSpread2({
      variables: variables
    }, options)),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? {} : _useQuery$data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  return {
    error: error,
    customer: data.customer || {},
    isFetching: loading
  };
};

var CustomerDetailPageWithState = function CustomerDetailPageWithState() {
  var _useParams = useParams(),
    id = _useParams.id;
  var _useCustomerDetailPag = useCustomerDetailPageQuery(id),
    customer = _useCustomerDetailPag.customer,
    isFetching = _useCustomerDetailPag.isFetching;
  return /*#__PURE__*/React.createElement(CustomerDetailPage, {
    customer: customer,
    isFetching: isFetching
  });
};

function ProductsCategoriesPage(_ref) {
  var categories = _ref.categories,
    onCategoriesChange = _ref.onCategoriesChange;
  return /*#__PURE__*/React.createElement(PageContainer, null, /*#__PURE__*/React.createElement(PageSideBarWithState, null), /*#__PURE__*/React.createElement(PageContent, null, /*#__PURE__*/React.createElement(PageHeader, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Categories"
    }),
    breadcrumbsItems: [{
      text: /*#__PURE__*/React.createElement(Trans, {
        id: "Categories"
      })
    }],
    rightChildren: /*#__PURE__*/React.createElement(Link, {
      to: "/products"
    }, /*#__PURE__*/React.createElement(Button, {
      "data-testid": "BackButton",
      className: "btn-white"
    }, /*#__PURE__*/React.createElement(Trans, {
      id: "Back"
    })))
  }), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Tree, {
    data: categories,
    onChange: onCategoriesChange,
    isDraggable: false
  }))));
}

var _templateObject$3;
var PRODUCTS_CATEGORIES_PAGE_QUERY = gql(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n    query productsCategoriesPage {\n        categories {\n            id\n            name\n        }\n    }\n"])));
var useProductsCategoriesPageQuery = function useProductsCategoriesPageQuery() {
  var _useQuery = useQuery(PRODUCTS_CATEGORIES_PAGE_QUERY),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? {} : _useQuery$data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  return {
    error: error,
    categories: mapCategoriesToTreeData(data.categories),
    isFetching: loading
  };
};

function ProductsCategoriesPageWithState() {
  var _useProductsCategorie = useProductsCategoriesPageQuery(),
    categories = _useProductsCategorie.categories;
  return /*#__PURE__*/React.createElement(ProductsCategoriesPage, {
    categories: categories
  });
}

var _templateObject$2;
var FRAGMENT = gql(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n    fragment ProductUpdatePricingPageCard on Product {\n        price\n        shippingCost\n    }\n"])));
var ProductUpdatePricingPageCard = function ProductUpdatePricingPageCard(_ref) {
  var formState = _ref.formState,
    isLoading = _ref.isLoading,
    isReadOnly = _ref.isReadOnly,
    onSave = _ref.onSave;
  var getErrorMessages = formState.getErrorMessages,
    getNativeInputProps = formState.getNativeInputProps;
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: /*#__PURE__*/React.createElement(Trans, {
      id: "Pricing"
    })
  }), /*#__PURE__*/React.createElement(CardContent, {
    hasGrid: true,
    className: "h-40"
  }, /*#__PURE__*/React.createElement(FormGroup, {
    className: "col-span-1",
    htmlFor: "price",
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Price (EUR)"
    })
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    id: "price",
    name: "price",
    disabled: isReadOnly,
    errors: getErrorMessages('price')
  }, getNativeInputProps('price')))), /*#__PURE__*/React.createElement(FormGroup, {
    className: "col-span-1",
    htmlFor: "shippingCost",
    label: /*#__PURE__*/React.createElement(Trans, {
      id: "Shipping cost"
    })
  }, /*#__PURE__*/React.createElement(FormInput, _extends({
    id: "shippingCost",
    name: "shippingCost",
    disabled: isReadOnly,
    type: "number",
    errors: getErrorMessages('shippingCost')
  }, getNativeInputProps('shippingCost'))))), /*#__PURE__*/React.createElement(CardFooter, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onSave,
    disabled: isLoading || isReadOnly,
    className: "btn-primary"
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Save"
  }))));
};
ProductUpdatePricingPageCard.FRAGMENT = FRAGMENT;

var ProductUpdatePricingPage = function ProductUpdatePricingPage(_ref) {
  var product = _ref.product,
    isLoading = _ref.isLoading,
    formState = _ref.formState,
    onSave = _ref.onSave;
  if (isLoading) {
    return /*#__PURE__*/React.createElement(PageLoading, null, /*#__PURE__*/React.createElement(ProductUpdatePageHeader, null));
  }
  return /*#__PURE__*/React.createElement(PageContainer, {
    "data-testid": "ProductUpdatePricingPage"
  }, /*#__PURE__*/React.createElement(PageSideBarWithState, null), /*#__PURE__*/React.createElement(PageContent, null, /*#__PURE__*/React.createElement(ProductUpdatePageHeader, {
    product: product
  }), /*#__PURE__*/React.createElement(ProductUpdatePricingPageCard, {
    isReadOnly: product.importId !== null,
    isLoading: isLoading,
    formState: formState,
    onSave: onSave
  })));
};

var _templateObject$1;
var UPDATE_PRODUCT_PRICING_MUTATION = gql(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n    mutation updateProductPricing($productId: ID!, $input: UpdateProductPricingInput!) {\n        updateProductPricing(productId: $productId, input: $input) {\n            product {\n                id\n                ...ProductUpdatePageHeader\n                ...ProductUpdatePricingPageCard\n                importId\n            }\n        }\n    }\n    ", "\n    ", "\n"])), ProductUpdatePageHeader.FRAGMENT, ProductUpdatePricingPageCard.FRAGMENT);
var useUpdateProductPricingMutation = function useUpdateProductPricingMutation(options) {
  return useMutation(UPDATE_PRODUCT_PRICING_MUTATION, options);
};

var _templateObject;
var PRODUCT_PAGE_QUERY = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query productPageQuery($slug: String) {\n        product(slug: $slug) {\n            id\n            ...ProductUpdatePageHeader\n            ...ProductUpdatePricingPageCard\n            importId\n        }\n    }\n    ", "\n    ", "\n"])), ProductUpdatePageHeader.FRAGMENT, ProductUpdatePricingPageCard.FRAGMENT);
var useProductUpdatePricingPageQuery = function useProductUpdatePricingPageQuery(slug, options) {
  var variables = {
    slug: slug
  };
  var _useQuery = useQuery(PRODUCT_PAGE_QUERY, _objectSpread2({
      variables: variables
    }, options)),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? {} : _useQuery$data,
    error = _useQuery.error,
    loading = _useQuery.loading,
    refetch = _useQuery.refetch;
  return {
    error: error,
    product: data.product || {},
    isLoading: loading,
    refetch: refetch
  };
};

var validation = createFormValidation([{
  path: 'price',
  validate: isRequired,
  message: /*#__PURE__*/React.createElement(Trans, {
    id: "Please fill in the price."
  })
}]);
var valuesToInput = function valuesToInput(_ref) {
  var price = _ref.price,
    _ref$shippingCost = _ref.shippingCost,
    shippingCost = _ref$shippingCost === void 0 ? '' : _ref$shippingCost;
  return {
    price: parseInt(parseFloat(price) * 100, 10),
    shippingCost: shippingCost === '' ? null : parseInt(parseFloat(shippingCost) * 100, 10)
  };
};
var useProductDetailFormState = function useProductDetailFormState(_ref2) {
  var _ref2$shippingCost = _ref2.shippingCost,
    shippingCost = _ref2$shippingCost === void 0 ? null : _ref2$shippingCost,
    price = _ref2.price;
  return useFormState({
    price: price / 100,
    shippingCost: shippingCost !== null ? shippingCost / 100 : ''
  }, {
    validation: validation,
    valuesToInput: valuesToInput
  });
};

var ProductDetailPageWithState = function ProductDetailPageWithState() {
  var _useParams = useParams(),
    slug = _useParams.slug;
  var _useProductUpdatePric = useProductUpdatePricingPageQuery(slug),
    product = _useProductUpdatePric.product,
    isLoading = _useProductUpdatePric.isLoading,
    refetch = _useProductUpdatePric.refetch;
  var formState = useProductDetailFormState(product);
  var _useUpdateProductPric = useUpdateProductPricingMutation(),
    _useUpdateProductPric2 = _slicedToArray(_useUpdateProductPric, 2),
    updateProductPricing = _useUpdateProductPric2[0],
    loading = _useUpdateProductPric2[1].loading;
  var _useNotifications = useNotifications(),
    dispatchSuccess = _useNotifications.dispatchSuccess,
    dispatchGraphqlError = _useNotifications.dispatchGraphqlError;
  return /*#__PURE__*/React.createElement(ProductUpdatePricingPage, {
    formState: formState,
    product: product,
    isLoading: isLoading || loading,
    onUpdateCompleted: function onUpdateCompleted() {
      return refetch();
    },
    onSave: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var input, variables;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (!formState.validate()) {
              _context.next = 7;
              break;
            }
            input = formState.valuesToInput();
            variables = {
              productId: product.id,
              input: input
            };
            _context.next = 6;
            return updateProductPricing({
              variables: variables
            });
          case 6:
            dispatchSuccess({
              message: /*#__PURE__*/React.createElement(Trans, {
                id: "Product successfully updated!"
              })
            });
          case 7:
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            dispatchGraphqlError(_context.t0);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 9]]);
    }))
  });
};

var _excluded = ["history", "isAuthenticated"];
var READ_PRODUCTS = PERMISSION_READ_PRODUCTS,
  READ_ORDERS = PERMISSION_READ_ORDERS,
  WRITE_USERS = PERMISSION_WRITE_USERS,
  READ_USERS = PERMISSION_READ_USERS,
  READ_CUSTOMERS = PERMISSION_READ_CUSTOMERS,
  READ_SETTINGS = PERMISSION_READ_SETTINGS;
var AppRouter = function AppRouter(_ref) {
  var history = _ref.history,
    isAuthenticated = _ref.isAuthenticated,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!isAuthenticated) {
    return /*#__PURE__*/React.createElement(Router, {
      history: history
    }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
      exact: true,
      path: "/reset-password"
    }, /*#__PURE__*/React.createElement(ResetPasswordPageWithState, props)), /*#__PURE__*/React.createElement(Route, {
      exact: true,
      path: "/choose-password"
    }, /*#__PURE__*/React.createElement(ChoosePasswordPageWithState, props)), /*#__PURE__*/React.createElement(Route, {
      path: "/"
    }, /*#__PURE__*/React.createElement(LoginPageWithState, props))));
  }
  return /*#__PURE__*/React.createElement(Router, {
    history: history
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(HasPermissionRoute, {
    exact: true,
    path: ['/', '/orders'],
    type: READ_ORDERS
  }, /*#__PURE__*/React.createElement(OrdersPageWithState, props)), /*#__PURE__*/React.createElement(HasPermissionRoute, {
    exact: true,
    path: "/orders/:id",
    type: READ_ORDERS
  }, /*#__PURE__*/React.createElement(OrderDetailPageWithState, props)), /*#__PURE__*/React.createElement(HasPermissionRoute, {
    exact: true,
    path: "/customers",
    type: READ_CUSTOMERS
  }, /*#__PURE__*/React.createElement(CustomersPageWithState, props)), /*#__PURE__*/React.createElement(HasPermissionRoute, {
    exact: true,
    path: "/customers/:id",
    type: READ_CUSTOMERS
  }, /*#__PURE__*/React.createElement(CustomerDetailPageWithState, props)), /*#__PURE__*/React.createElement(HasPermissionRoute, {
    exact: true,
    path: "/products",
    type: READ_PRODUCTS
  }, /*#__PURE__*/React.createElement(ProductsPageWithState, props)), /*#__PURE__*/React.createElement(HasPermissionRoute, {
    exact: true,
    path: "/products/:slug",
    type: READ_PRODUCTS
  }, /*#__PURE__*/React.createElement(ProductDetailPageWithState$1, props)), /*#__PURE__*/React.createElement(HasPermissionRoute, {
    exact: true,
    path: "/products/:slug/pricing",
    type: READ_PRODUCTS
  }, /*#__PURE__*/React.createElement(ProductDetailPageWithState, props)), /*#__PURE__*/React.createElement(HasPermissionRoute, {
    exact: true,
    path: "/categories",
    type: READ_PRODUCTS
  }, /*#__PURE__*/React.createElement(ProductsCategoriesPageWithState, props)), /*#__PURE__*/React.createElement(HasPermissionRoute, {
    exact: true,
    path: "/settings",
    type: READ_SETTINGS
  }, /*#__PURE__*/React.createElement(SettingsPageWithState, props)), /*#__PURE__*/React.createElement(HasPermissionRoute, {
    exact: true,
    path: "/settings/users",
    type: READ_USERS
  }, /*#__PURE__*/React.createElement(UsersPageWithState, props)), /*#__PURE__*/React.createElement(HasPermissionRoute, {
    exact: true,
    path: "/settings/users/create",
    type: WRITE_USERS
  }, /*#__PURE__*/React.createElement(UsersCreatePageWithState, props)), /*#__PURE__*/React.createElement(HasPermissionRoute, {
    exact: true,
    path: "/settings/users/update/:userId",
    type: WRITE_USERS
  }, /*#__PURE__*/React.createElement(UpdateUserPageWithState, props)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/profile"
  }, /*#__PURE__*/React.createElement(ProfilePageWithState, props)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/reset-password"
  }, /*#__PURE__*/React.createElement(ResetPasswordPageWithState, props)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/choose-password"
  }, /*#__PURE__*/React.createElement(ChoosePasswordPageWithState, props))));
};

var App = function App(_ref) {
  var history = _ref.history,
    isLoading = _ref.isLoading,
    isAuthenticated = _ref.isAuthenticated;
  if (isLoading) {
    return null;
  }
  return /*#__PURE__*/React.createElement(AppRouter, {
    history: history,
    isAuthenticated: isAuthenticated
  });
};

var AppProviders = function AppProviders(_ref) {
  var apolloClient = _ref.apolloClient,
    notificationDispatcher = _ref.notificationDispatcher,
    children = _ref.children,
    locales = _ref.locales;
  return /*#__PURE__*/React.createElement(ApolloProvider, {
    client: apolloClient
  }, /*#__PURE__*/React.createElement(I18nProvider, {
    i18n: locales
  }, /*#__PURE__*/React.createElement(NotificationsProvider, {
    dispatcher: notificationDispatcher
  }, children)));
};

var AppWithState = /*#__PURE__*/function (_React$Component) {
  function AppWithState(props) {
    var _this;
    _classCallCheck(this, AppWithState);
    _this = _callSuper(this, AppWithState, [props]);
    var locales = props.locales,
      _props$history = props.history,
      history = _props$history === void 0 ? createBrowserHistory() : _props$history,
      _props$apolloClient = props.apolloClient,
      apolloClient = _props$apolloClient === void 0 ? createApolloClient() : _props$apolloClient,
      _props$notificationDi = props.notificationDispatcher,
      notificationDispatcher = _props$notificationDi === void 0 ? getNotificationDispatcher() : _props$notificationDi;
    _this.locales = locales;
    _this.history = history;
    _this.apolloClient = apolloClient;
    _this.notificationDispatcher = notificationDispatcher;
    _this.login = _this.login.bind(_this);
    _this.logout = _this.logout.bind(_this);
    _this.state = {
      isLoading: true,
      isAuthenticated: false,
      currentUser: null,
      login: _this.login,
      logout: _this.logout,
      store: null
    };
    return _this;
  }
  _inherits(AppWithState, _React$Component);
  return _createClass(AppWithState, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.checkAuthorizationState();
            case 3:
              _context.next = 5;
              return this.fetchInitialData();
            case 5:
              this.setUserContext();
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              throw new Error(_context.t0.message);
            case 11:
              _context.prev = 11;
              this.setState({
                isLoading: false
              });
              return _context.finish(11);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 8, 11, 14]]);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "checkAuthorizationState",
    value: function () {
      var _checkAuthorizationState = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _yield$loadAndValidat, accessToken, isAuthenticated;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return loadAndValidateTokens();
            case 2:
              _yield$loadAndValidat = _context2.sent;
              accessToken = _yield$loadAndValidat.accessToken;
              isAuthenticated = accessToken !== null;
              this.setState({
                isAuthenticated: isAuthenticated
              });
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function checkAuthorizationState() {
        return _checkAuthorizationState.apply(this, arguments);
      }
      return checkAuthorizationState;
    }()
  }, {
    key: "fetchInitialData",
    value: function () {
      var _fetchInitialData2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var apolloClient, isAuthenticated, _yield$_fetchInitialD, me, store, authState;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              apolloClient = this.apolloClient;
              isAuthenticated = this.state.isAuthenticated;
              if (!isAuthenticated) {
                _context3.next = 13;
                break;
              }
              _context3.next = 5;
              return fetchInitialData(apolloClient);
            case 5:
              _yield$_fetchInitialD = _context3.sent;
              me = _yield$_fetchInitialD.me;
              store = _yield$_fetchInitialD.store;
              authState = me === null ? {
                isAuthenticated: false
              } : {
                currentUser: me
              };
              if (!(me === null)) {
                _context3.next = 12;
                break;
              }
              _context3.next = 12;
              return this.logout();
            case 12:
              this.setState(_objectSpread2({
                store: store
              }, authState));
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchInitialData$1() {
        return _fetchInitialData2.apply(this, arguments);
      }
      return fetchInitialData$1;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(accessToken, refreshToken, currentUser) {
        var history, isAuthenticated;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              history = this.history;
              _context4.next = 3;
              return setAccessToken(accessToken);
            case 3:
              _context4.next = 5;
              return setRefreshToken(refreshToken);
            case 5:
              isAuthenticated = accessToken !== null;
              this.setState({
                isAuthenticated: isAuthenticated,
                currentUser: currentUser
              });
              this.setUserContext();
              history.push('/');
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function login(_x, _x2, _x3) {
        return _login.apply(this, arguments);
      }
      return login;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var apolloClient, history;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              apolloClient = this.apolloClient, history = this.history;
              _context5.next = 3;
              return removeAccessToken();
            case 3:
              _context5.next = 5;
              return removeRefreshToken();
            case 5:
              _context5.next = 7;
              return apolloClient.clearStore();
            case 7:
              this.removeUserContext();
              this.setState({
                isAuthenticated: false
              });
              history.push('/login');
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }, {
    key: "setUserContext",
    value: function setUserContext() {
      var currentUser = this.state.currentUser;
      if (currentUser !== null) {
        this.locales.activate(currentUser.preferredLanguageCode);
      }
    }
  }, {
    key: "removeUserContext",
    value: function removeUserContext() {
      this.locales.activate('en');
    }
  }, {
    key: "render",
    value: function render() {
      var apolloClient = this.apolloClient,
        notificationDispatcher = this.notificationDispatcher,
        history = this.history,
        locales = this.locales;
      var _this$state = this.state,
        isLoading = _this$state.isLoading,
        isAuthenticated = _this$state.isAuthenticated;
      return /*#__PURE__*/React.createElement(AppStateProvider, {
        value: this.state
      }, /*#__PURE__*/React.createElement(AppProviders, {
        apolloClient: apolloClient,
        notificationDispatcher: notificationDispatcher,
        locales: locales
      }, /*#__PURE__*/React.createElement(App, {
        history: history,
        isLoading: isLoading,
        isAuthenticated: isAuthenticated
      }), /*#__PURE__*/React.createElement(ToastMessages, null)));
    }
  }]);
}(React.Component);

var DEFAULT_LANGUAGE = LANGUAGE_EN;
function createLocales() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_LANGUAGE;
  var catalogs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  catalogs.forEach(function (_ref) {
    var code = _ref.code,
      plurals = _ref.plurals,
      messages = _ref.messages.messages;
    i18n.loadLocaleData(code, {
      plurals: plurals
    });
    i18n.load(code, messages);
  });
  i18n.activate(locale);
  return i18n;
}

export { AppWithState, createLocales };
